webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(62);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36b73e2a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(140);
function injectStyle (ssrContext) {
  __webpack_require__(139)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36b73e2a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36b73e2a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompIcon_vue__ = __webpack_require__(58);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05c4b3cc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompIcon_vue__ = __webpack_require__(130);
function injectStyle (ssrContext) {
  __webpack_require__(129)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05c4b3cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05c4b3cc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return RESET_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GET_MYPROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GET_MYPROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GET_MYPROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return UPDATE_MYPROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return UPDATE_MYPROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return UPDATE_MYPROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_MYPASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_MYPASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_MYPASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return UPLOAD_MYAVATAR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return UPLOAD_MYAVATAR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return UPLOAD_MYAVATAR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GET_MYDEALER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GET_MYDEALER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GET_MYDEALER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return REGISTER_MYDEALER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return REGISTER_MYDEALER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return REGISTER_MYDEALER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return UPDATE_MYDEALER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return UPDATE_MYDEALER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return UPDATE_MYDEALER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GET_MYSITES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GET_MYSITES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GET_MYSITES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_IDTOKEN_IPAUTH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GET_IDTOKEN_IPAUTH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_IDTOKEN_IPAUTH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return SEND_PASSWORDRESET_EMAIL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return SEND_PASSWORDRESET_EMAIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return SEND_PASSWORDRESET_EMAIL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SEND_EMAILCHANGE_EMAIL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SEND_EMAILCHANGE_EMAIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SEND_EMAILCHANGE_EMAIL_FAILURE; });
/* unused harmony export OPEN_PROFILE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return INIT_AUTH0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return LOAD_LAST_SESSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return SET_SESSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CLEAR_SESSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return UPDATE_USERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return START_CHECKING_SESSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return STOP_CHECKING_SESSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return HANDLE_AUTHENTICATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return HANDLE_AUTHENTICATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return HANDLE_AUTHENTICATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHECK_SESSION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHECK_SESSION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHECK_SESSION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return MFA_SET_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return MFA_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return MFA_SET_AUTHENTICATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return MFA_SET_PENDING_ENROLLMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return MFA_CLEAR_PENDING_ENROLLMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return MFA_SET_ENROLL_STATUS; });
var RESET_STATE = 'RESET_STATE';

var INIT = 'INIT';

var GET_MYPROFILE_REQUEST = 'GET_MYPROFILE_REQUEST';
var GET_MYPROFILE_SUCCESS = 'GET_MYPROFILE_SUCCESS';
var GET_MYPROFILE_FAILURE = 'GET_MYPROFILE_FAILURE';

var UPDATE_MYPROFILE_REQUEST = 'UPDATE_MYPROFILE_REQUEST';
var UPDATE_MYPROFILE_SUCCESS = 'UPDATE_MYPROFILE_SUCCESS';
var UPDATE_MYPROFILE_FAILURE = 'UPDATE_MYPROFILE_FAILURE';

var CHANGE_MYPASSWORD_REQUEST = 'CHANGE_MYPASSWORD_REQUEST';
var CHANGE_MYPASSWORD_SUCCESS = 'CHANGE_MYPASSWORD_SUCCESS';
var CHANGE_MYPASSWORD_FAILURE = 'CHANGE_MYPASSWORD_FAILURE';

var UPLOAD_MYAVATAR_REQUEST = 'UPLOAD_MYAVATAR_REQUEST';
var UPLOAD_MYAVATAR_SUCCESS = 'UPLOAD_MYAVATAR_SUCCESS';
var UPLOAD_MYAVATAR_FAILURE = 'UPLOAD_MYAVATAR_FAILURE';

var GET_MYDEALER_REQUEST = 'GET_MYDEALER_REQUEST';
var GET_MYDEALER_SUCCESS = 'GET_MYDEALER_SUCCESS';
var GET_MYDEALER_FAILURE = 'GET_MYDEALER_FAILURE';

var REGISTER_MYDEALER_REQUEST = 'REGISTER_MYDEALER_REQUEST';
var REGISTER_MYDEALER_SUCCESS = 'REGISTER_MYDEALER_SUCCESS';
var REGISTER_MYDEALER_FAILURE = 'REGISTER_MYDEALER_FAILURE';

var UPDATE_MYDEALER_REQUEST = 'UPDATE_MYDEALER_REQUEST';
var UPDATE_MYDEALER_SUCCESS = 'UPDATE_MYDEALER_SUCCESS';
var UPDATE_MYDEALER_FAILURE = 'UPDATE_MYDEALER_FAILURE';

var GET_MYSITES_REQUEST = 'GET_MYSITES_REQUEST';
var GET_MYSITES_SUCCESS = 'GET_MYSITES_SUCCESS';
var GET_MYSITES_FAILURE = 'GET_MYSITES_FAILURE';

var GET_IDTOKEN_IPAUTH_REQUEST = 'GET_IDTOKEN_IPAUTH_REQUEST';
var GET_IDTOKEN_IPAUTH_SUCCESS = 'GET_IDTOKEN_IPAUTH_SUCCESS';
var GET_IDTOKEN_IPAUTH_FAILURE = 'GET_IDTOKEN_IPAUTH_FAILURE';

var SEND_PASSWORDRESET_EMAIL_REQUEST = 'SEND_PASSWORDRESET_EMAIL_REQUEST';
var SEND_PASSWORDRESET_EMAIL_SUCCESS = 'SEND_PASSWORDRESET_EMAIL_SUCCESS';
var SEND_PASSWORDRESET_EMAIL_FAILURE = 'SEND_PASSWORDRESET_EMAIL_FAILURE';

var SEND_EMAILCHANGE_EMAIL_REQUEST = 'SEND_EMAILCHANGE_EMAIL_REQUEST';
var SEND_EMAILCHANGE_EMAIL_SUCCESS = 'SEND_EMAILCHANGE_EMAIL_SUCCESS';
var SEND_EMAILCHANGE_EMAIL_FAILURE = 'SEND_EMAILCHANGE_EMAIL_FAILURE';

var OPEN_PROFILE = 'OPEN_PROFILE';

var INIT_AUTH0 = 'INIT_AUTH0';
var LOAD_LAST_SESSION = 'LOAD_LAST_SESSION';
var SET_SESSION = 'SET_SESSION';
var CLEAR_SESSION = 'CLEAR_SESSION';
var UPDATE_USERINFO = 'UPDATE_USERINFO';

var START_CHECKING_SESSION = 'START_CHECKING_SESSION';
var STOP_CHECKING_SESSION = 'STOP_CHECKING_SESSION';

var HANDLE_AUTHENTICATION_REQUEST = 'HANDLE_AUTHENTICATION_REQUEST';
var HANDLE_AUTHENTICATION_SUCCESS = 'HANDLE_AUTHENTICATION_SUCCESS';
var HANDLE_AUTHENTICATION_FAILURE = 'HANDLE_AUTHENTICATION_FAILURE';

var CHECK_SESSION_REQUEST = 'CHECK_SESSION_REQUEST';
var CHECK_SESSION_SUCCESS = 'CHECK_SESSION_SUCCESS';
var CHECK_SESSION_FAILURE = 'CHECK_SESSION_FAILURE';

var MFA_SET_TOKEN = 'MFA_SET_TOKEN';
var MFA_CLEAR = 'MFA_CLEAR';
var MFA_SET_AUTHENTICATORS = 'MFA_SET_AUTHENTICATORS';
var MFA_SET_PENDING_ENROLLMENT = 'MFA_SET_PENDING_ENROLLMENT';
var MFA_CLEAR_PENDING_ENROLLMENT = 'MFA_CLEAR_PENDING_ENROLLMENT';
var MFA_SET_ENROLL_STATUS = 'MFA_SET_ENROLL_STATUS';

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompAppIcon_vue__ = __webpack_require__(85);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2aa7afb4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompAppIcon_vue__ = __webpack_require__(206);
function injectStyle (ssrContext) {
  __webpack_require__(205)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2aa7afb4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompAppIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2aa7afb4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompAppIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_MyAuth__ = __webpack_require__(115);
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    MyAuth: __WEBPACK_IMPORTED_MODULE_0__pages_MyAuth__["a" /* default */]
  },
  created: function created() {
    this.$auth.removeTokensFromLegacyLocation(); // TODO - remove this at 2019-03-01
    if (!this.$route.query['ip_auth_dealer']) {
      this.$store.commit('LOAD_LAST_SESSION'); // set id_token in auth service before "Set Session" takes its place.
    }
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-auth',
  computed: {
    statusHandleAuthentication: function statusHandleAuthentication() {
      return this.$store.getters.statusHandleAuthentication;
    },
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    idTokenExpiresAt: function idTokenExpiresAt() {
      return this.$store.getters.idTokenExpiresAt;
    },
    idTokenProvider: function idTokenProvider(state) {
      return this.$store.getters.idTokenProvider;
    },
    idTokenIPAuthDealerID: function idTokenIPAuthDealerID(state) {
      return this.$store.getters.idTokenIPAuthDealerID;
    },
    statusCheckSession: function statusCheckSession() {
      return this.$store.getters.statusCheckSession;
    }
  },
  data: function data() {
    return {
      request: {},
      isTokenRefreshedMoreThanOnce: false,
      refreshingToken$t: null,
      checkingAuthStatus$i: null
    };
  },
  watch: {
    statusCheckSession: function statusCheckSession(now) {
      if (now === 'successful') {
        this.onRefreshTokenSuccess();
      }
    },
    statusHandleAuthentication: function statusHandleAuthentication(now) {
      // if (now === 'successful' || now === 'failed') {
      // when it is failed, it should show ERROR page without proceeding any step further
      if (now === 'successful') {
        if (this.$router.currentRoute.name === 'Callback') {
          this.$logger.info('statusHandleAuthentication: Callback: Authenticated action');
          this.proceedRouting();
          this.initRefreshingTokenTimeout();
        }
      }
    }
  },
  created: function created() {
    var _this = this;

    this.request = this.$param.options;
    this.$param.checkCHeKTParams().then(function (paramReplaced) {
      // do nothing because it will reload the page and need to wait... because of async calls.
    }, function (noParamToReplace) {
      if (_this.$router.currentRoute.name === 'Callback') {
        // If it is Callback... Don't refresh token, because it has already got it by parsing hash query
        // initRefreshingTokenTimeout will occurs when statusHandleAuthentication === 'successful'
      } else {
        _this.init();
      }
    });
  },
  methods: {
    init: function init() {
      // SPEC
      // 1. IP authentication can co-exist with user auth session
      // 2. IP authentication doesn't store its session in cookie (volatile)
      // INFO
      this.$logger.info('MyAuth: Has existing USER auth session');
      // [IP authentication]
      if (this.$route.query['ip_auth_dealer']) {
        this.$logger.info('MyAuth: IP authentication');
        this.refreshToken();
        // [User authentication]
      } else {
        this.$logger.info('MyAuth: User authentication');
        this.refreshToken();
      }
    },
    proceedRouting: function proceedRouting() {
      if ('request' in this.request) {
        if (this.request['request'] === 'dealer_registration') {
          this.$router.push({ name: 'DealerTools', query: this.$route.query });
          return;
        } else if (this.request['request'] === 'dealer_member_invitation') {
          this.$router.push({ name: 'DealerTools', query: this.$route.query });
          return;
        } else if (this.request['request'] === 'site_member_invitation') {
          this.$router.push({ name: 'CustomerTools', query: this.$route.query });
          return;
        }
      }

      if (this.request['continue']) {
        this.$tool.redirectToUrl(this.request['continue']);
        return;
      }

      if (this.$router.currentRoute.name === 'Loading' || this.$router.currentRoute.name === 'Login' || this.$router.currentRoute.name === 'Logout' || this.$router.currentRoute.name === 'Callback' || this.$router.currentRoute.name === null) {
        this.$router.push({ name: 'Profile', query: this.$route.query });
      }
    },
    onLoginSuccess: function onLoginSuccess() {
      this.proceedRouting();
    },
    onRefreshTokenSuccess: function onRefreshTokenSuccess() {
      this.proceedRouting();
    },
    onCheckSessionError: function onCheckSessionError(err) {
      var errMessage = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err);
      if (err.error === 'login_required') {
        if (this.isTokenRefreshedMoreThanOnce) {
          alert('Login required: Login session timeout.');
        }
        this.login();
      } else {
        this.$logger.error(errMessage);
        if (this.$route.query['ip_auth_dealer']) {
          alert(errMessage);
        } else {
          alert(errMessage);
        }
        if (confirm('Do you want to try login again?')) {
          this.login();
        } else {
          // do nothing
        }
      }
    },
    checkSession: function checkSession() {
      var dealerID = null;
      if (this.$route.query['ip_auth_dealer']) {
        dealerID = this.$route.query['ip_auth_dealer'];
      }
      // IP authentication - Treat this as infinite session
      if (dealerID) {
        return this.$store.dispatch('getIDTokenIPAuth', { dealerID: dealerID });
        // Username/Password authentication
      } else {
        return this.$store.dispatch('checkSession');
      }
    },
    refreshToken: function refreshToken() {
      var _this2 = this;

      this.checkSession().then(function (success) {
        _this2.$logger.info('refreshToken: Authenticated user');
        _this2.isTokenRefreshedMoreThanOnce = true;
        _this2.proceedRouting();
        _this2.initRefreshingTokenTimeout();
      }, function (err) {
        _this2.$logger.info('refreshToken: Not authenticated user: ' + err.error);
        _this2.onCheckSessionError(err);
      });
    },
    initRefreshingTokenTimeout: function initRefreshingTokenTimeout() {
      var _this3 = this;

      this.cancelRefreshingTokenTimeout();
      var timeoutAfter = 0;
      if (this.idTokenExpiresAt) {
        timeoutAfter = this.idTokenExpiresAt - new Date().getTime() - 1 * 60 * 1000; // 1 min before expiration
      }
      this.$logger.info('initRefreshingTokenTimeout: Refreshing id token after {timeLeft} minutes.'.replace('{timeLeft}', '' + Math.round(timeoutAfter / 60000 + 0.5)));
      this.refreshingToken$t = setTimeout(function () {
        _this3.$logger.info('initRefreshingTokenTimeout: id token will be refreshed');
        _this3.checkSession().then(function (success) {
          _this3.$logger.info('initRefreshingTokenTimeout: Authenticated user');
          _this3.initRefreshingTokenTimeout();
        }, function (err) {
          _this3.$logger.info('initRefreshingTokenTimeout: Not authenticated user: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err));
          _this3.onCheckSessionError(err);
        });
      }, timeoutAfter);
      // startCheckingAuthStatus is used for when the computer wakes up after sleeping
      // it is a backing up feature for initRefreshingTokenTimeout
      // because initRefreshingTokenTimeout doens't work after sleeping
      setTimeout(function () {
        _this3.startCheckingAuthStatus();
      }, 1000);
    },
    cancelRefreshingTokenTimeout: function cancelRefreshingTokenTimeout() {
      if (this.refreshingToken$t) {
        this.$logger.info('cancelRefreshingTokenTimeout: Canceling the previous timeout request');
        clearTimeout(this.refreshingToken$t);
      }
    },
    startCheckingAuthStatus: function startCheckingAuthStatus() {
      var _this4 = this;

      var checkingInterval = 1000 * 10;
      this.stopCheckingAuthStatus();
      this.$logger.info('startCheckingAuthStatus');
      this.checkingAuthStatus$i = setInterval(function () {
        if (!_this4.isAuthenticated()) {
          _this4.$logger.info('Check authenticated: No valid id_token!');
          _this4.refreshToken();
          _this4.stopCheckingAuthStatus();
        }
      }, checkingInterval);
    },
    stopCheckingAuthStatus: function stopCheckingAuthStatus() {
      this.$logger.info('stopCheckingAuthStatus');
      if (this.checkingAuthStatus$i) {
        clearInterval(this.checkingAuthStatus$i);
        this.checkingAuthStatus$i = null;
      }
    },
    login: function login() {
      if (this.$route.query['ip_auth_dealer']) {
        this.$tool.redirectToUrl(window.location.origin + window.location.search);
      } else {
        this.$store.dispatch('login');
      }
    },
    logout: function logout() {
      this.$store.dispatch('logout');
    }
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CompIcon__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Account_Navi__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Account_Notifications__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modal_ModalChangeName__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Modal_ModalChangeIpUserName__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Modal_ModalChangePassword__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Modal_ModalChangeEmail__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Modal_ModalEmailChanged__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Modal_ModalChangePhoto__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Modal_ModalDealerRegistration__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Modal_ModalOpenDealerPortal__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Modal_ModalOpenEnduserApp__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Modal_ModalLogout__ = __webpack_require__(190);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'account',
  components: {
    CompIcon: __WEBPACK_IMPORTED_MODULE_1__components_CompIcon__["a" /* default */],
    Navi: __WEBPACK_IMPORTED_MODULE_2__pages_Account_Navi__["a" /* default */],
    Notifications: __WEBPACK_IMPORTED_MODULE_3__pages_Account_Notifications__["a" /* default */],
    ModalChangeName: __WEBPACK_IMPORTED_MODULE_4__components_Modal_ModalChangeName__["a" /* default */],
    ModalChangeIpUserName: __WEBPACK_IMPORTED_MODULE_5__components_Modal_ModalChangeIpUserName__["a" /* default */],
    ModalChangePassword: __WEBPACK_IMPORTED_MODULE_6__components_Modal_ModalChangePassword__["a" /* default */],
    ModalChangeEmail: __WEBPACK_IMPORTED_MODULE_7__components_Modal_ModalChangeEmail__["a" /* default */],
    ModalEmailChanged: __WEBPACK_IMPORTED_MODULE_8__components_Modal_ModalEmailChanged__["a" /* default */],
    ModalChangePhoto: __WEBPACK_IMPORTED_MODULE_9__components_Modal_ModalChangePhoto__["a" /* default */],
    ModalDealerRegistration: __WEBPACK_IMPORTED_MODULE_10__components_Modal_ModalDealerRegistration__["a" /* default */],
    ModalOpenDealerPortal: __WEBPACK_IMPORTED_MODULE_11__components_Modal_ModalOpenDealerPortal__["a" /* default */],
    ModalOpenEnduserApp: __WEBPACK_IMPORTED_MODULE_12__components_Modal_ModalOpenEnduserApp__["a" /* default */],
    ModalLogout: __WEBPACK_IMPORTED_MODULE_13__components_Modal_ModalLogout__["a" /* default */]
  },
  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    statusCheckSession: function statusCheckSession() {
      return this.$store.getters.statusCheckSession;
    },
    myDealerHasPendingRegistration: function myDealerHasPendingRegistration() {
      return this.$store.getters.myDealerHasPendingRegistration;
    },
    iAmOwnerOfMyDealer: function iAmOwnerOfMyDealer() {
      return this.$store.getters.iAmOwnerOfMyDealer;
    },
    isToResetPassword: function isToResetPassword() {
      return this.$store.getters.isToResetPasswordAuth0 && this.$store.getters.accountCreatedDate > this.$store.getters.newAccountLogicBeginDate;
    },
    myEmail: function myEmail() {
      return this.$store.getters.myEmail;
    }
  },
  data: function data() {
    return {
      isMenuOpen: true,
      modals: {
        changeName: {
          isVisible: false
        },
        changeIPUserName: {
          isVisible: false
        },
        changePassword: {
          isVisible: false
        },
        changeEmail: {
          isVisible: false
        },
        emailChanged: {
          isVisible: false
        },
        changePhoto: {
          isVisible: false
        },
        dealerRegistration: {
          isVisible: false
        },
        logout: {
          isVisible: false
        },
        openDealerPortal: {
          isVisible: false
        },
        openEnduserApp: {
          isVisible: false
        }
      },
      request: {}
    };
  },
  watch: {
    myDealerHasPendingRegistration: function myDealerHasPendingRegistration() {
      this.openAppropriateModals();
    },
    iAmOwnerOfMyDealer: function iAmOwnerOfMyDealer() {
      this.openAppropriateModals();
    },
    isToResetPassword: function isToResetPassword() {
      this.openAppropriateModals();
    },
    myEmail: function myEmail() {
      this.openAppropriateModals();
    },
    statusCheckSession: function statusCheckSession(status) {
      if (status === 'successful') {
        this.checkAuthStatus();
      } else if (status === 'failed') {
        // do nothing here
        // it is handled in MyAuth.vue (redirecting to login page auth.chekt.com)
      }
    }
  },
  created: function created() {
    this.initRequest();
    this.initResizeListener();
    this.checkAuthStatus();
    this.openAppropriateModals();
  },
  beforeDestroy: function beforeDestroy() {
    this.removeResizeListener();
  },
  methods: {
    initResizeListener: function initResizeListener() {
      this.onResize();
      window.addEventListener('resize', this.onResize);
    },
    removeResizeListener: function removeResizeListener() {
      window.removeEventListener('resize', this.onResize);
    },
    openAppropriateModals: function openAppropriateModals() {
      this.openEmailChangedModal();
      if (this.myDealerHasPendingRegistration && this.iAmOwnerOfMyDealer) {
        this.openDealerRegistrationModal();
      }
      if (this.isToResetPassword) {
        this.openChangePasswordModal();
      }
      if (this.myEmail) {
        if ('email' in this.request) {
          if (this.myEmail !== this.request['email']) {
            this.closeAllModal();
            this.openLogoutModal();
          } else {
            this.closeLogoutModal();
            if ('request' in this.request) {
              if (this.request['request'] === 'dealer_registration') {
                this.openOpenDealerPortalModal();
              } else if (this.request['request'] === 'dealer_member_invitation') {
                this.openOpenDealerPortalModal();
              } else if (this.request['request'] === 'site_member_invitation') {
                this.openOpenEnduserAppModal();
              }
            }
          }
        }
        // only when account email is changed
        if ('oldEmail' in this.request) {
          if (this.request['oldEmail']) {
            if (this.request['request'] === 'email_change') {
              this.openEmailChangedModal();
            } else if (this.request['request'] === 'email_change_revoke') {
              this.openEmailChangedModal();
            }
          }
        }
      }
    },
    onResize: function onResize() {
      if (window.innerWidth > 600) {
        this.openMenu();
      } else {
        this.closeMenu();
      }
    },
    checkAuthStatus: function checkAuthStatus() {
      if (this.isAuthenticated()) {
        this.onAuthenticatedUser();
      } else {
        this.onNotAuthenticatedUser();
      }
    },
    onAuthenticatedUser: function onAuthenticatedUser() {
      var _this = this;

      this.getMyProfile().then(function (success) {
        _this.getMyDealer().then(function (success) {}, function (failure) {
          _this.$logger.debug('No my dealer');
        });
        _this.getMySites().then(function (success) {}, function (failure) {
          _this.$logger.debug('No my sites');
        });
      });
    },
    onNotAuthenticatedUser: function onNotAuthenticatedUser() {
      this.$router.push({ name: 'Login', query: this.$route.query });
    },
    toggleMenu: function toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    openMenu: function openMenu() {
      this.isMenuOpen = true;
    },
    closeMenu: function closeMenu() {
      this.isMenuOpen = false;
    },
    onClickMenu: function onClickMenu() {
      this.onResize();
      this.closeAllModal();
    },
    closeAllModal: function closeAllModal() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.modals).map(function (modalName) {
        _this2.modals[modalName].isVisible = false;
      });
    },
    openChangePhotoModal: function openChangePhotoModal() {
      this.modals.changePhoto.isVisible = true;
    },
    closeChangePhotoModal: function closeChangePhotoModal() {
      this.modals.changePhoto.isVisible = false;
    },
    openChangeNameModal: function openChangeNameModal() {
      this.modals.changeName.isVisible = true;
    },
    closeChangeNameModal: function closeChangeNameModal() {
      this.modals.changeName.isVisible = false;
    },
    openChangeIPUserNameModal: function openChangeIPUserNameModal() {
      this.modals.changeIPUserName.isVisible = true;
    },
    closeChangeIPUserNameModal: function closeChangeIPUserNameModal() {
      this.modals.changeIPUserName.isVisible = false;
    },
    openChangePasswordModal: function openChangePasswordModal() {
      this.modals.changePassword.isVisible = true;
    },
    closeChangePasswordModal: function closeChangePasswordModal() {
      this.modals.changePassword.isVisible = false;
    },
    openChangeEmailModal: function openChangeEmailModal() {
      this.modals.changeEmail.isVisible = true;
    },
    closeChangeEmailModal: function closeChangeEmailModal() {
      this.modals.changeEmail.isVisible = false;
    },
    openEmailChangedModal: function openEmailChangedModal() {
      this.modals.emailChanged.isVisible = true;
    },
    closeEmailChangedModal: function closeEmailChangedModal() {
      this.modals.emailChanged.isVisible = false;
    },
    openLogoutModal: function openLogoutModal() {
      this.modals.logout.isVisible = true;
    },
    closeLogoutModal: function closeLogoutModal() {
      this.modals.logout.isVisible = false;
    },
    openDealerRegistrationModal: function openDealerRegistrationModal() {
      this.modals.dealerRegistration.isVisible = true;
    },
    closeDealerRegistrationModal: function closeDealerRegistrationModal() {
      this.modals.dealerRegistration.isVisible = false;
    },
    openOpenDealerPortalModal: function openOpenDealerPortalModal() {
      this.modals.openDealerPortal.isVisible = true;
    },
    closeOpenDealerPortalModal: function closeOpenDealerPortalModal() {
      this.modals.openDealerPortal.isVisible = false;
    },
    openOpenEnduserAppModal: function openOpenEnduserAppModal() {
      this.modals.openEnduserApp.isVisible = true;
    },
    closeOpenEnduserAppModal: function closeOpenEnduserAppModal() {
      this.modals.openEnduserApp.isVisible = false;
    },
    getMyProfile: function getMyProfile() {
      return this.$store.dispatch('getMyProfile');
    },
    getMyDealer: function getMyDealer() {
      return this.$store.dispatch('getMyDealer');
    },
    getMySites: function getMySites() {
      return this.$store.dispatch('getMySites');
    },
    initRequest: function initRequest() {
      this.request = this.$param.options;
    }
  }
});

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'comp-icon',
  props: {
    icon: {
      type: String,
      default: function _default() {
        return null;
      }
    },
    width: {
      type: Number,
      default: function _default() {
        return 40;
      }
    },
    widthInCustomMetric: {
      type: String,
      default: function _default() {
        return null;
      }
    },
    color: {
      type: String,
      default: function _default() {
        return null;
      }
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CompIcon__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navi',
  components: {
    CompIcon: __WEBPACK_IMPORTED_MODULE_0__components_CompIcon__["a" /* default */]
  },
  computed: {
    myProfilePictureUrl: function myProfilePictureUrl() {
      return this.$store.getters.myProfilePictureUrl;
    },
    myName: function myName() {
      return this.$store.getters.myFirstName ? this.$store.getters.myFirstName + ' ' + this.$store.getters.myLastName : '';
    },
    isCHeKTAdmin: function isCHeKTAdmin() {
      return this.$store.getters.isCHeKTAdmin;
    },
    hasMyDealer: function hasMyDealer() {
      return this.$store.getters.hasMyDealer;
    },
    hasMySites: function hasMySites() {
      return this.$store.getters.hasMySites;
    },
    hasMyDevices: function hasMyDevices() {
      return this.$store.getters.hasMyDevices;
    },
    hasMyAccessHistory: function hasMyAccessHistory() {
      return this.$store.getters.hasMyAccessHistory;
    },
    myDealerHasPendingRegistration: function myDealerHasPendingRegistration() {
      return this.$store.getters.myDealerHasPendingRegistration;
    },
    iAmOwnerOfMyDealer: function iAmOwnerOfMyDealer() {
      return this.$store.getters.iAmOwnerOfMyDealer;
    },
    isToResetPassword: function isToResetPassword() {
      return this.$store.getters.isToResetPasswordAuth0 && this.$store.getters.accountCreatedDate > this.$store.getters.newAccountLogicBeginDate;
    },
    isIPAuth: function isIPAuth(state) {
      return !!this.$store.getters.idTokenIPAuthDealerID;
    }
  },
  methods: {
    goTo: function goTo(routeName) {
      this.$router.push({ name: routeName, query: this.$route.query });
      this.$forceUpdate();
      this.$emit('onClickMenu', null);
    },
    onClickLogout: function onClickLogout() {
      this.$emit('onClickLogout', null);
    },
    onClickDealerRegistration: function onClickDealerRegistration() {
      this.$emit('onClickDealerRegistration', null);
    },
    onClickChangePassword: function onClickChangePassword() {
      this.$emit('onClickChangePassword', null);
    },
    getCurrentRouteName: function getCurrentRouteName() {
      return this.$router.currentRoute.name;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notifications',
  computed: {
    statusGetMyDealer: function statusGetMyDealer() {
      return this.$store.getters.statusGetMyDealer;
    },
    statusGetMyProfile: function statusGetMyProfile() {
      return this.$store.getters.statusGetMyProfile;
    },
    statusUpdateMyProfile: function statusUpdateMyProfile() {
      return this.$store.getters.statusUpdateMyProfile;
    },
    statusChangeMyPassword: function statusChangeMyPassword() {
      return this.$store.getters.statusChangeMyPassword;
    },
    statusUploadMyAvatar: function statusUploadMyAvatar() {
      return this.$store.getters.statusUploadMyAvatar;
    },
    statusRegisterMyDealer: function statusRegisterMyDealer() {
      return this.$store.getters.statusRegisterMyDealer;
    },
    statusMfaEnroll: function statusMfaEnroll() {
      return this.$store.getters.statusMfaEnroll;
    }
  },
  data: function data() {
    return {
      toasterItems: {},
      successTimeout: 1000 * 3,
      infoTimeout: 1000 * 60 * 5,
      warningTimeout: 1000 * 20,
      errorTimeout: 1000 * 60 * 5
    };
  },
  watch: {
    statusGetMyDealer: function statusGetMyDealer(status) {
      if (status === 'successful') {
        this.addNewToaster('success', 'My dealer is loaded', null, 'statusGetMyDealer');
      }
      // } else if (status === 'requested') {
      //   this.addNewToaster('info', 'Loading my dealer', null, 'statusGetMyDealer')
      // } else if (status === 'failed') {
      //   this.addNewToaster('warning', 'Loading my dealer failed', null, 'statusGetMyDealer')
      // }
    },
    statusGetMyProfile: function statusGetMyProfile(status) {
      if (status === 'requested') {
        this.addNewToaster('info', 'Loading my profile', null, 'statusGetMyProfile');
      } else if (status === 'successful') {
        this.addNewToaster('success', 'My profile is loaded', null, 'statusGetMyProfile');
      } else if (status === 'failed') {
        this.addNewToaster('warning', 'Loading my profile failed', null, 'statusGetMyProfile');
      }
    },
    statusUpdateMyProfile: function statusUpdateMyProfile(status) {
      if (status === 'requested') {
        this.addNewToaster('info', 'Updating my profile', null, 'statusUpdateMyProfile');
      } else if (status === 'successful') {
        this.addNewToaster('success', 'My profile is updated', null, 'statusUpdateMyProfile');
      } else if (status === 'failed') {
        this.addNewToaster('warning', 'Updating my profile failed', null, 'statusUpdateMyProfile');
      }
    },
    statusChangeMyPassword: function statusChangeMyPassword(status) {
      if (status === 'requested') {
        this.addNewToaster('info', 'Changing my password', null, 'statusChangeMyPassword');
      } else if (status === 'successful') {
        this.addNewToaster('success', 'My password is changed', null, 'statusChangeMyPassword');
      } else if (status === 'failed') {
        this.addNewToaster('warning', 'Changing my password failed', null, 'statusChangeMyPassword');
      }
    },
    statusUploadMyAvatar: function statusUploadMyAvatar(status) {
      if (status === 'requested') {
        this.addNewToaster('info', 'Uploading my picture', null, 'statusUploadMyAvatar');
      } else if (status === 'successful') {
        this.addNewToaster('success', 'My picture is uploaded', null, 'statusUploadMyAvatar');
      } else if (status === 'failed') {
        this.addNewToaster('warning', 'Uploading my picture failed', null, 'statusUploadMyAvatar');
      }
    },
    statusRegisterMyDealer: function statusRegisterMyDealer(status) {
      if (status === 'requested') {
        this.addNewToaster('info', 'Registering my dealer', null, 'statusRegisterMyDealer');
      } else if (status === 'successful') {
        this.addNewToaster('success', 'My dealer is registered', null, 'statusRegisterMyDealer');
      } else if (status === 'failed') {
        this.addNewToaster('warning', 'Registering my dealer failed', null, 'statusRegisterMyDealer');
      }
    },
    statusMfaEnroll: function statusMfaEnroll(status) {
      if (status === 'successful') {
        this.addNewToaster('success', 'Authenticator app registered', null, 'statusMfaEnroll');
      }
    }
  },
  methods: {
    addNewToaster: function addNewToaster(status, message, action, key) {
      var _this = this;

      if (key in this.toasterItems) {
        if (this.toasterItems[key].hide$t) {
          clearTimeout(this.toasterItems[key].hide$t);
          this.toasterItems[key].hide$t = null;
        }
      }
      this.$set(this.toasterItems, key, {
        status: status,
        message: message,
        action: action,
        hide$t: null
      });
      var timeout = status === 'success' ? this.successTimeout : status === 'info' ? this.infoTimeout : status === 'warning' ? this.warningTimeout : status === 'error' ? this.errorTimeout : null;
      this.toasterItems[key].hide$t = setTimeout(function () {
        _this.hideToaster(key);
      }, timeout);
    },
    onClickToaster: function onClickToaster(key) {
      if (this.toasterItems[key].action) {
        this.toasterItems[key].action();
      }
      this.hideToaster(key);
    },
    hideToaster: function hideToaster(key) {
      this.$delete(this.toasterItems, key);
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-change-name',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__components_Modal__["a" /* default */]
  },
  computed: {
    myFirstName: function myFirstName() {
      return this.$store.getters.myFirstName;
    },
    myLastName: function myLastName() {
      return this.$store.getters.myLastName;
    }
  },
  data: function data() {
    return {
      firstName: null,
      lastName: null
    };
  },
  created: function created() {
    this.initInputs();
    this.setInputFocused();
  },
  methods: {
    closeModalRequest: function closeModalRequest() {
      var _this = this;

      var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.$emit('closeModalRequest');
      if (reload) setTimeout(function () {
        _this.getMyProfile();
      }, 1000);
    },
    onClickSubmit: function onClickSubmit(e) {
      var _this2 = this;

      e.preventDefault();
      this.updateMyProfile().then(function (success) {
        _this2.closeModalRequest(true);
      }, function (failure) {
        _this2.closeModalRequest(true);
      });
    },
    setInputFocused: function setInputFocused() {
      var _this3 = this;

      this.$nextTick(function () {
        if (_this3.$refs['first-name']) {
          _this3.$refs['first-name'].focus();
        } else {
          setTimeout(function () {
            if (_this3.$refs['first-name']) {
              _this3.$refs['first-name'].focus();
            }
          }, 1000);
        }
      });
    },
    initInputs: function initInputs() {
      this.firstName = this.myFirstName;
      this.lastName = this.myLastName;
    },
    getMyProfile: function getMyProfile() {
      return this.$store.dispatch('getMyProfile');
    },
    updateMyProfile: function updateMyProfile() {
      var firstName = this.firstName;
      var lastName = this.lastName;
      return this.$store.dispatch('updateMyProfile', { firstName: firstName, lastName: lastName });
    }
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'comp-modal',
  methods: {
    onClickBackground: function onClickBackground() {
      this.closeModalRequest();
    },
    closeModalRequest: function closeModalRequest() {
      this.$emit('closeModalRequest');
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-change-ip-user-name',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__components_Modal__["a" /* default */]
  },
  computed: {
    myFirstName: function myFirstName() {
      return this.$store.getters.myFirstName;
    }
  },
  data: function data() {
    return {
      firstName: null
    };
  },
  created: function created() {
    this.initInputs();
    this.setInputFocused();
  },
  methods: {
    closeModalRequest: function closeModalRequest() {
      var _this = this;

      this.$emit('closeModalRequest');
      setTimeout(function () {
        _this.getMyProfile();
      }, 1000);
    },
    onClickSubmit: function onClickSubmit(e) {
      var _this2 = this;

      e.preventDefault();
      this.updateMyProfile().then(function (success) {
        _this2.closeModalRequest();
      }, function (failure) {
        _this2.closeModalRequest();
      });
    },
    setInputFocused: function setInputFocused() {
      var _this3 = this;

      this.$nextTick(function () {
        if (_this3.$refs['first-name']) {
          _this3.$refs['first-name'].focus();
        } else {
          setTimeout(function () {
            if (_this3.$refs['first-name']) {
              _this3.$refs['first-name'].focus();
            }
          }, 1000);
        }
      });
    },
    initInputs: function initInputs() {
      this.firstName = this.myFirstName;
    },
    getMyProfile: function getMyProfile() {
      return this.$store.dispatch('getMyProfile');
    },
    updateMyProfile: function updateMyProfile() {
      var firstName = this.firstName;
      var lastName = null;
      return this.$store.dispatch('updateMyProfile', { firstName: firstName, lastName: lastName });
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-change-password',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__components_Modal__["a" /* default */]
  },
  computed: {
    isToResetPassword: function isToResetPassword() {
      return this.$store.getters.isToResetPasswordAuth0 && this.$store.getters.accountCreatedDate > this.$store.getters.newAccountLogicBeginDate;
    },
    lastPasswordReset: function lastPasswordReset() {
      return new Date(this.$store.getters.lastPasswordReset).toString();
    },
    statusSendPasswordResetEmail: function statusSendPasswordResetEmail() {
      return this.$store.getters.statusSendPasswordResetEmail;
    }
  },
  data: function data() {
    return {
      message: null,
      isSuccess: true
    };
  },
  created: function created() {
    this.getUserInfo();
  },
  beforeDestroy: function beforeDestroy() {
    this.getUserInfo();
  },
  methods: {
    closeModalRequest: function closeModalRequest() {
      this.$emit('closeModalRequest');
    },
    onClickSubmit: function onClickSubmit(e) {
      var _this = this;

      e.preventDefault();
      if (this.statusSendPasswordResetEmail === 'requested') {
        this.$logger.warn('Still in requesting to send the password reset email.');
      } else {
        this.message = null;
        this.isSuccess = true;
        this.changePassword().then(function (resp) {
          _this.message = resp;
          _this.isSuccess = true;
          // setTimeout(() => { this.closeModalRequest() }, 5000)
        }, function (err) {
          _this.message = err.statusText + ': ' + err.description;
          _this.isSuccess = false;
        });
      }
    },
    changePassword: function changePassword() {
      return this.$store.dispatch('changePassword');
    },
    getUserInfo: function getUserInfo() {
      return this.$store.dispatch('getUserInfo');
    }
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-change-email',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__components_Modal__["a" /* default */]
  },
  computed: {
    myEmail: function myEmail() {
      return this.$store.getters.myEmail;
    },
    statusSendEmailChangeEmail: function statusSendEmailChangeEmail() {
      return this.$store.getters.statusSendEmailChangeEmail;
    }
  },
  data: function data() {
    return {
      newEmail: null,
      message: null,
      isSuccess: true
    };
  },
  created: function created() {
    this.setInputFocused();
  },
  methods: {
    closeModalRequest: function closeModalRequest() {
      var _this = this;

      var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.$emit('closeModalRequest');
      if (reload) setTimeout(function () {
        _this.getMyProfile();
      }, 1000);
    },
    onClickSubmit: function onClickSubmit(e) {
      var _this2 = this;

      e.preventDefault();
      if (this.statusSendEmailChangeEmail === 'requested') {
        this.$logger.warn('Still in requesting to send the email change email.');
      } else {
        this.message = null;
        this.isSuccess = true;
        this.changeMyEmail().then(function (resp) {
          _this2.message = 'We\'ve just sent you an email to your new email address(' + _this2.newEmail + ') to confirm your request.';
          _this2.isSuccess = true;
          // this.closeModalRequest()
        }, function (err) {
          _this2.message = err.message;
          _this2.isSuccess = false;
          // this.closeModalRequest()
        });
      }
    },
    setInputFocused: function setInputFocused() {
      var _this3 = this;

      this.$nextTick(function () {
        if (_this3.$refs['new-email']) {
          _this3.$refs['new-email'].focus();
        } else {
          setTimeout(function () {
            if (_this3.$refs['new-email']) {
              _this3.$refs['new-email'].focus();
            }
          }, 1000);
        }
      });
    },
    getMyProfile: function getMyProfile() {
      return this.$store.dispatch('getMyProfile');
    },
    changeMyEmail: function changeMyEmail() {
      var email = this.newEmail;
      return this.$store.dispatch('changeMyEmail', { email: email });
    }
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-email-changed',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__components_Modal__["a" /* default */]
  },
  computed: {
    myEmail: function myEmail() {
      return this.$store.getters.myEmail;
    }
  },
  data: function data() {
    return {
      oldEmail: null
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      this.oldEmail = this.$param.options['oldEmail'];
      if (!this.oldEmail) this.closeModalRequestWithoutRemovingQuery();
    },
    closeModalRequestWithoutRemovingQuery: function closeModalRequestWithoutRemovingQuery() {
      this.$emit('closeModalRequest');
    },
    closeModalRequest: function closeModalRequest() {
      this.$emit('closeModalRequest');
      this.goToProfile();
    },
    onClickSubmit: function onClickSubmit(e) {
      e.preventDefault();
      this.closeModalRequest();
    },
    goToProfile: function goToProfile() {
      this.$router.push({ name: 'Profile' });
    }
  }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-change-photo',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__components_Modal__["a" /* default */]
  },
  computed: {
    myProfilePictureUrl: function myProfilePictureUrl() {
      return this.$store.getters.myProfilePictureUrl;
    }
  },
  data: function data() {
    return {
      selectedTab: 'uploadPhoto',
      tabs: ['uploadPhoto', 'takePhoto'],
      camera: null,
      newSnapshotURL: null,
      newSnapshotURLFromCamera: null,
      imageFile: {
        blobData: null,
        contentType: null
      },
      imageFileFromCamera: {
        blobData: null,
        contentType: null
      }
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.stopJpegCamera();
    this.removeSnapshot();
  },
  methods: {
    closeModalRequest: function closeModalRequest() {
      var _this = this;

      var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.$emit('closeModalRequest');
      if (reload) setTimeout(function () {
        _this.getMyProfile();
      }, 1000);
    },
    onClickSubmit: function onClickSubmit(e) {
      var _this2 = this;

      e.preventDefault();
      var blobData = this.imageFile.blobData;
      var contentType = this.imageFile.contentType;
      if (blobData && contentType) {
        this.uploadMyAvatar().then(function (success) {
          _this2.closeModalRequest(true);
        }, function (failure) {
          _this2.closeModalRequest();
        });
      } else {
        this.closeModalRequest(true);
      }
    },
    goToTakePhotoTab: function goToTakePhotoTab() {
      this.selectedTab = 'takePhoto';
      this.initJpegCamera();
    },
    goToUploadPhotoTab: function goToUploadPhotoTab() {
      this.selectedTab = 'uploadPhoto';
      this.stopJpegCamera();
      this.removeSnapshot();
    },
    initJpegCamera: function initJpegCamera() {
      var _this3 = this;

      if (this.$refs.webcam) {
        this.startJpegCamera();
      } else {
        setTimeout(function () {
          _this3.startJpegCamera();
        }, 1000);
      }
    },
    startJpegCamera: function startJpegCamera() {
      if (this.$refs.webcam) {
        var options = {
          quality: 1,
          shutter: false,
          mirror: true,
          timeout: 0,
          retry_success: false,
          scale: 0.4
        };
        this.camera = new this.$jpegCamera(this.$refs.webcam, options).ready(function (info) {
          // console.log(info)
        });
      }
    },
    takeSnapshot: function takeSnapshot() {
      var snapshot = this.camera.capture();
      var contentType = 'image/jpeg';
      snapshot.get_blob(function (data) {
        this.newSnapshotURLFromCamera = window.URL.createObjectURL(data);
        this.imageFileFromCamera.blobData = data;
        this.imageFileFromCamera.contentType = contentType;
      }.bind(this), contentType);
    },
    removeSnapshot: function removeSnapshot() {
      this.newSnapshotURLFromCamera = null;
      this.imageFileFromCamera.blobData = null;
      this.imageFileFromCamera.contentType = null;
    },
    onClickTryAgain: function onClickTryAgain() {
      this.removeSnapshot();
    },
    onClickLooksGood: function onClickLooksGood() {
      this.newSnapshotURL = this.newSnapshotURLFromCamera;
      this.imageFile.blobData = this.imageFileFromCamera.blobData;
      this.imageFile.contentType = this.imageFileFromCamera.contentType;
      this.goToUploadPhotoTab();
    },
    onClickRemove: function onClickRemove() {
      this.newSnapshotURL = null;
      this.imageFile.blobData = null;
      this.imageFile.contentType = null;
    },
    stopJpegCamera: function stopJpegCamera() {
      if (this.camera) {
        this.camera.stop_stream();
        this.$refs.webcam.innerHTML = '';
        this.camera = null;
      }
    },
    openFileBrowser: function openFileBrowser() {
      var x = document.createElement('INPUT');
      x.setAttribute('type', 'file');
      x.setAttribute('accept', 'image/*;capture=camera');
      x.onchange = function (event) {
        var file = event.target.files[0];
        var contentType = file['type'];

        var reader = new FileReader();
        reader.onload = function () {
          var imageBlobData = reader.result;
          this.newSnapshotURL = (window.URL || window.webkitURL).createObjectURL(file);
          this.imageFile.blobData = imageBlobData;
          this.imageFile.contentType = contentType;
        }.bind(this);

        if (file) {
          reader.readAsArrayBuffer(file);
        }
      }.bind(this);
      x.click();
    },
    getMyProfile: function getMyProfile() {
      return this.$store.dispatch('getMyProfile');
    },
    uploadMyAvatar: function uploadMyAvatar() {
      var blobData = this.imageFile.blobData;
      var contentType = this.imageFile.contentType;
      return this.$store.dispatch('uploadMyAvatar', { blobData: blobData, contentType: contentType });
    }
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CompAddressPicker__ = __webpack_require__(159);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-dealer-registration',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__components_Modal__["a" /* default */],
    CompAddressPicker: __WEBPACK_IMPORTED_MODULE_1__components_CompAddressPicker__["a" /* default */]
  },
  computed: {
    myDealer: function myDealer() {
      return this.$store.getters.myDealer;
    },
    myDealerHasPendingRegistration: function myDealerHasPendingRegistration() {
      return this.$store.getters.myDealerHasPendingRegistration;
    },
    iAmOwnerOfMyDealer: function iAmOwnerOfMyDealer() {
      return this.$store.getters.iAmOwnerOfMyDealer;
    },
    statusGetMyDealer: function statusGetMyDealer() {
      return this.$store.getters.statusGetMyDealer;
    }
  },
  data: function data() {
    return {
      selectedTab: 'registerDealer',
      tabs: ['registerDealer', 'addressPicker'],
      name: null,
      address1: null,
      address2: null,
      lat: null,
      lng: null,
      zip: null,
      phone: null,
      email: null,
      primaryAdminEmail: null
    };
  },
  watch: {
    statusGetMyDealer: function statusGetMyDealer() {
      this.initInputs();
    }
  },
  created: function created() {
    this.initInputs();
  },
  methods: {
    closeModalRequest: function closeModalRequest() {
      var _this = this;

      this.$emit('closeModalRequest');
      setTimeout(function () {
        _this.getMyDealer();
      }, 1000);
    },
    onClickSubmit: function onClickSubmit(e) {
      var _this2 = this;

      e.preventDefault();
      this.closeModalRequest();
      var action = null;
      if (this.myDealerHasPendingRegistration) action = this.registerMyDealer;else action = this.updateMyDealer;
      action().then(function (success) {
        _this2.closeModalRequest();
      }, function (failure) {
        _this2.closeModalRequest();
      });
    },
    initInputs: function initInputs() {
      if (this.statusGetMyDealer === 'successful') {
        this.name = this.myDealer.dealerName;
        this.address1 = this.myDealer.locationInfo.address1;
        this.address2 = this.myDealer.locationInfo.address2;
        this.lat = this.myDealer.locationInfo.lat;
        this.lng = this.myDealer.locationInfo.lng;
        this.phone = this.myDealer.contactInfo.phone;
        this.email = this.myDealer.contactInfo.email;
        this.primaryAdminEmail = this.myDealer.ownerInfo.email;
      }
    },
    goToRegisterDealerTab: function goToRegisterDealerTab() {
      this.selectedTab = 'registerDealer';
    },
    goToAddressPickerTab: function goToAddressPickerTab() {
      this.selectedTab = 'addressPicker';
    },
    onCloseAddressPicker: function onCloseAddressPicker(_ref) {
      var address = _ref.address,
          lat = _ref.lat,
          lng = _ref.lng,
          zip = _ref.zip;

      this.address1 = address;
      this.lat = lat;
      this.lng = lng;
      this.zip = zip;
      this.goToRegisterDealerTab();
    },
    getMyDealer: function getMyDealer() {
      return this.$store.dispatch('getMyDealer');
    },
    registerMyDealer: function registerMyDealer() {
      var dealerId = this.myDealer.dealerId;
      var name = this.name;
      var address1 = this.address1;
      var address2 = this.address2;
      var zip = this.zip;
      var lat = this.lat;
      var lng = this.lng;
      var phone = this.phone;
      var email = this.email;
      return this.$store.dispatch('registerMyDealer', { dealerId: dealerId, name: name, zip: zip, address1: address1, address2: address2, phone: phone, email: email, lat: lat, lng: lng });
    },
    updateMyDealer: function updateMyDealer() {
      var dealerId = this.myDealer.dealerId;
      var name = this.name;
      var address1 = this.address1;
      var address2 = this.address2;
      var zip = this.zip;
      var lat = this.lat;
      var lng = this.lng;
      var phone = this.phone;
      var email = this.email;
      return this.$store.dispatch('updateMyDealer', { dealerId: dealerId, name: name, zip: zip, address1: address1, address2: address2, phone: phone, email: email, lat: lat, lng: lng });
    }
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_google__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CompIcon__ = __webpack_require__(10);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'comp-address-picker',
  components: {
    CompIcon: __WEBPACK_IMPORTED_MODULE_3__components_CompIcon__["a" /* default */]
  },
  props: {
    address: null, // string
    lat: null, // number
    lng: null // number
  },
  computed: {},
  data: function data() {
    return {
      zoom: 18, // Why 18? Because it looks good.
      map: null,
      marker: null,
      infowindow: null,
      searchInput: null,
      place: null,
      placeLat: null,
      placeLng: null,
      placePostalCode: null,
      autocomplete: null,
      placeChanged$e: null,
      dragEnd$e: null
    };
  },
  watch: {},
  mounted: function mounted() {
    var _this = this;

    // this.checkIfValidAddress()
    setTimeout(function () {
      _this.init();
    }, 500);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.placeChanged$e) {
      this.$googlemap.google.maps.event.removeListener(this.placeChanged$e);
      this.getAutocompletePacContainer(this.autocomplete).remove();
    }
    if (this.dragEnd$e) {
      this.$googlemap.google.maps.event.removeListener(this.dragEnd$e);
    }
  },
  methods: {
    close: function close() {
      this.$emit('onClose', {
        'address': this.searchInput,
        'lat': this.placeLat,
        'lng': this.placeLng,
        'zip': this.placePostalCode
      });
    },
    checkIfValidAddress: function checkIfValidAddress() {
      if (this.address && this.lat && this.lng && !this.searchInput) {
        this.searchInput = this.address;
        this.placeLat = this.lat;
        this.placeLng = this.lng;
        this.refreshMapCenter();
      }
    },
    init: function init() {
      this.loadGoogleMapLib();
    },
    loadGoogleMapLib: function loadGoogleMapLib() {
      var _this2 = this;

      if (!this.$googlemap.isLoaded) {
        this.$googlemap.loadScript(function (isSuccess) {
          if (isSuccess) {
            _this2.initAutoComplete();
            _this2.initMap();
            _this2.checkIfValidAddress();
          }
        });
      } else {
        this.initAutoComplete();
        this.initMap();
        this.checkIfValidAddress();
      }
    },
    initMap: function initMap() {
      var _this3 = this;

      if (this.$refs['googleMap'] && this.$refs['infowindowContent']) {
        this.map = new this.$googlemap.google.maps.Map(this.$refs['googleMap'], {
          center: { lat: 40.7127753, lng: -74.0059728 },
          zoom: this.zoom,
          scaleControl: false,
          streetViewControl: false,
          mapTypeControl: false
        });
        this.marker = new this.$googlemap.google.maps.Marker({
          map: this.map,
          draggable: true,
          animation: this.$googlemap.google.maps.Animation.DROP,
          anchorPoint: new this.$googlemap.google.maps.Point(0, -29)
        });
        this.dragEnd$e = this.marker.addListener('dragend', function (event) {
          _this3.onMarkerMoved(event);
        });
        this.infowindow = new this.$googlemap.google.maps.InfoWindow();
        this.infowindow.setContent(this.$refs['infowindowContent']);
      }
    },
    initAutoComplete: function initAutoComplete() {
      var _this4 = this;

      if (this.$refs['searchInput']) {
        this.autocomplete = new this.$googlemap.google.maps.places.Autocomplete(this.$refs['searchInput'], {
          types: [
          // return only geocoding results, rather than business results.
          'geocode']
        });
        this.placeChanged$e = this.autocomplete.addListener('place_changed', function () {
          _this4.onPlaceChanged();
        });
      }
    },
    getAutocompletePacContainer: function getAutocompletePacContainer(autocomplete) {
      var place = autocomplete.gm_accessors_.place;
      var placeKey = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(place).find(function (value) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(place[value]) === 'object' && place[value].hasOwnProperty('gm_accessors_');
      });
      var input = place[placeKey].gm_accessors_.input[placeKey];
      var inputKey = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(input).find(function (value) {
        return input[value].classList && input[value].classList.contains('pac-container');
      });
      return input[inputKey];
    },
    onMarkerMoved: function onMarkerMoved(event) {
      var _this5 = this;

      var lat = event.latLng.lat();
      var lng = event.latLng.lng();
      __WEBPACK_IMPORTED_MODULE_2__apis_google__["a" /* default */].getAddressOfGeoCode({ lat: lat, lng: lng }).then(function (res) {
        var place = res.body.results[0];
        _this5.placeLat = place.geometry.location.lat;
        _this5.placeLng = place.geometry.location.lng;
        _this5.placePostalCode = _this5.getPostalCode(place.address_components);
        _this5.searchInput = place.formatted_address;
        _this5.$refs['infowindowContent'].children['place-name'].textContent = 'New address';
        _this5.$refs['infowindowContent'].children['place-address'].textContent = _this5.searchInput;
        // make it valid address
        _this5.place = place;
      }, function (err) {
        console.log(err);
      });
    },
    onPlaceChanged: function onPlaceChanged() {
      this.place = this.autocomplete.getPlace();
      this.marker.setVisible(false);
      if (!this.place.geometry) {
        return;
      }
      this.placeLat = this.place.geometry.location.lat();
      this.placeLng = this.place.geometry.location.lng();
      this.placePostalCode = this.getPostalCode(this.place.address_components);

      this.searchInput = this.place.formatted_address;
      // if (this.place.geometry.viewport) {
      //   this.map.fitBounds(this.place.geometry.viewport)
      // } else {
      //   this.map.setCenter(this.place.geometry.location)
      //   this.map.setZoom(this.zoom)
      // }
      this.map.setCenter(this.place.geometry.location);
      this.map.setZoom(this.zoom);
      this.marker.setPosition(this.place.geometry.location);
      this.marker.setVisible(true);

      this.$refs['infowindowContent'].children['place-name'].textContent = 'New address';
      this.$refs['infowindowContent'].children['place-address'].textContent = this.searchInput;
      this.infowindow.open(this.map, this.marker);
    },
    refreshMapCenter: function refreshMapCenter() {
      this.marker.setVisible(false);
      var latLng = { lat: parseFloat(this.placeLat), lng: parseFloat(this.placeLng) };
      this.map.setCenter(latLng);
      this.map.setZoom(this.zoom);
      this.marker.setPosition(latLng);
      this.marker.setVisible(true);
      this.$refs['infowindowContent'].children['place-name'].textContent = 'Current address';
      this.$refs['infowindowContent'].children['place-address'].textContent = this.searchInput;
      this.infowindow.open(this.map, this.marker);
    },
    onEnterKey: function onEnterKey() {
      if (this.place) {
        this.onPlaceChanged();
      }
    },
    getPostalCode: function getPostalCode(googleAddressComponents) {
      var postalCode = null;
      try {
        googleAddressComponents.map(function (addrComp) {
          addrComp.types.map(function (addrCompType) {
            if (addrCompType === 'postal_code') {
              postalCode = addrComp.long_name;
            }
          });
        });
      } catch (err) {}
      return postalCode;
    }
  }
});

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-open-dealer-portal',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__components_Modal__["a" /* default */]
  },
  computed: {
    myDealerType: function myDealerType() {
      return this.$store.getters.myDealerType;
    }
  },
  methods: {
    closeModalRequest: function closeModalRequest() {
      this.$emit('closeModalRequest');
    },
    goToDealerPortal: function goToDealerPortal() {
      if (this.myDealerType === 'Wholesale Monitoring Station') {
        this.goToURL(this.$env.wcsWebUrl);
      } else {
        this.goToURL(this.$env.dealerWebUrl);
      }
      this.closeModalRequest();
    },
    goToURL: function goToURL(url) {
      this.$tool.redirectToUrl(url);
    }
  }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-open-enduser-app',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__components_Modal__["a" /* default */]
  },
  methods: {
    closeModalRequest: function closeModalRequest() {
      this.$emit('closeModalRequest');
    },
    goToEnduserApp: function goToEnduserApp() {
      this.goToURL(this.$env.appWebUrl);
      this.closeModalRequest();
    },
    goToURL: function goToURL(url) {
      this.$tool.redirectToUrl(url);
    }
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-logout',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_1__components_Modal__["a" /* default */]
  },
  data: function data() {
    return {
      title: 'Are you sure to logout?',
      description: 'All your web apps in this browser will be logged out.'
    };
  },
  computed: {
    myEmail: function myEmail() {
      return this.$store.getters.myEmail;
    }
  },
  watch: {
    myEmail: function myEmail() {
      this.setProperMessage();
    }
  },
  created: function created() {
    this.setProperMessage();
  },
  methods: {
    closeModalRequest: function closeModalRequest() {
      this.$emit('closeModalRequest');
    },
    onClickSubmit: function onClickSubmit(e) {
      e.preventDefault();
      this.closeModalRequest();
    },
    logout: function logout() {
      // When an user taking this action
      // The user want to login as USER not IP
      var query = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$route.query));
      delete query['ip_name'];
      this.$router.push({ name: 'Logout', query: query });
    },
    setProperMessage: function setProperMessage() {
      var request = this.$param.options;
      if (this.myEmail) {
        if ('email' in request) {
          if (this.myEmail !== request['email']) {
            this.title = 'Do you want to logout?';
            this.description = 'You are trying to login ' + request['email'] + ', but you are already logged in as ' + this.myEmail + '.';
            return;
          }
        }
      }
      this.title = 'Are you sure to logout?';
      this.description = 'All your web apps in this browser will be logged out.';
    }
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CompIcon__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profile',
  components: {
    CompIcon: __WEBPACK_IMPORTED_MODULE_0__components_CompIcon__["a" /* default */]
  },
  computed: {
    myProfilePictureUrl: function myProfilePictureUrl() {
      return this.$store.getters.myProfilePictureUrl;
    },
    myName: function myName() {
      return this.$store.getters.myFirstName ? this.$store.getters.myFirstName + ' ' + this.$store.getters.myLastName : '';
    },
    myEmail: function myEmail() {
      return this.$store.getters.myEmail;
    },
    myDealer: function myDealer() {
      return this.$store.getters.myDealer;
    },
    myDealerType: function myDealerType() {
      return this.$store.getters.myDealerType;
    },
    hasMyDealer: function hasMyDealer() {
      return this.$store.getters.hasMyDealer;
    },
    myDealerHasPendingRegistration: function myDealerHasPendingRegistration() {
      return this.$store.getters.myDealerHasPendingRegistration;
    },
    iAmOwnerOfMyDealer: function iAmOwnerOfMyDealer() {
      return this.$store.getters.iAmOwnerOfMyDealer;
    },
    isIPAuth: function isIPAuth(state) {
      return !!this.$store.getters.idTokenIPAuthDealerID;
    },
    ipAuthIP: function ipAuthIP(state) {
      return this.$store.getters.idTokenIPAuthIP;
    }
  },
  data: function data() {
    return {
      email: 'trevor.seo@chekt.com',
      name: 'Trevor S. Seo',
      camera: null
    };
  },
  methods: {
    onClickChangePhoto: function onClickChangePhoto() {
      this.$emit('openChangePhotoModal');
    },
    onClickChangePassword: function onClickChangePassword() {
      this.$emit('openChangePasswordModal');
    },
    onClickChangeDealerInfo: function onClickChangeDealerInfo() {
      this.$emit('openChangeDealerInfoModal');
    },
    onClickChangeName: function onClickChangeName() {
      this.$emit('openChangeNameModal');
    },
    onClickChangeIPUserName: function onClickChangeIPUserName() {
      this.$emit('openChangeIPUserNameModal');
    },
    onClickChangeEmail: function onClickChangeEmail() {
      this.$emit('openChangeEmailModal');
    },
    onClickChangeProfile: function onClickChangeProfile() {
      if (!this.camera) {
        console.log('this.initJpegCamera()');
        this.initJpegCamera();
      } else {
        console.log('this.stopJpegCamera()');
        this.stopJpegCamera();
      }
    },
    initJpegCamera: function initJpegCamera() {
      var options = {
        quality: 0.5,
        shutter: false,
        mirror: false,
        timeout: 0,
        retry_success: false,
        scale: 0.4
      };
      this.camera = new this.$jpegCamera(this.$refs.webcam, options).ready(function (info) {
        console.log(info);
      });
    },
    stopJpegCamera: function stopJpegCamera() {
      this.camera.stop_stream();
      this.$refs.webcam.innerHTML = '';
      this.camera = null;
    }
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'devices'
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'access-history'
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CompAppIcon__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dealer-tools',
  components: {
    CompAppIcon: __WEBPACK_IMPORTED_MODULE_0__components_CompAppIcon__["a" /* default */]
  },
  computed: {
    myDealerName: function myDealerName() {
      return this.$store.getters.myDealerName;
    },
    myDealerType: function myDealerType() {
      return this.$store.getters.myDealerType;
    },
    ipAuthIP: function ipAuthIP(state) {
      return this.$store.getters.idTokenIPAuthIP;
    }
  },
  data: function data() {
    return {
      appIconWidth: 340
    };
  },
  methods: {
    goToURL: function goToURL(url) {
      this.$tool.openNewTab(url);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'comp-app-icon',
  props: {
    icon: {
      type: String,
      default: function _default() {
        return null;
      }
    },
    width: {
      type: Number,
      default: function _default() {
        return 40;
      }
    },
    widthInCustomMetric: {
      type: String,
      default: function _default() {
        return null;
      }
    },
    color: {
      type: String,
      default: function _default() {
        return null;
      }
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CompAppIcon__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'customer-tools',
  components: {
    CompAppIcon: __WEBPACK_IMPORTED_MODULE_0__components_CompAppIcon__["a" /* default */]
  },
  computed: {
    mySites: function mySites() {
      return this.$store.getters.mySites;
    }
  },
  data: function data() {
    return {
      appIconWidth: 340
    };
  },
  methods: {
    goToURL: function goToURL(url) {
      this.$tool.openNewTab(url);
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CompAppIcon__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'admin-tools',
  components: {
    CompAppIcon: __WEBPACK_IMPORTED_MODULE_0__components_CompAppIcon__["a" /* default */]
  },
  data: function data() {
    return {
      appIconWidth: 340
    };
  },
  methods: {
    goToURL: function goToURL(url) {
      this.$tool.openNewTab(url);
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qrcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CompOtpInput__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_mfaHelpers__ = __webpack_require__(94);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'security',
  components: {
    CompOtpInput: __WEBPACK_IMPORTED_MODULE_1__components_CompOtpInput__["a" /* default */]
  },
  data: function data() {
    return {
      pageState: 'loading', // loading | needAuth | ready | error
      errorMessage: '',
      otp: '',
      enrollError: '',
      qrDataUrl: '',
      secretCopied: false,
      verifying: false
    };
  },
  computed: {
    authenticators: function authenticators() {
      return this.$store.getters.mfaAuthenticators;
    },
    pendingEnrollment: function pendingEnrollment() {
      return this.$store.getters.mfaPendingEnrollment;
    }
  },
  created: function created() {
    if (window.location.hash.indexOf('access_token=') !== -1) {
      // Returning from the authorize() redirect with an MFA-scoped token in the hash.
      this.resume();
    } else if (this.$store.getters.hasMfaToken) {
      this.loadAndReady();
    } else {
      this.trySilent();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('clearMfaSession');
  },
  methods: {
    trySilent: function trySilent() {
      // Attempt to get the MFA token without a redirect. Falls back to the
      // Continue button (interactive authorize) when Auth0 needs an MFA step-up
      // or the SSO cookie is unavailable (e.g. third-party cookies on localhost).
      var self = this;
      this.pageState = 'loading';
      this.$store.dispatch('initMfaSession').then(function () {
        return self.$store.dispatch('loadMfaAuthenticators');
      }).then(function () {
        self.pageState = 'ready';
        self.maybeAutoEnroll();
      }).catch(function () {
        self.pageState = 'needAuth';
      });
    },
    authorize: function authorize() {
      // Full-page redirect to Auth0; returns to this page with the token in the hash.
      this.$store.dispatch('startMfaAuthorize');
    },
    resume: function resume() {
      var self = this;
      this.pageState = 'loading';
      this.$store.dispatch('resumeMfaSession').then(function () {
        // Strip the token from the URL so it is not left in history.
        window.history.replaceState({}, document.title, window.location.pathname + window.location.search);
        return self.$store.dispatch('loadMfaAuthenticators');
      }).then(function () {
        self.pageState = 'ready';
        self.maybeAutoEnroll();
      }).catch(function (err) {
        self.errorMessage = Object(__WEBPACK_IMPORTED_MODULE_2__utils_mfaHelpers__["a" /* mapMfaError */])(err);
        self.pageState = 'error';
      });
    },
    loadAndReady: function loadAndReady() {
      var self = this;
      this.pageState = 'loading';
      this.$store.dispatch('loadMfaAuthenticators').then(function () {
        self.pageState = 'ready';
        self.maybeAutoEnroll();
      }).catch(function (err) {
        self.errorMessage = Object(__WEBPACK_IMPORTED_MODULE_2__utils_mfaHelpers__["a" /* mapMfaError */])(err);
        self.pageState = 'error';
      });
    },
    maybeAutoEnroll: function maybeAutoEnroll() {
      // No authenticator yet → go straight to the QR enrollment, no extra click.
      if (this.authenticators.length === 0 && !this.pendingEnrollment) {
        this.startEnrollment();
      }
    },
    startEnrollment: function startEnrollment() {
      // Only one authenticator app is allowed; ignore if one already exists.
      if (this.authenticators.length >= 1) return;
      var self = this;
      this.enrollError = '';
      this.otp = '';
      this.qrDataUrl = '';
      this.$store.dispatch('startMfaEnrollment').then(function () {
        var uri = self.pendingEnrollment && self.pendingEnrollment.barcodeUri;
        if (uri) {
          __WEBPACK_IMPORTED_MODULE_0_qrcode___default.a.toDataURL(uri).then(function (url) {
            self.qrDataUrl = url;
          });
        }
      }).catch(function (err) {
        self.enrollError = Object(__WEBPACK_IMPORTED_MODULE_2__utils_mfaHelpers__["a" /* mapMfaError */])(err);
      });
    },
    onOtpComplete: function onOtpComplete() {
      // Auto-submit when all 6 digits are entered, with a short beat so the
      // transition does not feel abrupt (a "Verifying…" state is shown).
      if (this.verifying) return;
      this.verifying = true;
      this.enrollError = '';
      var self = this;
      setTimeout(function () {
        self.doConfirm();
      }, 500);
    },
    submitOtp: function submitOtp() {
      if (this.verifying) return;
      this.verifying = true;
      this.enrollError = '';
      this.doConfirm();
    },
    doConfirm: function doConfirm() {
      var self = this;
      this.$store.dispatch('confirmMfaEnrollment', { otp: this.otp }).then(function () {
        self.otp = '';
        self.qrDataUrl = '';
        self.verifying = false;
      }).catch(function (err) {
        self.verifying = false;
        self.enrollError = Object(__WEBPACK_IMPORTED_MODULE_2__utils_mfaHelpers__["a" /* mapMfaError */])(err);
      });
    },
    copySecret: function copySecret() {
      var self = this;
      var secret = this.pendingEnrollment && this.pendingEnrollment.secret;
      if (!secret) return;
      var flag = function flag() {
        self.secretCopied = true;
        setTimeout(function () {
          self.secretCopied = false;
        }, 1500);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(secret).then(flag, function () {
          self.fallbackCopy(secret);
          flag();
        });
      } else {
        this.fallbackCopy(secret);
        flag();
      }
    },
    fallbackCopy: function fallbackCopy(text) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      try {
        document.execCommand('copy');
      } catch (e) {/* ignore */}
      document.body.removeChild(ta);
    },
    remove: function remove(id) {
      var self = this;
      if (!window.confirm('Remove this authenticator app?')) return;
      this.$store.dispatch('removeMfaAuthenticator', { id: id }).then(function () {
        // Now at zero authenticators → go straight back to QR enrollment.
        self.maybeAutoEnroll();
      }).catch(function (err) {
        self.errorMessage = Object(__WEBPACK_IMPORTED_MODULE_2__utils_mfaHelpers__["a" /* mapMfaError */])(err);
        self.pageState = 'error';
      });
    }
  }
});

/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'comp-otp-input',
  props: {
    length: { type: Number, default: 6 },
    value: { type: String, default: '' }
  },
  data: function data() {
    return {
      boxes: this.toBoxes(this.value)
    };
  },
  watch: {
    // Resync when the parent resets the value (e.g. clears on error/cancel).
    value: function value(v) {
      if (v !== this.boxes.join('')) {
        this.boxes = this.toBoxes(v);
      }
    }
  },
  methods: {
    toBoxes: function toBoxes(str) {
      var arr = [];
      for (var i = 0; i < this.length; i++) {
        arr.push(str && str[i] ? str[i] : '');
      }
      return arr;
    },
    focusBox: function focusBox(i) {
      var ref = this.$refs['box' + i];
      var el = Array.isArray(ref) ? ref[0] : ref;
      if (el) {
        el.focus();
        el.select();
      }
    },
    emitValue: function emitValue() {
      var code = this.boxes.join('');
      this.$emit('input', code);
      if (code.length === this.length) {
        this.$emit('complete', code);
      }
    },
    onInput: function onInput(i, e) {
      var digits = e.target.value.replace(/[^0-9]/g, '');
      var digit = digits ? digits[digits.length - 1] : '';
      this.$set(this.boxes, i, digit);
      e.target.value = digit;
      if (digit && i < this.length - 1) this.focusBox(i + 1);
      this.emitValue();
    },
    onKeydown: function onKeydown(i, e) {
      if (e.key === 'Backspace' && !this.boxes[i] && i > 0) {
        this.focusBox(i - 1);
      } else if (e.key === 'ArrowLeft' && i > 0) {
        e.preventDefault();
        this.focusBox(i - 1);
      } else if (e.key === 'ArrowRight' && i < this.length - 1) {
        e.preventDefault();
        this.focusBox(i + 1);
      }
    },
    onFocus: function onFocus(e) {
      e.target.select();
    },
    onPaste: function onPaste(e) {
      var _this = this;

      e.preventDefault();
      var clipboard = e.clipboardData || window.clipboardData;
      var text = clipboard ? clipboard.getData('text') : '';
      var digits = (text || '').replace(/[^0-9]/g, '').slice(0, this.length);
      if (!digits) return;
      var arr = this.toBoxes('');
      for (var j = 0; j < digits.length; j++) {
        arr[j] = digits[j];
      }this.boxes = arr;
      var next = Math.min(digits.length, this.length - 1);
      this.$nextTick(function () {
        return _this.focusBox(next);
      });
      this.emitValue();
    }
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = parseOtpAuthenticators;
/* unused harmony export buildAssociateBody */
/* harmony export (immutable) */ __webpack_exports__["b"] = parseAssociateResponse;
/* harmony export (immutable) */ __webpack_exports__["a"] = mapMfaError;
// Pure, framework-free helpers for MFA management.
// No Vue/auth0 imports, so these are unit-testable without the browser harness.

function parseOtpAuthenticators(list) {
  if (!Array.isArray(list)) return [];
  return list.filter(function (a) {
    return a && a.authenticator_type === 'otp' && a.active === true;
  }).map(function (a) {
    return { id: a.id, name: a.name || 'Authenticator app', active: true };
  });
}

function buildAssociateBody() {
  return { authenticator_types: ['otp'] };
}

function parseAssociateResponse(body) {
  if (!body) return null;
  return {
    secret: body.secret || null,
    barcodeUri: body.barcode_uri || null,
    recoveryCodes: Array.isArray(body.recovery_codes) ? body.recovery_codes : []
  };
}

function mapMfaError(error) {
  var code = error && (error.error || error.body && error.body.error) || null;
  var status = error && error.status || null;
  switch (code) {
    case 'login_required':
    case 'consent_required':
    case 'interaction_required':
      return 'Your session has expired. Please sign in again.';
    case 'invalid_grant':
      return 'The verification code is invalid or has expired. Please try again.';
    case 'access_denied':
      return 'You are not allowed to manage two-factor authentication.';
  }
  if (status === 401 || status === 403) {
    return 'The verification code is invalid or has expired. Please try again.';
  }
  return 'Something went wrong. Please try again.';
}

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CompIcon__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  components: {
    CompIcon: __WEBPACK_IMPORTED_MODULE_0__components_CompIcon__["a" /* default */]
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'logout',
  created: function created() {
    this.logout();
  },
  methods: {
    logout: function logout() {
      this.$store.dispatch('logout');
    }
  }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CompIcon__ = __webpack_require__(10);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-callback',
  components: {
    CompIcon: __WEBPACK_IMPORTED_MODULE_1__components_CompIcon__["a" /* default */]
  },
  data: function data() {
    return {
      errMessage: null,
      retryMax: 3,
      curCount: 0
    };
  },
  created: function created() {
    this.handleAuthentication();
  },
  methods: {
    handleAuthentication: function handleAuthentication() {
      var _this = this;

      this.$store.dispatch('handleAuthentication').then(function (success) {
        _this.$logger.info('handleAuthentication: Authenticated user');
        // do nothing
        // there is the event listener in MyAuth.vue
      }, function (err) {
        try {
          if (err.message === 'no_result') {
            _this.curCount++;
            if (_this.retryMax !== _this.curCount) {
              setTimeout(function () {
                return _this.handleAuthentication();
              }, 100);
            } else {
              _this.$logger.error('handleAuthentication: Not authenticated user: ' + err.message);
              _this.errMessage = 'Login failed: No id_token';
            }
            return;
          }
        } catch (error) {}
        var errMessage = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err);
        _this.$logger.error('handleAuthentication: Not authenticated user: ' + errMessage);
        _this.errMessage = errMessage;
        // do nothing
      });
    },
    goToLogin: function goToLogin() {
      this.$tool.redirectToUrl(window.origin);
    }
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CompIcon__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loading',
  components: {
    CompIcon: __WEBPACK_IMPORTED_MODULE_0__components_CompIcon__["a" /* default */]
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CompIcon__ = __webpack_require__(10);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CompIcon: __WEBPACK_IMPORTED_MODULE_2__components_CompIcon__["a" /* default */]
  },
  name: 'signup',
  data: function data() {
    return {
      email: '',
      password: '',
      confirmPassword: '',
      loginFailMessage: '',
      isLoading: false,
      isEmailExist: false,
      isSignupFailed: false,
      passowordMatch: false,
      isInvailedEmail: false,
      signupSuccess: false
    };
  },

  watch: {
    password: function password() {
      this.checkPasswordMacth();
    },
    confirmPassword: function confirmPassword() {
      this.checkPasswordMacth();
    },
    email: function email() {
      if (!this.$tool.isValidEmailAddress(this.email)) this.isInvailedEmail = true;else this.isInvailedEmail = false;
    }
  },
  computed: {},
  created: function created() {},
  methods: {
    checkPasswordMacth: function checkPasswordMacth() {
      if (this.password === this.confirmPassword) this.passowordMatch = true;else this.passowordMatch = false;
    },
    clickSignup: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(email, password) {
        var passwordDom, passwordConfirmDom, emailDom;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                passwordDom = document.getElementById('password');
                passwordConfirmDom = document.getElementById('passwordConfirm');
                emailDom = document.getElementById('email');

                passwordDom.blur();
                passwordConfirmDom.blur();
                emailDom.blur();
                passwordDom.disabled = true;
                passwordConfirmDom.disabled = true;
                emailDom.disabled = true;
                this.isSignupFailed = false;
                this.isLoading = true;
                _context.next = 13;
                return this.$tool.wait(500);

              case 13:
                if (this.checkInput(emailDom, passwordDom, passwordConfirmDom)) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt('return');

              case 15:
                _context.prev = 15;
                _context.next = 18;
                return this.$firebase.auth.signIn({ email: email, password: password });

              case 18:
                this.signupSuccess = true;
                _context.next = 25;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context['catch'](15);

                this.isSignupFailed = true;
                this.loginFailMessage = _context.t0.message;

              case 25:
                this.isLoading = false;
                passwordDom.disabled = false;
                emailDom.disabled = false;
                passwordConfirmDom.disabled = false;

              case 29:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[15, 21]]);
      }));

      function clickSignup(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return clickSignup;
    }(),
    checkInput: function checkInput(emailDom, passwordDom, passwordConfirmDom) {
      var _this = this;

      var failedRoutine = function failedRoutine() {
        _this.isSignupFailed = true;
        _this.isLoading = false;
        emailDom.disabled = false;
        passwordDom.disabled = false;
        passwordConfirmDom.disabled = false;
      };

      // 1. when enpty email or password
      if (!this.password || !this.confirmPassword || !this.email) {
        failedRoutine();
        this.loginFailMessage = 'Please set your email or password';
        return false;
      }

      // 2. check valid email
      if (this.isInvailedEmail) {
        failedRoutine();
        this.loginFailMessage = 'Invalid email format';
        return false;
      }

      // 3. check password match
      if (!this.passowordMatch) {
        failedRoutine();
        this.loginFailMessage = 'No matched password with confirm password';
        return false;
      }

      return true;
    },
    goToLink: function goToLink(type) {
      var link = null;

      if (type === 'ios') link = 'https://apps.apple.com/app/chekt-com/id1508918518?l=en-GB';else if (type === 'android') link = 'https://play.google.com/store/apps/details?id=com.chekt.app.v3';else if (type === 'chekt') link = 'https://chekt.com/';else if (type === 'contact') link = 'https://chekt.com/dealers/contact/';else if (type === 'privacy') link = 'https://chekt.com/privacy-policy/';

      if (link) window.open(link, "_blank");
    }
  }
});

/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  checkEmail: function checkEmail(email) {
    var apiDetailPath = '/users/find?email=' + encodeURIComponent(email);
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.apiPath + apiDetailPath);
  },
  pingCloud: function pingCloud() {
    var apiDetailPath = '/users/find?email=ping';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.apiPath + apiDetailPath);
  },
  getMyProfile: function getMyProfile() {
    var apiDetailPath = '/users/me';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.apiPath + apiDetailPath, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  updateMyEmailAsVerified: function updateMyEmailAsVerified() {
    var apiDetailPath = '/users/me';
    var data = {
      is_verify: 1
    };
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.put(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.apiPath + apiDetailPath, data, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  updateMyProfile: function updateMyProfile(_ref) {
    var firstName = _ref.firstName,
        lastName = _ref.lastName;

    var apiDetailPath = '/users/me';
    var data = {
      firstname: firstName,
      lastname: lastName
    };
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.put(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.apiPath + apiDetailPath, data, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  changeMyEmail: function changeMyEmail(_ref2) {
    var email = _ref2.email;

    var apiDetailPath = '/users/me/change_email_verify';
    var data = {
      email: email
    };
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.put(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.apiPath + apiDetailPath, data, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  changeMyPassword: function changeMyPassword(_ref3) {
    var password = _ref3.password;

    var apiDetailPath = '/users/me/change_password';
    var data = {
      password: password
    };
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.put(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.apiPath + apiDetailPath, data, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  getMyAvatarUploadUrl: function getMyAvatarUploadUrl(_ref4) {
    var fileExtension = _ref4.fileExtension;

    var apiDetailPath = '/users/me/picture';
    var data = {
      format: fileExtension
    };
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.put(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.apiPath + apiDetailPath, data, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  getMyDealer: function getMyDealer(tsSessionDealerId) {
    var apiDetailPath = '/users/me/dealer';
    if (tsSessionDealerId) {
      apiDetailPath += '?dealer_id=' + tsSessionDealerId;
    }
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.apiPath + apiDetailPath, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  getMyPublicIp: function getMyPublicIp() {
    var apiDetailPath = '/users/me/ip';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.apiPath + apiDetailPath, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  getMyMetadata: function getMyMetadata() {
    var apiDetailPath = '/users/me/metadata';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.apiPath + apiDetailPath, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  createMyMetadata: function createMyMetadata(metadata) {
    var apiDetailPath = '/users/me/metadata';
    var data = {
      metadata: metadata
    };
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.apiPath + apiDetailPath, data, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  updateMyMetadata: function updateMyMetadata(metadata) {
    var apiDetailPath = '/users/me/metadata';
    var data = {
      metadata: metadata
    };
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.put(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.apiPath + apiDetailPath, data, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  deleteMyMetadata: function deleteMyMetadata() {
    var apiDetailPath = '/users/me/metadata';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.delete(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.apiPath + apiDetailPath, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  getDealer: function getDealer(_ref) {
    var dealerId = _ref.dealerId;

    var apiDetailPath = '/dealers/' + dealerId;
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.apiPath + apiDetailPath, { 'headers': { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  registerDealer: function registerDealer(_ref2) {
    var dealerId = _ref2.dealerId,
        name = _ref2.name,
        zip = _ref2.zip,
        address1 = _ref2.address1,
        address2 = _ref2.address2,
        phone = _ref2.phone,
        email = _ref2.email,
        lat = _ref2.lat,
        lng = _ref2.lng;

    var apiDetailPath = '/dealers/' + dealerId + '/register';
    var data = {
      company_name: name,
      company_zipcode: zip,
      company_address1: address1,
      company_address2: address2,
      company_phone: phone,
      company_email: email,
      lat: lat,
      lng: lng
    };
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.put(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.apiPath + apiDetailPath, data, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  updateDealer: function updateDealer(_ref3) {
    var dealerId = _ref3.dealerId,
        name = _ref3.name,
        zip = _ref3.zip,
        address1 = _ref3.address1,
        address2 = _ref3.address2,
        phone = _ref3.phone,
        email = _ref3.email,
        lat = _ref3.lat,
        lng = _ref3.lng;

    var apiDetailPath = '/dealers/' + dealerId;
    var data = {
      company_name: name,
      company_zipcode: zip,
      company_address1: address1,
      company_address2: address2,
      company_phone: phone,
      company_email: email,
      lat: lat,
      lng: lng
    };
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.put(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.apiPath + apiDetailPath, data, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  acceptDealerMemberInvitation: function acceptDealerMemberInvitation(_ref4) {
    var dealerId = _ref4.dealerId,
        memberId = _ref4.memberId;

    var apiDetailPath = '/dealers/' + dealerId + '/members/' + memberId + '/accept';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.apiPath + apiDetailPath, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  }
});

/***/ }),
/* 107 */,
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_auth__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_environment__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_tool__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_logger__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_jpegCamera__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plugins_param__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plugins_time__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plugins_googlemap__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__plugins_tagManager__ = __webpack_require__(312);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7__plugins_tool__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6__plugins_environment__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11__plugins_time__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8__plugins_logger__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__plugins_auth__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9__plugins_jpegCamera__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10__plugins_param__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12__plugins_googlemap__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13__plugins_tagManager__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

if (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.isChektDomain && __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.isProduction) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].logger.setLogLevel('WARNING'); // 'DEBUG', 'INFO', 'WARNING', 'ERROR'
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].tagManager.appendTags();
} else {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].logger.setLogLevel('DEBUG'); // 'DEBUG', 'INFO', 'WARNING', 'ERROR'
}
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].logger.getLogLevelFromLocalStorage();

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(51);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd55b534_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(119);
function injectStyle (ssrContext) {
  __webpack_require__(113)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd55b534_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */,
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyAuth_vue__ = __webpack_require__(52);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_551dc3a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyAuth_vue__ = __webpack_require__(118);
function injectStyle (ssrContext) {
  __webpack_require__(116)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-551dc3a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyAuth_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_551dc3a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyAuth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 117 */,
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('my-auth'),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Account__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Account_Profile__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Account_Devices__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Account_AccessHistory__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Account_DealerTools__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Account_CustomerTools__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Account_AdminTools__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Account_Security__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Login__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Logout__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_MyCallback__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Loading__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Signup__ = __webpack_require__(257);
















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/account',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Account__["a" /* default */],
    children: [{
      path: 'profile',
      name: 'Profile',
      component: __WEBPACK_IMPORTED_MODULE_3__pages_Account_Profile__["a" /* default */]
    }, {
      path: 'security',
      name: 'Security',
      component: __WEBPACK_IMPORTED_MODULE_9__pages_Account_Security__["a" /* default */]
    }, {
      path: 'devices',
      name: 'Devices',
      component: __WEBPACK_IMPORTED_MODULE_4__pages_Account_Devices__["a" /* default */]
    }, {
      path: 'access-history',
      name: 'AccessHistory',
      component: __WEBPACK_IMPORTED_MODULE_5__pages_Account_AccessHistory__["a" /* default */]
    }, {
      path: 'dealer-tools',
      name: 'DealerTools',
      component: __WEBPACK_IMPORTED_MODULE_6__pages_Account_DealerTools__["a" /* default */]
    }, {
      path: 'customer-tools',
      name: 'CustomerTools',
      component: __WEBPACK_IMPORTED_MODULE_7__pages_Account_CustomerTools__["a" /* default */]
    }, {
      path: 'admin-tools',
      name: 'AdminTools',
      component: __WEBPACK_IMPORTED_MODULE_8__pages_Account_AdminTools__["a" /* default */]
    }, {
      path: '/',
      redirect: 'profile'
    }, {
      path: '*',
      redirect: 'profile'
    }]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_Login__["a" /* default */],
    props: true
  }, {
    path: '/logout',
    name: 'Logout',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_Logout__["a" /* default */]
  }, {
    path: '/callback',
    name: 'Callback',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_MyCallback__["a" /* default */]
  }, {
    path: '/loading',
    name: 'Loading',
    component: __WEBPACK_IMPORTED_MODULE_13__pages_Loading__["a" /* default */]
  }, {
    path: '/signup',
    name: 'Signup',
    component: __WEBPACK_IMPORTED_MODULE_14__pages_Signup__["a" /* default */]
  }, {
    path: '/',
    redirect: 'loading'
    // {
    //   path: '*',
    //   redirect: 'loading'
    // }
  }]
}));

/***/ }),
/* 121 */,
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__ = __webpack_require__(53);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab4cec60_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__ = __webpack_require__(193);
function injectStyle (ssrContext) {
  __webpack_require__(123)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ab4cec60"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab4cec60_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-icon",style:({
  'font-size': _vm.widthInCustomMetric ? _vm.widthInCustomMetric : _vm.width + 'px',
  'color': _vm.color
})},[(_vm.icon === 'sdCard')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z"}})])]:(_vm.icon === 'bridge')?[_c('svg',{attrs:{"fill":"#000000","height":"48px","viewBox":"0 0 24 24","width":"48px","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"height":"18","width":"17","x":"3.5","y":"3","rx":"1","ry":"1"}}),_vm._v(" "),_c('rect',{attrs:{"fill":"hsl(100, 100%, 0%)","height":"2","width":"2","x":"4.75","y":"14"}}),_vm._v(" "),_c('rect',{attrs:{"fill":"hsl(200, 100%, 0%)","height":"2","width":"2","x":"7.25","y":"14"}}),_vm._v(" "),_c('rect',{attrs:{"fill":"hsl(0, 100%, 0%)","height":"2","width":"2","x":"9.75","y":"14"}}),_vm._v(" "),_c('rect',{attrs:{"fill":"hsl(0, 100%, 0%)","height":"2","width":"2","x":"12.25","y":"14"}}),_vm._v(" "),_c('rect',{attrs:{"fill":"hsl(0, 100%, 0%)","height":"2","width":"2","x":"14.75","y":"14"}}),_vm._v(" "),_c('rect',{attrs:{"fill":"hsl(0, 100%, 0%)","height":"2","width":"2","x":"17.25","y":"14"}})])]:(_vm.icon === 'chekt')?[_c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 640 640","width":"48","height":"48"}},[_c('defs',[_c('path',{attrs:{"d":"M330.5 18.09L337.89 18.25L345.28 18.47L352.67 18.75L360.08 19.1L367.48 19.52L374.9 19.99L382.31 20.53L389.74 21.13L397.17 21.8L404.6 22.53L412.04 23.33L419.49 24.18L426.94 25.1L434.4 26.09L441.86 27.14L449.33 28.25L456.8 29.42L464.28 30.66L471.77 31.96L479.26 33.33L486.75 34.76L494.25 36.25L501.76 37.8L509.27 39.42L516.79 41.11L524.31 42.85L531.84 44.66L539.38 46.53L546.92 48.47L554.46 50.47L562.01 52.54L569.57 54.66L577.13 56.85L584.7 59.11L592.27 61.43L599.85 63.81L607.44 66.25L615.03 68.76L615.47 79.36L615.8 89.86L616.04 100.28L616.16 110.6L616.19 120.84L616.1 130.98L615.92 141.04L615.63 151L615.23 160.87L614.73 170.66L614.13 180.35L613.42 189.95L612.6 199.46L611.68 208.88L610.66 218.21L609.53 227.46L608.3 236.61L606.96 245.67L605.52 254.63L603.97 263.51L602.32 272.3L600.56 281L598.7 289.61L596.73 298.13L594.66 306.55L592.49 314.89L590.21 323.14L587.83 331.29L585.34 339.36L582.74 347.33L580.04 355.22L577.24 363.01L574.33 370.72L571.32 378.33L568.2 385.86L564.98 393.29L561.66 400.63L558.22 407.88L554.69 415.05L551.05 422.12L549.49 425.05L547.83 428.09L546.07 431.21L544.22 434.43L542.28 437.74L540.23 441.13L538.08 444.6L535.83 448.15L533.48 451.78L531.02 455.48L528.46 459.25L525.79 463.08L523.01 466.98L520.13 470.94L517.13 474.95L514.02 479.02L510.8 483.14L507.47 487.31L504.02 491.52L500.45 495.77L496.76 500.07L492.96 504.39L489.04 508.75L484.99 513.14L480.82 517.55L476.53 521.99L472.11 526.44L467.56 530.91L462.89 535.4L458.09 539.9L453.16 544.4L448.09 548.91L442.89 553.41L437.56 557.92L432.1 562.42L426.5 566.91L420.76 571.39L414.88 575.86L408.86 580.31L402.7 584.74L400.88 586.01L399.04 587.27L397.19 588.5L395.31 589.73L393.42 590.93L391.51 592.12L389.58 593.28L387.64 594.43L385.67 595.57L383.69 596.68L381.69 597.78L379.67 598.86L377.63 599.93L375.58 600.97L373.51 602L371.41 603.01L369.3 604.01L367.18 604.98L365.03 605.94L362.86 606.88L360.68 607.81L358.48 608.71L356.26 609.6L354.02 610.48L351.77 611.33L349.49 612.17L347.2 612.98L344.89 613.79L342.56 614.57L340.22 615.34L337.85 616.09L335.47 616.82L333.07 617.53L330.65 618.23L328.21 618.91L325.75 619.57L323.28 620.21L320.79 620.84L318.28 621.45L315.75 622.04L313 621.11L310.27 620.17L307.57 619.22L304.9 618.27L302.25 617.3L299.62 616.32L297.02 615.33L294.45 614.33L291.89 613.32L289.37 612.31L286.87 611.28L284.39 610.24L281.94 609.19L279.52 608.14L277.12 607.07L274.74 605.99L272.39 604.91L270.07 603.81L267.77 602.7L265.49 601.59L263.24 600.46L261.02 599.33L258.82 598.18L256.64 597.03L254.49 595.86L252.37 594.69L250.27 593.5L248.19 592.31L246.14 591.1L244.11 589.89L242.11 588.66L240.14 587.43L238.19 586.18L236.26 584.93L234.36 583.67L232.49 582.39L230.64 581.11L228.81 579.81L227.01 578.51L225.24 577.2L219.24 572.66L213.41 568.13L207.74 563.61L202.22 559.11L196.85 554.61L191.64 550.13L186.57 545.67L181.65 541.23L176.87 536.82L172.23 532.42L167.74 528.05L163.38 523.72L159.15 519.41L155.06 515.13L151.09 510.89L147.26 506.68L143.55 502.52L139.96 498.39L136.5 494.31L133.15 490.27L129.92 486.28L126.8 482.34L123.8 478.44L120.9 474.61L118.11 470.82L115.43 467.1L112.85 463.43L110.37 459.83L107.99 456.29L105.7 452.81L103.51 449.4L101.41 446.06L99.4 442.8L97.47 439.61L95.63 436.49L93.88 433.45L92.2 430.49L90.6 427.62L89.07 424.82L87.62 422.12L84 415.15L80.48 408.09L77.06 400.94L73.75 393.69L70.55 386.34L67.46 378.9L64.47 371.36L61.58 363.72L58.81 355.99L56.13 348.16L53.57 340.24L51.11 332.22L48.76 324.11L46.51 315.9L44.37 307.59L42.33 299.19L40.4 290.69L38.58 282.09L36.86 273.4L35.25 264.62L33.75 255.74L32.35 246.76L31.06 237.68L29.87 228.52L28.79 219.25L27.81 209.89L26.95 200.43L26.18 190.88L25.53 181.23L24.98 171.48L24.53 161.64L24.19 151.71L23.96 141.67L23.83 131.55L23.81 121.32L23.9 111L24.09 100.58L24.39 90.07L24.79 79.46L25.3 68.76L32.46 66.25L39.61 63.81L46.78 61.43L53.95 59.11L61.12 56.85L68.31 54.66L75.49 52.54L82.68 50.47L89.88 48.47L97.09 46.53L104.29 44.66L111.51 42.85L118.73 41.11L125.95 39.42L133.18 37.8L140.42 36.25L147.66 34.76L154.91 33.33L162.16 31.96L169.42 30.66L176.68 29.42L183.95 28.25L191.23 27.14L198.51 26.09L205.79 25.1L213.09 24.18L220.38 23.33L227.69 22.53L234.99 21.8L242.31 21.13L249.63 20.53L256.95 19.99L264.28 19.52L271.62 19.1L278.96 18.75L286.3 18.47L293.66 18.25L301.01 18.09L308.38 17.99L315.75 17.96L323.12 17.99L330.5 18.09ZM303.16 91.29L294.86 92.13L286.65 93.3L278.56 94.79L270.57 96.59L262.71 98.7L254.97 101.11L247.37 103.81L239.91 106.8L232.59 110.07L225.43 113.61L218.42 117.41L211.58 121.48L204.92 125.8L198.44 130.36L192.14 135.17L186.04 140.21L180.13 145.47L174.43 150.96L168.95 156.65L163.69 162.56L158.65 168.66L153.84 174.96L149.28 181.44L144.96 188.11L140.89 194.94L137.08 201.95L133.54 209.11L130.28 216.43L127.29 223.89L124.59 231.5L122.18 239.23L120.07 247.1L118.27 255.08L116.78 263.18L115.61 271.38L114.76 279.68L114.25 288.08L114.08 296.57L114.25 305.05L114.76 313.45L115.61 321.75L116.78 329.96L118.27 338.05L120.07 346.04L122.18 353.9L124.59 361.64L127.29 369.24L130.28 376.7L133.54 384.02L137.08 391.18L140.89 398.19L144.96 405.02L149.28 411.69L153.84 418.17L158.65 424.47L163.69 430.57L168.95 436.48L174.43 442.17L180.13 447.66L186.04 452.92L192.14 457.96L198.44 462.77L204.92 467.33L211.58 471.65L218.42 475.72L225.43 479.52L232.59 483.06L239.91 486.33L247.37 489.32L254.97 492.02L262.71 494.43L270.57 496.54L278.56 498.34L286.65 499.83L294.86 501L303.16 501.84L311.56 502.36L320.04 502.53L328.53 502.36L336.92 501.84L345.23 501L353.43 499.83L361.53 498.34L369.51 496.54L377.38 494.43L385.11 492.02L392.72 489.32L400.18 486.33L407.5 483.06L414.66 479.52L421.66 475.72L428.5 471.65L435.16 467.33L441.65 462.77L447.95 457.96L454.05 452.92L459.95 447.66L465.65 442.17L471.14 436.48L476.4 430.57L481.44 424.47L486.24 418.17L490.81 411.69L495.13 405.02L499.19 398.19L503 391.18L506.54 384.02L509.81 376.7L512.8 369.24L515.5 361.64L517.91 353.9L520.01 346.04L521.82 338.05L522.39 334.91L469.49 334.91L468.14 339.93L466.35 345.69L464.33 351.36L462.11 356.92L459.67 362.38L457.03 367.71L454.2 372.93L451.16 378.03L447.95 383L444.54 387.83L440.96 392.52L437.21 397.07L433.28 401.47L429.2 405.72L424.95 409.81L420.55 413.73L416 417.48L411.31 421.07L406.47 424.47L401.51 427.69L396.41 430.72L391.19 433.56L385.85 436.19L380.4 438.63L374.84 440.86L369.17 442.87L363.4 444.66L357.54 446.24L351.59 447.58L345.56 448.69L339.44 449.56L333.25 450.19L327 450.57L320.67 450.7L314.35 450.57L308.09 450.19L301.9 449.56L295.79 448.69L289.75 447.58L283.8 446.24L277.94 444.66L272.17 442.87L266.51 440.86L260.95 438.63L255.49 436.19L250.15 433.56L244.93 430.72L239.84 427.69L234.87 424.47L230.04 421.07L225.35 417.48L220.8 413.73L216.4 409.81L212.15 405.72L208.06 401.47L204.14 397.07L200.38 392.52L196.8 387.83L193.4 383L190.18 378.03L187.15 372.93L184.31 367.71L181.67 362.38L179.24 356.92L177.01 351.36L175 345.69L173.2 339.93L171.63 334.07L170.29 328.12L169.18 322.08L168.31 315.97L167.68 309.78L167.3 303.52L167.17 297.2L167.3 290.87L167.68 284.61L168.31 278.42L169.18 272.31L170.29 266.27L171.63 260.32L173.2 254.46L175 248.7L177.01 243.03L179.24 237.47L181.67 232.01L184.31 226.68L187.15 221.46L190.18 216.36L193.4 211.39L196.8 206.56L200.38 201.87L204.14 197.32L208.06 192.92L212.15 188.67L216.4 184.58L220.8 180.66L225.35 176.91L230.04 173.32L234.87 169.92L239.84 166.7L244.93 163.67L250.15 160.83L255.49 158.2L260.95 155.76L266.51 153.53L272.17 151.52L277.94 149.73L283.8 148.15L289.75 146.81L295.79 145.7L301.9 144.83L308.09 144.2L314.35 143.82L320.67 143.69L327 143.82L333.25 144.2L339.44 144.83L345.56 145.7L351.59 146.81L357.54 148.15L363.4 149.73L369.17 151.52L374.84 153.53L380.4 155.76L385.85 158.2L391.19 160.83L396.41 163.67L401.51 166.7L406.47 169.92L411.31 173.32L416 176.91L420.55 180.66L424.95 184.58L429.2 188.67L433.28 192.92L437.21 197.32L440.96 201.87L444.54 206.56L447.95 211.39L451.16 216.36L454.2 221.46L457.03 226.68L459.67 232.01L462.11 237.47L464.33 243.03L466.35 248.7L468.14 254.46L469.71 260.32L469.85 260.92L522.89 260.92L521.82 255.08L520.01 247.1L517.91 239.23L515.5 231.5L512.8 223.89L509.81 216.43L506.54 209.11L503 201.95L499.19 194.94L495.13 188.11L490.81 181.44L486.24 174.96L481.44 168.66L476.4 162.56L471.14 156.65L465.65 150.96L459.95 145.47L454.05 140.21L447.95 135.17L441.65 130.36L435.16 125.8L428.5 121.48L421.66 117.41L414.66 113.61L407.5 110.07L400.18 106.8L392.72 103.81L385.11 101.11L377.38 98.7L369.51 96.59L361.53 94.79L353.43 93.3L345.23 92.13L336.92 91.29L328.53 90.78L320.04 90.6L311.56 90.78L303.16 91.29ZM314.2 233.73L311.67 233.98L309.17 234.34L306.7 234.79L304.27 235.34L301.87 235.99L299.51 236.72L297.42 237.46L297.63 237.67L298.48 238.59L299.3 239.55L300.07 240.53L300.81 241.55L301.51 242.6L302.17 243.67L302.79 244.77L303.36 245.9L303.89 247.06L304.38 248.24L304.82 249.44L305.21 250.66L305.55 251.91L305.84 253.17L306.09 254.45L306.28 255.75L306.41 257.07L306.5 258.4L306.53 259.75L306.5 261.09L306.41 262.42L306.28 263.74L306.09 265.04L305.84 266.32L305.55 267.59L305.21 268.83L304.82 270.06L304.38 271.26L303.89 272.44L303.36 273.59L302.79 274.72L302.17 275.82L301.51 276.9L300.81 277.94L300.07 278.96L299.3 279.95L298.48 280.9L297.63 281.82L296.74 282.71L295.82 283.56L294.87 284.38L293.88 285.16L292.86 285.9L291.82 286.6L290.74 287.25L289.64 287.87L288.51 288.45L287.35 288.98L286.18 289.46L284.97 289.9L283.75 290.29L282.51 290.63L281.24 290.93L279.96 291.17L278.66 291.36L277.34 291.5L276.01 291.58L274.66 291.61L273.32 291.58L271.99 291.5L270.67 291.36L269.37 291.17L268.09 290.93L266.82 290.63L265.58 290.29L264.36 289.9L263.15 289.46L261.98 288.98L260.82 288.45L259.69 287.87L258.59 287.25L257.51 286.6L257.34 286.48L257.03 288.62L256.77 291.15L256.62 293.71L256.56 296.3L256.62 298.89L256.77 301.45L257.03 303.98L257.39 306.48L257.84 308.95L258.39 311.38L259.03 313.78L259.77 316.14L260.59 318.45L261.5 320.73L262.5 322.96L263.58 325.14L264.74 327.28L265.98 329.36L267.29 331.39L268.68 333.37L270.15 335.29L271.69 337.15L273.29 338.95L274.96 340.69L276.7 342.36L278.5 343.96L280.36 345.5L282.28 346.96L284.25 348.35L286.29 349.67L288.37 350.91L290.51 352.07L292.69 353.15L294.92 354.15L297.19 355.06L299.51 355.88L301.87 356.61L304.27 357.26L306.7 357.81L309.17 358.26L311.67 358.62L314.2 358.87L316.76 359.03L319.35 359.08L321.93 359.03L324.49 358.87L327.02 358.62L329.52 358.26L331.99 357.81L334.43 357.26L336.82 356.61L339.18 355.88L341.5 355.06L343.77 354.15L346.01 353.15L348.19 352.07L350.32 350.91L352.41 349.67L354.44 348.35L356.42 346.96L358.33 345.5L360.2 343.96L362 342.36L363.73 340.69L365.4 338.95L367.01 337.15L368.54 335.29L370.01 333.37L371.4 331.39L372.72 329.36L373.96 327.28L375.12 325.14L376.2 322.96L377.19 320.73L378.1 318.45L378.93 316.14L379.66 313.78L380.3 311.38L380.85 308.95L381.31 306.48L381.66 303.98L381.92 301.45L382.08 298.89L382.13 296.3L382.08 293.71L381.92 291.15L381.66 288.62L381.31 286.12L380.85 283.65L380.3 281.22L379.66 278.82L378.93 276.47L378.1 274.15L377.19 271.87L376.2 269.64L375.12 267.46L373.96 265.32L372.72 263.24L371.4 261.21L370.01 259.23L368.54 257.31L367.01 255.45L365.4 253.65L363.73 251.92L362 250.24L360.2 248.64L358.33 247.1L356.42 245.64L354.44 244.25L352.41 242.93L350.32 241.69L348.19 240.53L346.01 239.45L343.77 238.46L341.5 237.54L339.18 236.72L336.82 235.99L334.43 235.34L331.99 234.79L329.52 234.34L327.02 233.98L324.49 233.73L321.93 233.57L319.35 233.52L316.76 233.57L314.2 233.73Z","id":"fITBbomu"}})]),_c('g',[_c('g',[_c('g',[_c('g',[_c('use',{attrs:{"xlink:href":"#fITBbomu","opacity":"1","fill":"#ffffff","fill-opacity":"1"}}),_c('g',[_c('use',{attrs:{"xlink:href":"#fITBbomu","opacity":"1","fill-opacity":"1","stroke":"#000000","stroke-width":"0","stroke-opacity":"1"}})])])])])])])]:(_vm.icon === 'location')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])]:(_vm.icon === 'network')?[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill-opacity":".3","d":"M2 22h20V2z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M17 7L2 22h15z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])]:(_vm.icon === 'dvr')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z"}})])]:(_vm.icon === 'person')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])]:(_vm.icon === 'contentCopy')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"}})])]:(_vm.icon === 'error')?[_c('svg',{attrs:{"fill":"#000000","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"}})])]:(_vm.icon === 'warning')?[_c('svg',{attrs:{"fill":"#000000","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"}})])]:(_vm.icon === 'verifiedUser')?[_c('svg',{attrs:{"fill":"#000000","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"}})])]:(_vm.icon === 'notificationsActive')?[_c('svg',{attrs:{"fill":"#000000","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z"}})])]:(_vm.icon === 'notifications')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"}})])]:(_vm.icon === 'list')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])]:(_vm.icon === 'close')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])]:(_vm.icon === 'face')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])]:(_vm.icon === 'pause')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6 19h4V5H6v14zm8-14v14h4V5h-4z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])]:(_vm.icon === 'info')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"}})])]:(_vm.icon === 'videocam' || _vm.icon === 'camera')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"}})])]:(_vm.icon === 'refresh')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])]:(_vm.icon === 'volumeOff')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])]:(_vm.icon === 'volumeUp')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])]:(_vm.icon === 'play')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8 5v14l11-7z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])]:(_vm.icon === 'forward10')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('defs',[_c('path',{attrs:{"d":"M24 24H0V0h24v24z","id":"a"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"b"}},[_c('use',{attrs:{"overflow":"visible","xlink:href":"#a"}})]),_vm._v(" "),_c('path',{attrs:{"clip-path":"url(#b)","d":"M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.8 3H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"}})])]:(_vm.icon === 'replay10')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('defs',[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","id":"a"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"b"}},[_c('use',{attrs:{"overflow":"visible","xlink:href":"#a"}})]),_vm._v(" "),_c('path',{attrs:{"clip-path":"url(#b)","d":"M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.1 11H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1c.2.1.3.2.5.3s.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"}})])]:(_vm.icon === 'arrowDropDown')?[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M7 10l5 5 5-5z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])]:(_vm.icon === 'arrowUp')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])]:(_vm.icon === 'arrowDown')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0-.75h24v24H0z","fill":"none"}})])]:(_vm.icon === 'outlinePerson')?[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])]:(_vm.icon === 'outlineLock')?[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z"}}),_c('path',{attrs:{"opacity":".87","d":"M0 0h24v24H0V0z"}})]),_c('path',{attrs:{"d":"M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"}})])]:(_vm.icon === 'outlineMail')?[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h24v24H0V0z"}}),_c('path',{attrs:{"d":"M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 4.99L4 6h16zm0 12H4V8l8 5 8-5v10z"}})])]:(_vm.icon === 'menu')?[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"}})])]:(_vm.icon === 'mail')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])]:(_vm.icon === 'map')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])]:(_vm.icon === 'phoneSpeaker')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0zm0 0h24v24H0V0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41C17.76 2.23 15.02 1 12 1zm2.86 9.01L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13zM15 20H9v-8h6v8z"}})])]:(_vm.icon === 'dashboard')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"}})])]:(_vm.icon === 'store')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"}})])]:(_vm.icon === 'zoomOut')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"}})])]:(_vm.icon === 'zoomIn')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"}})])]:(_vm.icon === 'search')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])]:(_vm.icon === 'phoneMessage')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM12 3v10l3-3h6V3h-9z"}})])]:(_vm.icon === 'replay')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"}})])]:(_vm.icon === 'mic')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])]:(_vm.icon === 'business')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"}})])]:(_vm.icon === 'people')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"}})])]:(_vm.icon === 'firstPage')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M24 24H0V0h24v24z","fill":"none"}})])]:(_vm.icon === 'lastPage')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"none"}})])]:(_vm.icon === 'before')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])]:(_vm.icon === 'next')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])]:(_vm.icon === 'link')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"}})])]:(_vm.icon === 'idcard')?[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M21 8V7l-3 2-3-2v1l3 2 3-2zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z"}})])]:(_vm.icon === 'spinnerTail')?[_c('svg',{attrs:{"width":"38","height":"38","viewBox":"0 0 38 38","xmlns":"http://www.w3.org/2000/svg"}},[_c('defs',[_c('linearGradient',{attrs:{"x1":"8.042%","y1":"0%","x2":"65.682%","y2":"23.865%","id":"a"}},[_c('stop',{attrs:{"stop-color":"#fff","stop-opacity":"0","offset":"0%"}}),_vm._v(" "),_c('stop',{attrs:{"stop-color":"#fff","stop-opacity":".631","offset":"63.146%"}}),_vm._v(" "),_c('stop',{attrs:{"stop-color":"#fff","offset":"100%"}})],1)],1),_vm._v(" "),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"transform":"translate(1 1)"}},[_c('path',{attrs:{"d":"M36 18c0-9.94-8.06-18-18-18","id":"Oval-2","stroke":"url(#a)","stroke-width":"2"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","from":"0 18 18","to":"360 18 18","dur":"0.9s","repeatCount":"indefinite"}})],1),_vm._v(" "),_c('circle',{attrs:{"fill":"#fff","cx":"36","cy":"18","r":"1"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","from":"0 18 18","to":"360 18 18","dur":"0.9s","repeatCount":"indefinite"}})],1)])])])]:(_vm.icon === 'spinnerBars')?[_c('svg',{attrs:{"width":"135","height":"140","viewBox":"0 0 135 140","xmlns":"http://www.w3.org/2000/svg","fill":"#fff"}},[_c('rect',{attrs:{"y":"10","width":"15","height":"120","rx":"6"}},[_c('animate',{attrs:{"attributeName":"height","begin":"0.5s","dur":"1s","values":"120;110;100;90;80;70;60;50;40;140;120","calcMode":"linear","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"y","begin":"0.5s","dur":"1s","values":"10;15;20;25;30;35;40;45;50;0;10","calcMode":"linear","repeatCount":"indefinite"}})]),_vm._v(" "),_c('rect',{attrs:{"x":"30","y":"10","width":"15","height":"120","rx":"6"}},[_c('animate',{attrs:{"attributeName":"height","begin":"0.25s","dur":"1s","values":"120;110;100;90;80;70;60;50;40;140;120","calcMode":"linear","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"y","begin":"0.25s","dur":"1s","values":"10;15;20;25;30;35;40;45;50;0;10","calcMode":"linear","repeatCount":"indefinite"}})]),_vm._v(" "),_c('rect',{attrs:{"x":"60","width":"15","height":"140","rx":"6"}},[_c('animate',{attrs:{"attributeName":"height","begin":"0s","dur":"1s","values":"120;110;100;90;80;70;60;50;40;140;120","calcMode":"linear","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"y","begin":"0s","dur":"1s","values":"10;15;20;25;30;35;40;45;50;0;10","calcMode":"linear","repeatCount":"indefinite"}})]),_vm._v(" "),_c('rect',{attrs:{"x":"90","y":"10","width":"15","height":"120","rx":"6"}},[_c('animate',{attrs:{"attributeName":"height","begin":"0.25s","dur":"1s","values":"120;110;100;90;80;70;60;50;40;140;120","calcMode":"linear","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"y","begin":"0.25s","dur":"1s","values":"10;15;20;25;30;35;40;45;50;0;10","calcMode":"linear","repeatCount":"indefinite"}})]),_vm._v(" "),_c('rect',{attrs:{"x":"120","y":"10","width":"15","height":"120","rx":"6"}},[_c('animate',{attrs:{"attributeName":"height","begin":"0.5s","dur":"1s","values":"120;110;100;90;80;70;60;50;40;140;120","calcMode":"linear","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"y","begin":"0.5s","dur":"1s","values":"10;15;20;25;30;35;40;45;50;0;10","calcMode":"linear","repeatCount":"indefinite"}})])])]:(_vm.icon === 'spinnerOval')?[_c('svg',{attrs:{"width":"38","height":"38","viewBox":"0 0 38 38","xmlns":"http://www.w3.org/2000/svg","stroke":"#fff"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"transform":"translate(1 1)","stroke-width":"2"}},[_c('circle',{attrs:{"stroke-opacity":".5","cx":"18","cy":"18","r":"18"}}),_vm._v(" "),_c('path',{attrs:{"d":"M36 18c0-9.94-8.06-18-18-18"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","from":"0 18 18","to":"360 18 18","dur":"1s","repeatCount":"indefinite"}})],1)])])])]:(_vm.icon === 'spinnerPuff')?[_c('svg',{attrs:{"width":"44","height":"44","viewBox":"0 0 44 44","xmlns":"http://www.w3.org/2000/svg","stroke":"#fff"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke-width":"2"}},[_c('circle',{attrs:{"cx":"22","cy":"22","r":"1"}},[_c('animate',{attrs:{"attributeName":"r","begin":"0s","dur":"1.8s","values":"1; 20","calcMode":"spline","keyTimes":"0; 1","keySplines":"0.165, 0.84, 0.44, 1","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"stroke-opacity","begin":"0s","dur":"1.8s","values":"1; 0","calcMode":"spline","keyTimes":"0; 1","keySplines":"0.3, 0.61, 0.355, 1","repeatCount":"indefinite"}})]),_vm._v(" "),_c('circle',{attrs:{"cx":"22","cy":"22","r":"1"}},[_c('animate',{attrs:{"attributeName":"r","begin":"-0.9s","dur":"1.8s","values":"1; 20","calcMode":"spline","keyTimes":"0; 1","keySplines":"0.165, 0.84, 0.44, 1","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"stroke-opacity","begin":"-0.9s","dur":"1.8s","values":"1; 0","calcMode":"spline","keyTimes":"0; 1","keySplines":"0.3, 0.61, 0.355, 1","repeatCount":"indefinite"}})])])])]:(_vm.icon === 'arrow-left')?[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 20","width":"18px"}},[_c('path',{attrs:{"d":"M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"}})])]:(_vm.icon === 'eye')?[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":"18px","fill":"var(--blue-gray-high)"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"}})])]:(_vm.icon === 'eye-off')?[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":"18px","fill":"var(--blue-gray-high)"}},[_c('path',{attrs:{"d":"M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"}})])]:(_vm.icon === 'check')?[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","enable-background":"new 0 0 24 24","viewBox":"0 0 24 24","width":"18px","fill":"var(--success)"}},[_c('rect',{attrs:{"fill":"none","height":"24","width":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M22,5.18L10.59,16.6l-4.24-4.24l1.41-1.41l2.83,2.83l10-10L22,5.18z M19.79,10.22C19.92,10.79,20,11.39,20,12 c0,4.42-3.58,8-8,8s-8-3.58-8-8c0-4.42,3.58-8,8-8c1.58,0,3.04,0.46,4.28,1.25l1.44-1.44C16.1,2.67,14.13,2,12,2C6.48,2,2,6.48,2,12 c0,5.52,4.48,10,10,10s10-4.48,10-10c0-1.19-0.22-2.33-0.6-3.39L19.79,10.22z"}})])]:[_c('svg',{attrs:{"fill":"#FFFFFF","height":"48","viewBox":"0 0 24 24","width":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M24 24H0V0h24v24z","fill":"none"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"12","cy":"12","r":"8"}})])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navi_vue__ = __webpack_require__(59);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c9404f5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navi_vue__ = __webpack_require__(133);
function injectStyle (ssrContext) {
  __webpack_require__(132)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c9404f5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c9404f5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navi"},[_c('div',{staticClass:"user-container"},[_c('div',{staticClass:"profile-picture"},[(_vm.myProfilePictureUrl)?[_c('img',{attrs:{"src":_vm.myProfilePictureUrl}})]:[_c('comp-icon',{attrs:{"icon":'person',"width":48}})]],2),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.myName))])]),_vm._v(" "),(_vm.myDealerHasPendingRegistration && _vm.iAmOwnerOfMyDealer && !_vm.isIPAuth)?_c('div',{staticClass:"navi-item alarm",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.onClickDealerRegistration()}}},[_vm._v("Click to complete your dealer registration")]):_vm._e(),_vm._v(" "),(_vm.isToResetPassword && !_vm.isIPAuth)?_c('div',{staticClass:"navi-item alarm",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.onClickChangePassword()}}},[_vm._v("Please change your password")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"navi-item",class:{
    selected: _vm.getCurrentRouteName() === 'Profile'
  },attrs:{"ontouchstart":""},on:{"click":function($event){_vm.goTo('Profile')}}},[_vm._v("Profile")]),_vm._v(" "),(!_vm.isIPAuth)?_c('div',{staticClass:"navi-item",class:{
    selected: _vm.getCurrentRouteName() === 'Security'
  },attrs:{"ontouchstart":""},on:{"click":function($event){_vm.goTo('Security')}}},[_vm._v("Two-Factor Authentication")]):_vm._e(),_vm._v(" "),(_vm.hasMyDevices && !_vm.isIPAuth)?_c('div',{staticClass:"navi-item",class:{
    selected: _vm.getCurrentRouteName() === 'Devices'
  },attrs:{"ontouchstart":""},on:{"click":function($event){_vm.goTo('Devices')}}},[_vm._v("Devices")]):_vm._e(),_vm._v(" "),(_vm.hasMyAccessHistory && !_vm.isIPAuth)?_c('div',{staticClass:"navi-item",class:{
    selected: _vm.getCurrentRouteName() === 'AccessHistory'
  },attrs:{"ontouchstart":""},on:{"click":function($event){_vm.goTo('AccessHistory')}}},[_vm._v("Access History")]):_vm._e(),_vm._v(" "),(_vm.hasMySites && !_vm.isIPAuth)?_c('div',{staticClass:"navi-item",class:{
    selected: _vm.getCurrentRouteName() === 'CustomerTools'
  },attrs:{"ontouchstart":""},on:{"click":function($event){_vm.goTo('CustomerTools')}}},[_vm._v("Customer Tools")]):_vm._e(),_vm._v(" "),(_vm.hasMyDealer)?_c('div',{staticClass:"navi-item",class:{
    selected: _vm.getCurrentRouteName() === 'DealerTools'
  },attrs:{"ontouchstart":""},on:{"click":function($event){_vm.goTo('DealerTools')}}},[_vm._v("Dealer Tools")]):_vm._e(),_vm._v(" "),(_vm.isCHeKTAdmin && !_vm.isIPAuth)?_c('div',{staticClass:"navi-item",class:{
    selected: _vm.getCurrentRouteName() === 'AdminTools'
  },attrs:{"ontouchstart":""},on:{"click":function($event){_vm.goTo('AdminTools')}}},[_vm._v("Admin Tools")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"navi-item",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.onClickLogout()}}},[_vm._v("Logout")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__ = __webpack_require__(60);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9295222_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__ = __webpack_require__(136);
function injectStyle (ssrContext) {
  __webpack_require__(135)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d9295222"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9295222_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications scrollable -y scrollbar-hidden"},[_c('transition-group',{attrs:{"name":"fade","mode":"out-in"}},_vm._l((_vm.toasterItems),function(item,key){return _c('div',{key:key,staticClass:"toaster-wrapper"},[_c('div',{staticClass:"toaster",class:{
        'success': item.status === 'success',
        'info': item.status === 'info',
        'warning': item.status === 'warning',
        'error': item.status === 'error',
      },on:{"click":function($event){_vm.onClickToaster(key)}}},[_c('div',{staticClass:"message"},[_vm._v(_vm._s(item.message))])])])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalChangeName_vue__ = __webpack_require__(61);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4de3b478_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalChangeName_vue__ = __webpack_require__(141);
function injectStyle (ssrContext) {
  __webpack_require__(138)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4de3b478"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalChangeName_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4de3b478_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalChangeName_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-modal"},[_c('div',{staticClass:"modal-background",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.onClickBackground()}}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{on:{"closeModalRequest":function($event){_vm.closeModalRequest()}}},[_c('div',{staticClass:"modal-change-name scrollable -y"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("Change Name")])]),_vm._v(" "),_c('form',{staticClass:"body",on:{"submit":_vm.onClickSubmit}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"label"},[_vm._v("First name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.firstName),expression:"firstName"}],ref:"first-name",attrs:{"id":"first-name","type":"text"},domProps:{"value":(_vm.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.firstName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"label"},[_vm._v("Last name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lastName),expression:"lastName"}],attrs:{"id":"last-name","type":"text"},domProps:{"value":(_vm.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lastName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"action-btns flex-end"},[_c('div',{staticClass:"action-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.closeModalRequest()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('input',{staticClass:"action-btn blue",attrs:{"id":"update-name","type":"submit","value":"Update"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalChangeIpUserName_vue__ = __webpack_require__(63);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b38e65c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalChangeIpUserName_vue__ = __webpack_require__(144);
function injectStyle (ssrContext) {
  __webpack_require__(143)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b38e65c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalChangeIpUserName_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b38e65c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalChangeIpUserName_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{on:{"closeModalRequest":function($event){_vm.closeModalRequest()}}},[_c('div',{staticClass:"modal-change-ip-user-name scrollable -y"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("Change Name")])]),_vm._v(" "),_c('form',{staticClass:"body",on:{"submit":_vm.onClickSubmit}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"label"},[_vm._v("User name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.firstName),expression:"firstName"}],ref:"first-name",attrs:{"id":"first-name","type":"text"},domProps:{"value":(_vm.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.firstName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"action-btns"},[_c('input',{staticClass:"action-btn blue",attrs:{"id":"update-name","type":"submit","value":"Update"}}),_vm._v(" "),_c('div',{staticClass:"action-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.closeModalRequest()}}},[_vm._v("Cancel")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalChangePassword_vue__ = __webpack_require__(64);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09eee2f8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalChangePassword_vue__ = __webpack_require__(147);
function injectStyle (ssrContext) {
  __webpack_require__(146)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09eee2f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalChangePassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09eee2f8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalChangePassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{on:{"closeModalRequest":function($event){_vm.closeModalRequest()}}},[_c('div',{staticClass:"modal-change-password scrollable -y"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("Reset Your Password")]),_vm._v(" "),(_vm.isToResetPassword)?_c('div',{staticClass:"description"},[_vm._v("You have automatically generated password. We recommend you to change the password.")]):(_vm.lastPasswordReset)?_c('div',{staticClass:"description"},[_vm._v("You have reset your password at "+_vm._s(_vm.lastPasswordReset))]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"text","mode":"out-in","appear":""}},[(_vm.message)?_c('div',{staticClass:"message",class:{
        error: !_vm.isSuccess
      }},[_vm._v(_vm._s(_vm.message))]):_vm._e()]),_vm._v(" "),_c('form',{staticClass:"body",on:{"submit":_vm.onClickSubmit}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"action-btns flex-end"},[_c('div',{staticClass:"action-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.closeModalRequest()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('input',{staticClass:"action-btn blue",attrs:{"id":"update-new-password","type":"submit","value":"Request to reset your password"}})])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalChangeEmail_vue__ = __webpack_require__(65);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d8cb855_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalChangeEmail_vue__ = __webpack_require__(150);
function injectStyle (ssrContext) {
  __webpack_require__(149)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d8cb855"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalChangeEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d8cb855_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalChangeEmail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{on:{"closeModalRequest":function($event){_vm.closeModalRequest()}}},[_c('div',{staticClass:"modal-change-email scrollable -y"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("Change Account Email")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("Please double check the new email address before you making this request.")])]),_vm._v(" "),_c('transition',{attrs:{"name":"text","mode":"out-in","appear":""}},[(_vm.message)?_c('div',{staticClass:"message",class:{
        error: !_vm.isSuccess
      }},[_vm._v(_vm._s(_vm.message))]):_vm._e()]),_vm._v(" "),_c('form',{staticClass:"body",on:{"submit":_vm.onClickSubmit}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"label"},[_vm._v("Current email address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.myEmail),expression:"myEmail"}],attrs:{"id":"new-email","type":"email","disabled":""},domProps:{"value":(_vm.myEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.myEmail=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"label"},[_vm._v("New email address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newEmail),expression:"newEmail"}],ref:"new-email",attrs:{"id":"new-email","type":"email"},domProps:{"value":(_vm.newEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newEmail=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"action-btns flex-end"},[_c('div',{staticClass:"action-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.closeModalRequest()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('input',{staticClass:"action-btn blue",attrs:{"id":"change-email","type":"submit","value":"Request change"}})])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalEmailChanged_vue__ = __webpack_require__(66);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4153b298_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalEmailChanged_vue__ = __webpack_require__(153);
function injectStyle (ssrContext) {
  __webpack_require__(152)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4153b298"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalEmailChanged_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4153b298_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalEmailChanged_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{on:{"closeModalRequest":function($event){_vm.closeModalRequest()}}},[(_vm.oldEmail)?_c('div',{staticClass:"modal-email-changed scrollable -y"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("Your Account Email Changed")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("Please be aware that your account email has been changed.")])]),_vm._v(" "),_c('form',{staticClass:"body",on:{"submit":_vm.onClickSubmit}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"table"},[_c('div',{staticClass:"tr",staticStyle:{"background-color":"hsla(0, 0%, 75%, 1)"}},[_c('div',{staticClass:"td title"},[_vm._v("Old Email")]),_vm._v(" "),_c('div',{staticClass:"td"},[_vm._v(_vm._s(_vm.oldEmail))])]),_vm._v(" "),_c('div',{staticClass:"tr",staticStyle:{"background-color":"hsla(202, 100%, 40%, 1)"}},[_c('div',{staticClass:"td title"},[_vm._v("New Email")]),_vm._v(" "),_c('div',{staticClass:"td"},[_vm._v(_vm._s(_vm.myEmail))])])])]),_vm._v(" "),_c('div',{staticClass:"action-btns"},[_c('input',{staticClass:"action-btn blue",attrs:{"id":"email-changed-confirm","type":"submit","value":"Got it"}})])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalChangePhoto_vue__ = __webpack_require__(67);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d860e70_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalChangePhoto_vue__ = __webpack_require__(156);
function injectStyle (ssrContext) {
  __webpack_require__(155)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d860e70"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalChangePhoto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d860e70_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalChangePhoto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{on:{"closeModalRequest":function($event){_vm.closeModalRequest()}}},[_c('div',{staticClass:"modal-change-photo scrollable -y"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("Change Photo")])]),_vm._v(" "),_c('transition',{attrs:{"name":"flyInH","mode":"out-in"}},[(_vm.selectedTab === 'takePhoto')?_c('div',{key:'takePhoto',staticClass:"body"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"photo-container"},[_c('div',{ref:"webcam",staticClass:"profile-photo",style:({
              'display': _vm.newSnapshotURLFromCamera ? 'none' : null
            })}),_vm._v(" "),_c('div',{staticClass:"profile-photo",style:({
              'display': _vm.newSnapshotURLFromCamera ? null : 'none'
            })},[_c('img',{attrs:{"src":_vm.newSnapshotURLFromCamera}})])]),_vm._v(" "),_c('div',{staticClass:"action-btns column"},[(_vm.newSnapshotURLFromCamera)?[_c('div',{staticClass:"action-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.onClickTryAgain()}}},[_vm._v("Try again")]),_vm._v(" "),_c('div',{staticClass:"action-btn blue",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.onClickLooksGood()}}},[_vm._v("Looks good!")])]:[_c('div',{staticClass:"action-btn blue",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.takeSnapshot()}}},[_vm._v("Snap a photo")]),_vm._v(" "),_c('div',{staticClass:"action-btn disabled"},[_vm._v("Smile!")])],_vm._v(" "),_c('div',{staticClass:"action-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.goToUploadPhotoTab()}}},[_vm._v("Cancel")])],2)])]):_c('form',{key:'uploadPhoto',staticClass:"body",on:{"submit":_vm.onClickSubmit}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"photo-container"},[_c('div',{staticClass:"profile-photo"},[(!_vm.newSnapshotURL)?[(_vm.myProfilePictureUrl)?[_c('img',{attrs:{"src":_vm.myProfilePictureUrl}})]:[_c('div',{staticClass:"no-photo"},[_vm._v("No photo")])]]:[_c('img',{attrs:{"src":_vm.newSnapshotURL}})]],2)]),_vm._v(" "),_c('div',{staticClass:"action-btns flex-around"},[_c('div',{staticClass:"action-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.openFileBrowser()}}},[_vm._v("Choose")]),_vm._v(" "),_c('div',{staticClass:"action-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.goToTakePhotoTab()}}},[_vm._v("Take a photo")]),_vm._v(" "),_c('div',{staticClass:"action-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.onClickRemove()}}},[_vm._v("Remove")])]),_vm._v(" "),_c('div',{staticClass:"action-btns flex-end",staticStyle:{"border-top":"1px solid hsla(0, 100%, 0%, 0.1)"}},[_c('div',{staticClass:"action-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.closeModalRequest()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('input',{staticClass:"action-btn blue",attrs:{"id":"update-name","type":"submit","value":"Update"}})])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDealerRegistration_vue__ = __webpack_require__(68);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b77bd430_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalDealerRegistration_vue__ = __webpack_require__(183);
function injectStyle (ssrContext) {
  __webpack_require__(158)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b77bd430"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDealerRegistration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b77bd430_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalDealerRegistration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompAddressPicker_vue__ = __webpack_require__(69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b43b7da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompAddressPicker_vue__ = __webpack_require__(182);
function injectStyle (ssrContext) {
  __webpack_require__(160)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b43b7da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompAddressPicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b43b7da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompAddressPicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  getAddressOfGeoCode: function getAddressOfGeoCode(_ref) {
    var lat = _ref.lat,
        lng = _ref.lng;

    var apiPath = 'https://maps.googleapis.com/maps/api/geocode/json';
    var apiKey = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.googleMapAPIKey;
    apiPath += '?latlng=' + lat + ',' + lng;
    apiPath += '&key=' + apiKey;
    apiPath += '&channel=3';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(apiPath);
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-address-picker"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],ref:"searchInput",staticClass:"text-input",attrs:{"type":"text","placeholder":"Enter address"},domProps:{"value":(_vm.searchInput)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onEnterKey($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('div',{ref:"googleMap",staticClass:"map-container"}),_vm._v(" "),_c('div',{ref:"infowindowContent",staticClass:"infowindow-content"},[_c('span',{staticStyle:{"font-weight":"bold"},attrs:{"id":"place-name"}}),_c('br'),_vm._v(" "),_c('span',{attrs:{"id":"place-address"}})]),_vm._v(" "),_c('div',{staticClass:"close-btn",class:{
    active: _vm.place
  },on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.place ? 'Confirm' : 'Cancel'))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{on:{"closeModalRequest":function($event){_vm.closeModalRequest()}}},[_c('div',{staticClass:"modal-dealer-registration scrollable -y"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.myDealerHasPendingRegistration ? 'Register dealer' : 'Update dealer registration'))]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("You can modify any field below by yourself if you find any incorrect information. Please contact our "),_c('a',{attrs:{"href":"https://support.chekt.com","target":"_blank"}},[_vm._v("support")]),_vm._v(" if you need any help.")])]),_vm._v(" "),_c('transition',{attrs:{"name":"flyInH","mode":"out-in"}},[(_vm.selectedTab === 'addressPicker')?_c('div',{key:'addressPicker',staticClass:"body fixed"},[_c('comp-address-picker',{attrs:{"address":_vm.address1,"lat":_vm.lat,"lng":_vm.lng},on:{"onClose":_vm.onCloseAddressPicker}})],1):_c('form',{key:'registerDealer',staticClass:"body",on:{"submit":_vm.onClickSubmit}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"label"},[_vm._v("Company name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],attrs:{"id":"company-name","type":"text","placeholder":"Famous Alarm Systems"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"label"},[_vm._v("Company address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address1),expression:"address1"}],staticStyle:{"margin-bottom":"8px"},attrs:{"ontouchstart":"","id":"company-address1","type":"text","placeholder":"click to add address","readonly":""},domProps:{"value":(_vm.address1)},on:{"click":function($event){_vm.goToAddressPickerTab()},"input":function($event){if($event.target.composing){ return; }_vm.address1=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address2),expression:"address2"}],attrs:{"id":"company-address2","type":"text","placeholder":"(optional) e.g. Unit 511, 5th floor"},domProps:{"value":(_vm.address2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address2=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"label"},[_vm._v("Company main contact (phone)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],attrs:{"id":"company-main-contact-phone","type":"text","placeholder":"xxx-xxx-xxxx"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"label"},[_vm._v("Company main contact (email)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"id":"company-main-contact-email","type":"text","placeholder":"customercare@yourdomain.com"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"label"},[_vm._v("Dealer owner account (can't be modified)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.primaryAdminEmail),expression:"primaryAdminEmail"}],attrs:{"id":"primary-admin-email","type":"text","placeholder":"superadmin@yourdomain.com","disabled":""},domProps:{"value":(_vm.primaryAdminEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.primaryAdminEmail=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"action-btns flex-end"},[_c('div',{staticClass:"action-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.closeModalRequest()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('input',{staticClass:"action-btn blue",attrs:{"id":"register-dealer","type":"submit"},domProps:{"value":_vm.myDealerHasPendingRegistration ? 'Register' : 'Update'}})])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalOpenDealerPortal_vue__ = __webpack_require__(78);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e772d30_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalOpenDealerPortal_vue__ = __webpack_require__(186);
function injectStyle (ssrContext) {
  __webpack_require__(185)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e772d30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalOpenDealerPortal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e772d30_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalOpenDealerPortal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{on:{"closeModalRequest":function($event){_vm.closeModalRequest()}}},[_c('div',{staticClass:"modal-open-dealer-portal scrollable -y"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("Registration is completed")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("Do you want to open your dealer portal now?")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"action-btns flex-end"},[_c('div',{staticClass:"action-btn blue",attrs:{"id":"open-dealer-portal-go","ontouchstart":""},on:{"click":function($event){_vm.goToDealerPortal()}}},[_vm._v("Open dealer portal")]),_vm._v(" "),_c('div',{staticClass:"action-btn",attrs:{"id":"open-dealer-portal-cancel","ontouchstart":""},on:{"click":function($event){_vm.closeModalRequest()}}},[_vm._v("Cancel")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalOpenEnduserApp_vue__ = __webpack_require__(79);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330efc7d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalOpenEnduserApp_vue__ = __webpack_require__(189);
function injectStyle (ssrContext) {
  __webpack_require__(188)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-330efc7d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalOpenEnduserApp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330efc7d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalOpenEnduserApp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{on:{"closeModalRequest":function($event){_vm.closeModalRequest()}}},[_c('div',{staticClass:"modal-open-enduser-app scrollable -y"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("Registration is completed")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("Do you want to open your site now?")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"action-btns flex-end"},[_c('div',{staticClass:"action-btn blue",attrs:{"id":"open-dealer-portal-go","ontouchstart":""},on:{"click":function($event){_vm.goToEnduserApp()}}},[_vm._v("Open your site")]),_vm._v(" "),_c('div',{staticClass:"action-btn",attrs:{"id":"open-dealer-portal-cancel","ontouchstart":""},on:{"click":function($event){_vm.closeModalRequest()}}},[_vm._v("Cancel")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalLogout_vue__ = __webpack_require__(80);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17e3a543_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalLogout_vue__ = __webpack_require__(192);
function injectStyle (ssrContext) {
  __webpack_require__(191)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17e3a543"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalLogout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17e3a543_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalLogout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{on:{"closeModalRequest":function($event){_vm.closeModalRequest()}}},[_c('div',{staticClass:"modal-logout scrollable -y"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"action-btns"},[_c('div',{staticClass:"action-btn red",attrs:{"id":"logout-logout","ontouchstart":""},on:{"click":function($event){_vm.logout()}}},[_vm._v("Logout")]),_vm._v(" "),_c('div',{staticClass:"action-btn",attrs:{"id":"logout-cancel","ontouchstart":""},on:{"click":function($event){_vm.closeModalRequest()}}},[_vm._v("Cancel")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",class:{
  'menu-visible': _vm.isMenuOpen
}},[_c('div',{staticClass:"overlay",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.toggleMenu()}}}),_vm._v(" "),_c('div',{staticClass:"left "},[_c('navi',{on:{"onClickDealerRegistration":function($event){_vm.openDealerRegistrationModal()},"onClickChangePassword":function($event){_vm.openChangePasswordModal()},"onClickLogout":function($event){_vm.openLogoutModal()},"onClickMenu":function($event){_vm.onClickMenu()}}})],1),_vm._v(" "),_c('div',{staticClass:"right "},[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('router-view',{on:{"openChangePhotoModal":function($event){_vm.openChangePhotoModal()},"openChangeNameModal":function($event){_vm.openChangeNameModal()},"openChangeIPUserNameModal":function($event){_vm.openChangeIPUserNameModal()},"openChangeEmailModal":function($event){_vm.openChangeEmailModal()},"openChangeDealerInfoModal":function($event){_vm.openDealerRegistrationModal()},"openChangePasswordModal":function($event){_vm.openChangePasswordModal()}}})],1)],1),_vm._v(" "),_c('div',{staticClass:"menu-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.toggleMenu()}}},[_c('comp-icon',{attrs:{"icon":'menu',"width":25}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[(_vm.modals.openEnduserApp.isVisible)?_c('div',{staticClass:"modal-wrapper"},[_c('modal-open-enduser-app',{on:{"closeModalRequest":function($event){_vm.closeOpenEnduserAppModal()}}})],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[(_vm.modals.openDealerPortal.isVisible)?_c('div',{staticClass:"modal-wrapper"},[_c('modal-open-dealer-portal',{on:{"closeModalRequest":function($event){_vm.closeOpenDealerPortalModal()}}})],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[(_vm.modals.changePhoto.isVisible)?_c('div',{staticClass:"modal-wrapper"},[_c('modal-change-photo',{on:{"closeModalRequest":function($event){_vm.closeChangePhotoModal()}}})],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[(_vm.modals.changeName.isVisible)?_c('div',{staticClass:"modal-wrapper"},[_c('modal-change-name',{on:{"closeModalRequest":function($event){_vm.closeChangeNameModal()}}})],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[(_vm.modals.changeIPUserName.isVisible)?_c('div',{staticClass:"modal-wrapper"},[_c('modal-change-ip-user-name',{on:{"closeModalRequest":function($event){_vm.closeChangeIPUserNameModal()}}})],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[(_vm.modals.changeEmail.isVisible)?_c('div',{staticClass:"modal-wrapper"},[_c('modal-change-email',{on:{"closeModalRequest":function($event){_vm.closeChangeEmailModal()}}})],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[(_vm.modals.emailChanged.isVisible)?_c('div',{staticClass:"modal-wrapper"},[_c('modal-email-changed',{on:{"closeModalRequest":function($event){_vm.closeEmailChangedModal()}}})],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[(_vm.modals.changePassword.isVisible)?_c('div',{staticClass:"modal-wrapper"},[_c('modal-change-password',{on:{"closeModalRequest":function($event){_vm.closeChangePasswordModal()}}})],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[(_vm.modals.dealerRegistration.isVisible)?_c('div',{staticClass:"modal-wrapper"},[_c('modal-dealer-registration',{on:{"closeModalRequest":function($event){_vm.closeDealerRegistrationModal()}}})],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[(_vm.modals.logout.isVisible)?_c('div',{staticClass:"modal-wrapper"},[_c('modal-logout',{on:{"closeModalRequest":function($event){_vm.closeLogoutModal()}}})],1):_vm._e()]),_vm._v(" "),_c('notifications')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(81);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bd9e760_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(196);
function injectStyle (ssrContext) {
  __webpack_require__(195)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bd9e760"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bd9e760_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"title"},[_vm._v("Profile Photo")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"profile-picture"},[(_vm.myProfilePictureUrl)?[_c('img',{staticClass:"text-btn",attrs:{"src":_vm.myProfilePictureUrl,"ontouchstart":""},on:{"click":function($event){_vm.onClickChangePhoto()}}})]:[_c('comp-icon',{staticClass:"text-btn",attrs:{"icon":'person',"width":100,"ontouchstart":""},on:{"click":function($event){_vm.onClickChangePhoto()}}})]],2)])])]),_vm._v(" "),(!_vm.isIPAuth)?_c('div',{staticClass:"body"},[_c('div',{staticClass:"title"},[_vm._v("Full Name")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"info-container",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.onClickChangeName()}}},[_c('div',{staticClass:"text-btn"},[_vm._v("\n          "+_vm._s(_vm.myName)+"\n        ")])])])]):_vm._e(),_vm._v(" "),(_vm.isIPAuth)?_c('div',{staticClass:"body"},[_c('div',{staticClass:"title"},[_vm._v("IP User")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"info-container"},[_vm._v(_vm._s(_vm.ipAuthIP))]),_vm._v(" "),_c('div',{staticClass:"info-container"},[_vm._v("\n        "+_vm._s(_vm.myName)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"text-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.onClickChangeIPUserName()}}},[_vm._v("Change name")])])])]):_vm._e(),_vm._v(" "),(!_vm.isIPAuth)?_c('div',{staticClass:"body"},[_c('div',{staticClass:"title"},[_vm._v("Email Address")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"text-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.onClickChangeEmail()}}},[_vm._v(_vm._s(_vm.myEmail))])])])]):_vm._e(),_vm._v(" "),(!_vm.isIPAuth)?_c('div',{staticClass:"body"},[_c('div',{staticClass:"title"},[_vm._v("Password")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"text-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.onClickChangePassword()}}},[_c('div',{staticClass:"password"},[_vm._v("********************")])])])])]):_vm._e(),_vm._v(" "),(_vm.hasMyDealer)?_c('div',{staticClass:"body"},[_c('div',{staticClass:"title"},[_vm._v("My dealer")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"info-container"},[_c('div',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.myDealer.dealerName))]),_vm._v(" "),_c('div',{staticClass:"vertical-center",staticStyle:{"flex-wrap":"wrap"}},[_c('span',{staticClass:"badge blue"},[_vm._v(_vm._s(_vm.myDealerType))]),_vm._v(" "),_c('span',{staticClass:"badge blue"},[_vm._v("Owner: "+_vm._s(_vm.myDealer.ownerInfo.email))])]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.myDealer.locationInfo.address))]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.myDealer.contactInfo.email)+" / "+_vm._s(_vm.myDealer.contactInfo.phone))])]),_vm._v(" "),(_vm.iAmOwnerOfMyDealer)?_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"text-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.onClickChangeDealerInfo()}}},[_vm._v("Change registration information")])]):_vm._e()])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("Profile")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Devices_vue__ = __webpack_require__(82);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_646c07fa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Devices_vue__ = __webpack_require__(199);
function injectStyle (ssrContext) {
  __webpack_require__(198)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-646c07fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Devices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_646c07fa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Devices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"devices"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("Devices")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"info-container"},[_vm._v("\n        These are the devices being used by your account. If you click on Revoke Access, the refresh token will be revoked, forcing the user to re-login on the application. It is recommended to revoke access if you found an unknown device.\n      ")]),_vm._v(" "),_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"tr"},[_c('div',{staticClass:"th"},[_vm._v("Device")]),_vm._v(" "),_c('div',{staticClass:"th"},[_vm._v("Last access")]),_vm._v(" "),_c('div',{staticClass:"th"})]),_vm._v(" "),_c('div',{staticClass:"tr"},[_c('div',{staticClass:"td"},[_vm._v("Monitoring portal chrome")]),_vm._v(" "),_c('div',{staticClass:"td"},[_vm._v("October 29th, 2018")]),_vm._v(" "),_c('div',{staticClass:"td"},[_vm._v("Revoke Access")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccessHistory_vue__ = __webpack_require__(83);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8544cc8c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccessHistory_vue__ = __webpack_require__(202);
function injectStyle (ssrContext) {
  __webpack_require__(201)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8544cc8c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccessHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8544cc8c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccessHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"access-history"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("Access History")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"info-container"},[_vm._v("\n        You are currently accessing CHeKT from IP Address 61.84.46.228 in Kyunggi-do, Republic of Korea\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"info-container"},[_vm._v("\n        The following apps has accessed your account since Friday, August 3 2018\n      ")]),_vm._v(" "),_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"tr"},[_c('div',{staticClass:"th"},[_vm._v("App")]),_vm._v(" "),_c('div',{staticClass:"th"},[_vm._v("Accessed")]),_vm._v(" "),_c('div',{staticClass:"th"},[_vm._v("IP Address"),_c('br'),_vm._v("(Estimated Location)")])]),_vm._v(" "),_c('div',{staticClass:"tr"},[_c('div',{staticClass:"td"},[_vm._v("Monitoring Web")]),_vm._v(" "),_c('div',{staticClass:"td"},[_vm._v("2018-10-13T00:12:33")]),_vm._v(" "),_c('div',{staticClass:"td"},[_vm._v("61.84.46.228"),_c('br'),_vm._v("Kyunggi-do, Republic of Korea")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DealerTools_vue__ = __webpack_require__(84);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_622fcd5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DealerTools_vue__ = __webpack_require__(207);
function injectStyle (ssrContext) {
  __webpack_require__(204)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-622fcd5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DealerTools_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_622fcd5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DealerTools_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-app-icon",style:({
  'font-size': _vm.widthInCustomMetric ? _vm.widthInCustomMetric : _vm.width + 'px',
  'color': _vm.color
})},[(_vm.icon === 'monitoring')?[_c('svg',{attrs:{"width":"240","height":"135","viewBox":"0 0 160 90","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{staticStyle:{"fill":"hsla(202,50%,50%,1)"},attrs:{"width":"160","height":"90","rx":"0","ry":"0"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"47.5","height":"50","rx":"2","ry":"2","x":"10","y":"10"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"47.5","height":"50","rx":"2","ry":"2","x":"62.5","y":"10"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.5)"},attrs:{"width":"120","height":"20","rx":"0","ry":"0","x":"0","y":"70"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"40","height":"90","rx":"0","ry":"0","x":"120","y":"0"}})])]:(_vm.icon === 'dealer')?[_c('svg',{attrs:{"width":"240","height":"135","viewBox":"0 0 160 90","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{staticStyle:{"fill":"hsla(202,50%,50%,1)"},attrs:{"width":"160","height":"90","rx":"0","ry":"0"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"40","height":"90","rx":"0","ry":"0","x":"0","y":"0"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"40","height":"30","rx":"2","ry":"2","x":"50","y":"10"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"55","height":"30","rx":"2","ry":"2","x":"95","y":"10"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"100","height":"20","rx":"2","ry":"2","x":"50","y":"45"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.5)"},attrs:{"width":"100","height":"10","rx":"2","ry":"2","x":"50","y":"70"}})])]:(_vm.icon === 'dealerMobile')?[_c('svg',{attrs:{"width":"240","height":"135","viewBox":"0 0 160 90","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{staticStyle:{"fill":"hsla(202,50%,10%,1)"},attrs:{"width":"160","height":"90","rx":"0","ry":"0"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,1)"},attrs:{"width":"50","height":"90","rx":"2","ry":"2","x":"55","y":"0"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,70%,1)"},attrs:{"width":"10","height":"2","rx":"1","ry":"1","x":"75","y":"3"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,70%,1)"},attrs:{"width":"7.5","height":"7.5","rx":"7.5","ry":"7.5","x":"76.25","y":"80"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,50%,50%,1)"},attrs:{"width":"50","height":"70","rx":"0","ry":"0","x":"55","y":"7.5"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"50","height":"22.5","rx":"0","ry":"0","x":"55","y":"10"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"45","height":"10","rx":"1","ry":"1","x":"57.5","y":"35"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.5)"},attrs:{"width":"45","height":"10","rx":"1","ry":"1","x":"57.5","y":"47.5"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"45","height":"7.5","rx":"1","ry":"1","x":"57.5","y":"60"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.5)"},attrs:{"width":"45","height":"5","rx":"1","ry":"1","x":"57.5","y":"70"}})])]:(_vm.icon === 'enduser')?[_c('svg',{attrs:{"width":"240","height":"135","viewBox":"0 0 160 90","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{staticStyle:{"fill":"hsla(202,50%,50%,1)"},attrs:{"width":"160","height":"90","rx":"0","ry":"0"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"40","height":"90","rx":"0","ry":"0","x":"0","y":"0"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"100","height":"60","rx":"2","ry":"2","x":"50","y":"10"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"20","height":"5","rx":"1","ry":"1","x":"79","y":"75"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"20","height":"5","rx":"1","ry":"1","x":"101","y":"75"}})])]:(_vm.icon === 'enduserMobile')?[_c('svg',{attrs:{"width":"240","height":"135","viewBox":"0 0 160 90","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{staticStyle:{"fill":"hsla(202,50%,10%,1)"},attrs:{"width":"160","height":"90","rx":"0","ry":"0"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,1)"},attrs:{"width":"50","height":"90","rx":"2","ry":"2","x":"55","y":"0"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,70%,1)"},attrs:{"width":"10","height":"2","rx":"1","ry":"1","x":"75","y":"3"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,70%,1)"},attrs:{"width":"7.5","height":"7.5","rx":"7.5","ry":"7.5","x":"76.25","y":"80"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,50%,50%,1)"},attrs:{"width":"50","height":"70","rx":"0","ry":"0","x":"55","y":"7.5"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"45","height":"20","rx":"1","ry":"1","x":"57.5","y":"10"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.5)"},attrs:{"width":"45","height":"20","rx":"1","ry":"1","x":"57.5","y":"32.5"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"45","height":"20","rx":"1","ry":"1","x":"57.5","y":"55"}})])]:(_vm.icon === 'operation')?[_c('svg',{attrs:{"width":"240","height":"135","viewBox":"0 0 160 90","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{staticStyle:{"fill":"hsla(202,50%,50%,1)"},attrs:{"width":"160","height":"90","rx":"0","ry":"0"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"40","height":"90","rx":"0","ry":"0","x":"0","y":"0"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"100","height":"10","rx":"2","ry":"2","x":"50","y":"10"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.5)"},attrs:{"width":"100","height":"10","rx":"2","ry":"2","x":"50","y":"25"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"100","height":"10","rx":"2","ry":"2","x":"50","y":"40"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.5)"},attrs:{"width":"100","height":"10","rx":"2","ry":"2","x":"50","y":"55"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"100","height":"10","rx":"2","ry":"2","x":"50","y":"70"}})])]:(_vm.icon === 'operation-v2')?[_c('svg',{attrs:{"width":"240","height":"135","viewBox":"0 0 160 90","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{staticStyle:{"fill":"hsla(202,0%,10%,1)"},attrs:{"width":"160","height":"90","rx":"0","ry":"0"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"40","height":"90","rx":"0","ry":"0","x":"0","y":"0"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"100","height":"10","rx":"2","ry":"2","x":"50","y":"10"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.5)"},attrs:{"width":"100","height":"10","rx":"2","ry":"2","x":"50","y":"25"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"100","height":"10","rx":"2","ry":"2","x":"50","y":"40"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.5)"},attrs:{"width":"100","height":"10","rx":"2","ry":"2","x":"50","y":"55"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"100","height":"10","rx":"2","ry":"2","x":"50","y":"70"}})])]:(_vm.icon === 'aws-console')?[_c('svg',{attrs:{"width":"240","height":"135","viewBox":"0 0 160 90","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{staticStyle:{"fill":"hsla(50,100%,40%,1)"},attrs:{"width":"160","height":"90","rx":"0","ry":"0"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"40","height":"90","rx":"0","ry":"0","x":"0","y":"0"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"100","height":"10","rx":"2","ry":"2","x":"50","y":"10"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.5)"},attrs:{"width":"100","height":"10","rx":"2","ry":"2","x":"50","y":"25"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"100","height":"10","rx":"2","ry":"2","x":"50","y":"40"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.5)"},attrs:{"width":"100","height":"10","rx":"2","ry":"2","x":"50","y":"55"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"100","height":"10","rx":"2","ry":"2","x":"50","y":"70"}})])]:(_vm.icon === 'status')?[_c('svg',{attrs:{"width":"240","height":"135","viewBox":"0 0 160 90","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{staticStyle:{"fill":"hsla(202,50%,50%,1)"},attrs:{"width":"160","height":"90","rx":"0","ry":"0"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"100","height":"25","rx":"2","ry":"2","x":"30","y":"10"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"100","height":"10","rx":"2","ry":"2","x":"30","y":"40"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.5)"},attrs:{"width":"100","height":"10","rx":"2","ry":"2","x":"30","y":"55"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"100","height":"10","rx":"2","ry":"2","x":"30","y":"70"}})])]:(_vm.icon === 'share')?[_c('svg',{attrs:{"width":"240","height":"135","viewBox":"0 0 160 90","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{staticStyle:{"fill":"hsla(202,50%,10%,1)"},attrs:{"width":"160","height":"90","rx":"0","ry":"0"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,1)"},attrs:{"width":"50","height":"90","rx":"2","ry":"2","x":"55","y":"0"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,70%,1)"},attrs:{"width":"10","height":"2","rx":"1","ry":"1","x":"75","y":"3"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,70%,1)"},attrs:{"width":"7.5","height":"7.5","rx":"7.5","ry":"7.5","x":"76.25","y":"80"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,0%,1)"},attrs:{"width":"50","height":"70","rx":"0","ry":"0","x":"55","y":"7.5"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.4)"},attrs:{"width":"50","height":"30","rx":"0","ry":"0","x":"55","y":"7.5"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.4)"},attrs:{"width":"15","height":"5","rx":"0","ry":"0","x":"65","y":"42"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.9)"},attrs:{"width":"15","height":"5","rx":"0","ry":"0","x":"80","y":"42"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(0,100%,70%,0.9)"},attrs:{"width":"17","height":"12","rx":"0","ry":"0","x":"61","y":"56"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,100%,100%,0.9)"},attrs:{"width":"17","height":"12","rx":"0","ry":"0","x":"82","y":"56"}})])]:[_c('svg',{attrs:{"width":"240","height":"135","viewBox":"0 0 160 90","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{staticStyle:{"fill":"hsla(202,50%,50%,1)"},attrs:{"width":"160","height":"90","rx":"0","ry":"0"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"47.5","height":"50","rx":"2","ry":"2","x":"10","y":"10"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"47.5","height":"50","rx":"2","ry":"2","x":"62.5","y":"10"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.5)"},attrs:{"width":"120","height":"20","rx":"0","ry":"0","x":"0","y":"70"}}),_vm._v(" "),_c('rect',{staticStyle:{"fill":"hsla(202,0%,100%,0.8)"},attrs:{"width":"40","height":"90","rx":"0","ry":"0","x":"120","y":"0"}})])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dealer-tools"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"info-container"},[_vm._v("\n        You are currently a dealer member of "+_vm._s(_vm.myDealerName)+".\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"apps"},[(!_vm.ipAuthIP)?_c('div',{staticClass:"app card-container"},[_c('div',{staticClass:"icon-container"},[_c('comp-app-icon',{attrs:{"icon":'dealer',"width":_vm.appIconWidth}})],1),_vm._v(" "),(_vm.myDealerType === 'Wholesale Monitoring Station')?[_c('div',{staticClass:"title"},[_vm._v("WCS Dealer Portal")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("WCS Dealer Portal to manage all your sub dealers and to manage all your CHeKT devices.")]),_vm._v(" "),_c('div',{staticClass:"action-btns"},[_c('div',{staticClass:"action-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.goToURL(_vm.$env.wcsWebUrl)}}},[_vm._v("Open Dealer Portal")])])]:[_c('div',{staticClass:"title"},[_vm._v("Dealer Portal")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("Dealer Portal to manage all your CHeKT devices.")]),_vm._v(" "),_c('div',{staticClass:"action-btns"},[_c('div',{staticClass:"action-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.goToURL(_vm.$env.dealerWebUrl)}}},[_vm._v(_vm._s(_vm.$env.dealerWebUrl))])])]],2):_vm._e(),_vm._v(" "),(!_vm.ipAuthIP)?_c('div',{staticClass:"app card-container"},[_c('div',{staticClass:"icon-container"},[_c('comp-app-icon',{attrs:{"icon":'dealerMobile',"width":_vm.appIconWidth}})],1),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Dealer Mobile App")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("Dealer Mobile App for CHeKT device installation and maintenance.")]),_vm._v(" "),_c('div',{staticClass:"action-btns"},[_c('div',{staticClass:"action-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.goToURL('https://itunes.apple.com/us/app/chekt-dealer/id1196085905')}}},[_vm._v("iOS")]),_vm._v("\n          \n        "),_c('div',{staticClass:"action-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.goToURL('https://play.google.com/store/apps/details?id=com.ionicframework.mdealer590736')}}},[_vm._v("Android")])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("Dealer Tools")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("Designed and developed for integrators by an integrator")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerTools_vue__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e51869c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerTools_vue__ = __webpack_require__(210);
function injectStyle (ssrContext) {
  __webpack_require__(209)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e51869c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerTools_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e51869c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerTools_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer-tools"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"info-container"},[_vm._v("\n        You are currently a member of "+_vm._s(_vm.mySites.length)+" site(s).\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"apps"},[_c('div',{staticClass:"app card-container"},[_c('div',{staticClass:"icon-container"},[_c('comp-app-icon',{attrs:{"icon":'enduserMobile',"width":_vm.appIconWidth}})],1),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Enduser Mobile App")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("Enduser Mobile App for customers to view live video of the cameras installed at the site.")]),_vm._v(" "),_c('div',{staticClass:"action-btns"},[_c('div',{staticClass:"action-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.goToURL('https://apps.apple.com/us/app/id1508918518 ')}}},[_vm._v("iOS")]),_vm._v("\n          \n        "),_c('div',{staticClass:"action-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.goToURL('https://play.google.com/store/apps/details?id=com.chekt.app.v3')}}},[_vm._v("Android")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("Customer Tools")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("Designed for CHeKT Service End Users")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminTools_vue__ = __webpack_require__(87);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c83f8cc4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminTools_vue__ = __webpack_require__(213);
function injectStyle (ssrContext) {
  __webpack_require__(212)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c83f8cc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminTools_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c83f8cc4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminTools_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-tools"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"apps"},[_c('div',{staticClass:"app card-container"},[_c('div',{staticClass:"icon-container"},[_c('comp-app-icon',{attrs:{"icon":'operation',"width":_vm.appIconWidth}})],1),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Console Portal")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("Console Portal for CHeKT Admin to support CHeKT customers.")]),_vm._v(" "),_c('div',{staticClass:"action-btns"},[_c('div',{staticClass:"action-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.goToURL(_vm.$env.operationWebUrl)}}},[_vm._v("Open Console Portal")])])]),_vm._v(" "),_c('div',{staticClass:"app card-container"},[_c('div',{staticClass:"icon-container"},[_c('comp-app-icon',{attrs:{"icon":'aws-console',"width":_vm.appIconWidth}})],1),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("AWS Cloud Console")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("AWS Cloud Console for CHeKT Admin to maintain cloud servers.")]),_vm._v(" "),_c('div',{staticClass:"action-btns"},[_c('div',{staticClass:"action-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.goToURL('https://chekt-service.signin.aws.amazon.com/console')}}},[_vm._v("Open AWS Console")])])]),_vm._v(" "),_c('div',{staticClass:"app card-container"},[_c('div',{staticClass:"icon-container"},[_c('comp-app-icon',{attrs:{"icon":'status',"width":_vm.appIconWidth}})],1),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("CHeKT Service Status")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("CHeKT Service Status to check service operation status in real time.")]),_vm._v(" "),_c('div',{staticClass:"action-btns",staticStyle:{"display":"flex","flex-direction":"row"}},[_c('div',{staticClass:"action-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.goToURL('http://status.chekt.com')}}},[_vm._v("Opesn Status")]),_vm._v(" "),_c('div',{staticClass:"action-btn",staticStyle:{"margin":"0 4px"}},[_vm._v("/")]),_vm._v(" "),_c('div',{staticClass:"action-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.goToURL('http://uptime.chekt.com')}}},[_vm._v("Open Uptime")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("Admin Tools")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("Designed for CHeKT service administrators")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"info-container"},[_vm._v("\n        Thanks for being one of CHeKT service administrators.\n      ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Security_vue__ = __webpack_require__(88);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31d26cad_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Security_vue__ = __webpack_require__(244);
function injectStyle (ssrContext) {
  __webpack_require__(215)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31d26cad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Security_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31d26cad_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Security_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompOtpInput_vue__ = __webpack_require__(93);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5814f500_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompOtpInput_vue__ = __webpack_require__(243);
function injectStyle (ssrContext) {
  __webpack_require__(242)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5814f500"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompOtpInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5814f500_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompOtpInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"otp"},_vm._l((_vm.boxes),function(box,i){return _c('input',{key:i,ref:'box' + i,refInFor:true,staticClass:"otp-cell",attrs:{"type":"text","inputmode":"numeric","autocomplete":"one-time-code","maxlength":"1"},domProps:{"value":_vm.boxes[i]},on:{"input":function($event){_vm.onInput(i, $event)},"keydown":function($event){_vm.onKeydown(i, $event)},"focus":function($event){_vm.onFocus($event)},"paste":function($event){_vm.onPaste($event)}}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"security"},[_c('h2',{staticClass:"title"},[_vm._v("Two-Factor Authentication")]),_vm._v(" "),(_vm.pageState === 'loading')?_c('div',{staticClass:"status"},[_vm._v("Loading…")]):(_vm.pageState === 'needAuth')?_c('div',{staticClass:"status"},[_c('p',{staticClass:"desc"},[_vm._v("To manage two-factor authentication, we need to verify your identity.")]),_vm._v(" "),_c('div',{staticClass:"btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.authorize()}}},[_vm._v("Continue")])]):(_vm.pageState === 'error')?_c('div',{staticClass:"status error"},[_vm._v("\n    "+_vm._s(_vm.errorMessage)+"\n    "),_c('div',{staticClass:"btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.authorize()}}},[_vm._v("Try again")])]):_c('div',{staticClass:"content"},[_c('p',{staticClass:"desc"},[_vm._v("Use an authenticator app (Google Authenticator, Authy, 1Password, etc.) to generate verification codes.")]),_vm._v(" "),_c('div',{staticClass:"list"},_vm._l((_vm.authenticators),function(auth){return _c('div',{key:auth.id,staticClass:"item"},[_c('div',{staticClass:"item-name"},[_vm._v(_vm._s(auth.name))]),_vm._v(" "),_c('div',{staticClass:"btn danger",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.remove(auth.id)}}},[_vm._v("Remove")])])})),_vm._v(" "),(!_vm.pendingEnrollment && _vm.authenticators.length === 0)?_c('div',{staticClass:"enroll"},[_c('div',{staticClass:"status"},[_vm._v("Preparing…")])]):_vm._e(),_vm._v(" "),(_vm.pendingEnrollment)?_c('div',{staticClass:"enroll-flow"},[_c('p',{staticClass:"step"},[_vm._v("1. Scan this QR code with your authenticator app.")]),_vm._v(" "),(_vm.qrDataUrl)?_c('img',{staticClass:"qr",attrs:{"src":_vm.qrDataUrl,"alt":"QR code"}}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"secret"},[_vm._v("Or enter this key manually:"),_c('br'),_vm._v(" "),_c('code',{staticClass:"secret-key",attrs:{"ontouchstart":"","title":"Click to copy"},on:{"click":function($event){_vm.copySecret()}}},[_vm._v(_vm._s(_vm.pendingEnrollment.secret))]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.secretCopied)?_c('span',{staticClass:"copy-hint"},[_vm._v("Copied!")]):_vm._e()])],1),_vm._v(" "),(_vm.pendingEnrollment.recoveryCodes.length)?_c('div',{staticClass:"recovery"},[_c('p',{staticClass:"warn"},[_vm._v("Save these recovery codes now — they are shown only once.")]),_vm._v(" "),_c('ul',_vm._l((_vm.pendingEnrollment.recoveryCodes),function(code,i){return _c('li',{key:i},[_vm._v(_vm._s(code))])}))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"step"},[_vm._v("2. Enter the 6-digit code from your app.")]),_vm._v(" "),_c('comp-otp-input',{attrs:{"length":6},on:{"complete":function($event){_vm.onOtpComplete()}},model:{value:(_vm.otp),callback:function ($$v) {_vm.otp=$$v},expression:"otp"}}),_vm._v(" "),(_vm.enrollError)?_c('div',{staticClass:"inline-error"},[_vm._v(_vm._s(_vm.enrollError))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"btn",class:{ disabled: _vm.verifying },attrs:{"ontouchstart":""},on:{"click":function($event){_vm.submitOtp()}}},[_vm._v(_vm._s(_vm.verifying ? 'Verifying…' : 'Verify & activate'))])])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(95);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_455b5e0e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(247);
function injectStyle (ssrContext) {
  __webpack_require__(246)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-455b5e0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_455b5e0e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"my-spinner"},[_c('comp-icon',{attrs:{"icon":'spinnerPuff',"width":60}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__ = __webpack_require__(96);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071c65e3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__ = __webpack_require__(250);
function injectStyle (ssrContext) {
  __webpack_require__(249)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-071c65e3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071c65e3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyCallback_vue__ = __webpack_require__(97);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a221509a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyCallback_vue__ = __webpack_require__(253);
function injectStyle (ssrContext) {
  __webpack_require__(252)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a221509a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyCallback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a221509a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyCallback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper scrollable -x -y"},[_c('div',{staticClass:"page"},[(_vm.errMessage)?_c('div',{staticClass:"message"},[_c('h1',[_vm._v("ERROR")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.errMessage))]),_vm._v(" "),_c('p',[_c('a',{staticClass:"text-btn",attrs:{"ontouchstart":""},on:{"click":function($event){_vm.goToLogin()}}},[_vm._v("\n          Try login again\n        ")])])]):_c('div',{staticClass:"my-spinner"},[_c('comp-icon',{attrs:{"icon":'spinnerPuff',"width":60}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__(98);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecdcdd98_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__(256);
function injectStyle (ssrContext) {
  __webpack_require__(255)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ecdcdd98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecdcdd98_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"my-spinner"},[_c('comp-icon',{attrs:{"icon":'spinnerPuff',"width":60}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__ = __webpack_require__(99);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e83e4460_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__ = __webpack_require__(278);
function injectStyle (ssrContext) {
  __webpack_require__(258)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e83e4460"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e83e4460_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_vm._m(0),_vm._v(" "),_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[(!_vm.signupSuccess)?_c('div',{staticClass:"signup",class:{failed:_vm.isSignupFailed}},[_c('div',{staticClass:"form"},[_c('div',{staticClass:"form-header"},[_c('div',{staticClass:"title"},[_c('div',[_vm._v("Sign up your accuont")])])]),_vm._v(" "),_c('div',{staticClass:"email"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"input",staticStyle:{"margin-bottom":"30px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"autofocus":"","id":"email","type":"email","placeholder":"yours@chekt.com"},domProps:{"value":(_vm.email)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.clickSignup(_vm.email, _vm.password)},"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"passwords"},[_c('div',{staticClass:"password"},[_vm._v("Password")])]),_vm._v(" "),_c('div',{staticClass:"input",staticStyle:{"margin-bottom":"20px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","placeholder":"your password","id":"password"},domProps:{"value":(_vm.password)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.clickSignup(_vm.email, _vm.password)},"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"passwords"},[_c('div',{staticClass:"password"},[_vm._v("Confirm Password")])]),_vm._v(" "),_c('div',{staticClass:"input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmPassword),expression:"confirmPassword"}],attrs:{"type":"password","placeholder":"confirn your password","id":"passwordConfirm"},domProps:{"value":(_vm.confirmPassword)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.clickSignup(_vm.email, _vm.password)},"input":function($event){if($event.target.composing){ return; }_vm.confirmPassword=$event.target.value}}})]),_vm._v(" "),(_vm.isSignupFailed)?_c('div',{staticClass:"failed-text",staticStyle:{"margin-top":"20px"}},[_c('CompIcon',{staticStyle:{"color":"#CD3D64"},attrs:{"icon":'error',"width":18}}),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"5px","text-align":"left"}},[_vm._v(_vm._s(_vm.loginFailMessage))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"signup-btn",class:{loading:_vm.isLoading},staticStyle:{"margin-bottom":"20px","margin-top":"50px"},on:{"click":function($event){_vm.clickSignup(_vm.email, _vm.password)}}},[(_vm.isLoading)?_c('div',{staticClass:"loader"}):_c('div',[_vm._v("Sign up")])]),_vm._v(" "),_c('div',{staticClass:"passwordless"},[_vm._v("Can't sign up? "),_c('span',{staticClass:"try-resend-signup",on:{"click":function($event){_vm.clickPasswordless()}}},[_vm._v("Try resend sign up email")])])])]):_c('div',{staticClass:"signup",class:{failed:_vm.isSignupFailed}},[_c('div',{staticClass:"form"},[_c('div',{staticClass:"form-header"},[_c('div',{staticClass:"title"},[_c('div',[_vm._v("🎉 Successfully signed up!")])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"signedup-subtitle"},[_vm._v("You can use the chekt app now.")]),_vm._v(" "),_c('div',{staticClass:"signedup-desc"},[_vm._v("Please download the app in appstore or playstore with your phone. You can login the app with your signed up email and password.")])]),_vm._v(" "),_c('div',{staticClass:"download-apps"},[_c('div',{staticClass:"download-app",on:{"click":function($event){_vm.goToLink('ios')}}},[_vm._v(" Download for IOS ")]),_vm._v(" "),_c('div',{staticClass:"download-app",on:{"click":function($event){_vm.goToLink('android')}}},[_vm._v(" Download for Android ")])])])])]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('span',{staticClass:"footer-item",on:{"click":function($event){_vm.goToLink('chekt')}}},[_vm._v("© CHeKT")]),_vm._v(" "),_c('span',[_vm._v(" · ")]),_vm._v(" "),_c('span',{staticClass:"footer-item",on:{"click":function($event){_vm.goToLink('contact')}}},[_vm._v("Contact")]),_vm._v(" "),_c('span',[_vm._v(" · ")]),_vm._v(" "),_c('span',{staticClass:"footer-item",on:{"click":function($event){_vm.goToLink('privacy')}}},[_vm._v("Privacy & terms")])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('img',{staticStyle:{"width":"100px","height":"100%"},attrs:{"src":__webpack_require__(279)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rootModule__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_myProfile__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_myDealer__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_auth0__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_mfa__ = __webpack_require__(299);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__rootModule__["a" /* default */].state,
  actions: __WEBPACK_IMPORTED_MODULE_2__rootModule__["a" /* default */].actions,
  getters: __WEBPACK_IMPORTED_MODULE_2__rootModule__["a" /* default */].getters,
  mutations: __WEBPACK_IMPORTED_MODULE_2__rootModule__["a" /* default */].mutations,
  modules: {
    myProfile: __WEBPACK_IMPORTED_MODULE_3__modules_myProfile__["a" /* default */],
    myDealer: __WEBPACK_IMPORTED_MODULE_4__modules_myDealer__["a" /* default */],
    auth0: __WEBPACK_IMPORTED_MODULE_5__modules_auth0__["a" /* default */],
    mfa: __WEBPACK_IMPORTED_MODULE_6__modules_mfa__["a" /* default */]
  },
  strict: debug
}));

/***/ }),
/* 281 */,
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(27);





var initialState = {
  isInitiated: false

  // initial state
};var state = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].util.extend({}, initialState);

// getters
var getters = {
  isInitiated: function isInitiated(state) {
    return state.isInitiated;
  }

  // actions
};var actions = {
  initializeData: function initializeData(_ref) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch,
        state = _ref.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('INIT');
      resolve();
    });
  }

  // mutations
};var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["w" /* INIT */], function (state) {
  state.isInitiated = true;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apis_user__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apis_dealer__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__apis_site__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__apis_common__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mutation_types__ = __webpack_require__(27);




var _mutations;








var initialState = {
  dealerTypeTextList: ['Security Integrator', 'Full Service Integrator', 'Wholesale Monitoring Station', 'Security Dealer'],
  myProfile: {
    userId: null,
    mqttAccessToken: null,
    email: null,
    firstName: null,
    lastName: null,
    created: null,
    // isToResetPassword: null, // TO BE DELETED
    isEmailVerified: null,
    profilePictureUrl: null,
    isAdmin: null
  },
  myDealer: {},
  mySites: [],
  myDevices: [],
  myAccessHistory: [],
  status: {
    getMyProfile: null,
    getMyDealer: null,
    getMySites: null,
    updateMyProfile: null,
    changeMyProfile: null,
    uploadMyAvatar: null,
    sendEmailChangeEmail: null
  }

  // initial state
};var state = __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].util.extend({}, initialState);

// getters
var getters = {
  myFirstName: function myFirstName(state) {
    return state.myProfile.firstName ? state.myProfile.firstName : '';
  },
  myLastName: function myLastName(state) {
    return state.myProfile.lastName ? state.myProfile.lastName : '';
  },
  isValidAccount: function isValidAccount(state) {
    return state.myProfile.isEmailVerified;
  },
  // isToResetPassword: function (state) { // TO BE DELETED
  //   return state.myProfile.isToResetPassword
  // },
  myMqttAccessToken: function myMqttAccessToken(state) {
    return state.myProfile.mqttAccessToken;
  },
  isCHeKTAdmin: function isCHeKTAdmin(state) {
    return state.myProfile.isAdmin;
  },
  hasMyDealer: function hasMyDealer(state) {
    return !!state.myDealer.dealerId;
  },
  hasMySites: function hasMySites(state) {
    return !!state.mySites.length;
  },
  hasMyDevices: function hasMyDevices(state) {
    return !!state.myDevices.length;
  },
  hasMyAccessHistory: function hasMyAccessHistory(state) {
    return !!state.myAccessHistory.length;
  },
  myDealer: function myDealer(state) {
    return state.myDealer;
  },
  myDealerId: function myDealerId(state) {
    return state.myDealer.dealerId;
  },
  myDealerName: function myDealerName(state) {
    return state.myDealer.dealerName;
  },
  myDealerType: function myDealerType(state) {
    return 'typeInfo' in state.myDealer ? state.myDealer.typeInfo.typeText : null;
  },
  myDealerHasPendingRegistration: function myDealerHasPendingRegistration(state) {
    return 'statusInfo' in state.myDealer ? !state.myDealer.statusInfo.isRegistered : null;
  },
  iAmOwnerOfMyDealer: function iAmOwnerOfMyDealer(state) {
    return 'ownerInfo' in state.myDealer ? state.myDealer.ownerInfo.userId === state.myProfile.userId : null;
  },
  myEmail: function myEmail(state) {
    return state.myProfile.email;
  },
  myUserId: function myUserId(state) {
    return state.myProfile.userId;
  },
  myProfilePictureUrl: function myProfilePictureUrl(state) {
    return state.myProfile.profilePictureUrl;
  },
  mySites: function mySites(state) {
    return state.mySites;
  },
  statusGetMyDealer: function statusGetMyDealer(state) {
    return state.status.getMyDealer;
  },
  statusGetMyProfile: function statusGetMyProfile(state) {
    return state.status.getMyProfile;
  },
  statusUpdateMyProfile: function statusUpdateMyProfile(state) {
    return state.status.updateMyProfile;
  },
  statusChangeMyPassword: function statusChangeMyPassword(state) {
    return state.status.changeMyPassword;
  },
  statusUploadMyAvatar: function statusUploadMyAvatar(state) {
    return state.status.uploadMyAvatar;
  },
  statusSendEmailChangeEmail: function statusSendEmailChangeEmail() {
    return state.status.sendEmailChangeEmail;
  }

  // actions
};var actions = {
  getMyProfile: function getMyProfile(_ref) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["o" /* GET_MYPROFILE_REQUEST */]);
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__apis_user__["a" /* default */].getMyProfile().then(function (res) {
        commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["p" /* GET_MYPROFILE_SUCCESS */], res.body[0]);
        // if email is not verified, but logged in, which means the user got the password by checking the email
        // so, it is safe to change the verify status to verified.
        // but CHeKT support multiple emails, then it is not a safe operation anymore.
        if (!res.body[0]['is_verify']) {
          dispatch('updateMyEmailAsVerified');
        }
        dispatch('getUserInfo');
        resolve();
      }, function (err) {
        commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["n" /* GET_MYPROFILE_FAILURE */]);
        reject(new Error(err.statusText));
      });
    });
  },
  updateMyProfile: function updateMyProfile(_ref2, _ref3) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;
    var firstName = _ref3.firstName,
        lastName = _ref3.lastName;

    commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["W" /* UPDATE_MYPROFILE_REQUEST */]);
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__apis_user__["a" /* default */].updateMyProfile({ firstName: firstName, lastName: lastName }).then(function (res) {
        commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["X" /* UPDATE_MYPROFILE_SUCCESS */]);
        resolve();
      }, function (err) {
        commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["V" /* UPDATE_MYPROFILE_FAILURE */]);
        reject(new Error(err.statusText));
      });
    });
  },
  updateMyEmailAsVerified: function updateMyEmailAsVerified(_ref4) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__apis_user__["a" /* default */].updateMyEmailAsVerified().then(function (res) {
        resolve();
      }, function (err) {
        reject(new Error(err.statusText));
      });
    });
  },
  changeMyPassword: function changeMyPassword(_ref5, _ref6) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;
    var password = _ref6.password;

    commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["b" /* CHANGE_MYPASSWORD_REQUEST */]);
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__apis_user__["a" /* default */].changeMyPassword({ password: password }).then(function (res) {
        commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["c" /* CHANGE_MYPASSWORD_SUCCESS */]);
        resolve();
      }, function (err) {
        commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["a" /* CHANGE_MYPASSWORD_FAILURE */]);
        reject(new Error(err.statusText));
      });
    });
  },
  uploadMyAvatar: function uploadMyAvatar(_ref7, _ref8) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;
    var blobData = _ref8.blobData,
        contentType = _ref8.contentType;

    commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["_0" /* UPLOAD_MYAVATAR_REQUEST */]);
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var fileExtension = contentType.split('/')[1];
      __WEBPACK_IMPORTED_MODULE_4__apis_user__["a" /* default */].getMyAvatarUploadUrl({ fileExtension: fileExtension }).then(function (res) {
        var uploadUrl = res.body['url'];
        __WEBPACK_IMPORTED_MODULE_7__apis_common__["a" /* default */].put(uploadUrl, blobData, contentType).then(function (res) {
          commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["_1" /* UPLOAD_MYAVATAR_SUCCESS */]);
          resolve();
        }, function (err) {
          commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["Z" /* UPLOAD_MYAVATAR_FAILURE */]);
          reject(new Error(err.statusText));
        });
      });
    });
  },
  changeMyEmail: function changeMyEmail(_ref9, _ref10) {
    var commit = _ref9.commit,
        dispatch = _ref9.dispatch;
    var email = _ref10.email;

    commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["K" /* SEND_EMAILCHANGE_EMAIL_REQUEST */]);
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__apis_user__["a" /* default */].changeMyEmail({ email: email }).then(function (res) {
        commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["L" /* SEND_EMAILCHANGE_EMAIL_SUCCESS */]);
        // console.log(res)
        resolve(res.body.message);
      }, function (err) {
        commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["J" /* SEND_EMAILCHANGE_EMAIL_FAILURE */]);
        // console.log(err)
        reject(new Error(err.body.message));
      });
    });
  },
  getMyDealer: function getMyDealer(_ref11) {
    var commit = _ref11.commit,
        dispatch = _ref11.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["l" /* GET_MYDEALER_REQUEST */]);
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__apis_user__["a" /* default */].getMyDealer().then(function (res) {
        var dealerId = res.body[0]['dealer_id'];
        // if email is not verified, but logged in, which means the user got the password by checking the email
        // so, it is safe to change the verify status to verified.
        // but CHeKT support multiple emails, then it is not a safe operation anymore.
        // if verify email and accept invitation is one queue action
        if (!!res.body[0]['is_registered'] && res.body[0]['invitation_status'] + '' === '1') {
          dispatch('acceptMyDealerInvitation', {
            dealerId: res.body[0]['dealer_id'],
            memberId: res.body[0]['user_id']
          });
        }
        __WEBPACK_IMPORTED_MODULE_5__apis_dealer__["a" /* default */].getDealer({ dealerId: dealerId }).then(function (res) {
          commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["m" /* GET_MYDEALER_SUCCESS */], res.body[0]);
          resolve();
        }, function (err) {
          commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["k" /* GET_MYDEALER_FAILURE */]);
          reject(new Error(err.statusText));
        });
      }, function (err) {
        commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["k" /* GET_MYDEALER_FAILURE */]);
        reject(new Error(err.statusText));
      });
    });
  },
  getMySites: function getMySites(_ref12) {
    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["r" /* GET_MYSITES_REQUEST */]);
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_6__apis_site__["a" /* default */].getMySites().then(function (res) {
        if (res.body.length) {
          commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["s" /* GET_MYSITES_SUCCESS */], res.body);
          resolve();
        } else {
          commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["q" /* GET_MYSITES_FAILURE */]);
          reject(new Error('No my sites'));
        }
      }, function (err) {
        commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["q" /* GET_MYSITES_FAILURE */]);
        reject(new Error(err.statusText));
      });
    });
  },
  getMyMetadata: function getMyMetadata(_ref13) {
    var commit = _ref13.commit,
        dispatch = _ref13.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__apis_user__["a" /* default */].getMyMetadata().then(function (res) {
        resolve(res);
      }, function (err) {
        reject(new Error(err.statusText));
      });
    });
  },
  createMyMetadata: function createMyMetadata(_ref14, metadata) {
    var commit = _ref14.commit,
        dispatch = _ref14.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__apis_user__["a" /* default */].createMyMetadata(metadata).then(function (res) {
        resolve();
      }, function (err) {
        reject(new Error(err.statusText));
      });
    });
  },
  updateMyMetadata: function updateMyMetadata(_ref15, metadata) {
    var commit = _ref15.commit,
        dispatch = _ref15.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__apis_user__["a" /* default */].updateMyMetadata(metadata).then(function (res) {
        resolve();
      }, function (err) {
        reject(new Error(err.statusText));
      });
    });
  },
  deleteMyMetadata: function deleteMyMetadata(_ref16) {
    var commit = _ref16.commit,
        dispatch = _ref16.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__apis_user__["a" /* default */].deleteMyMetadata().then(function (res) {
        resolve();
      }, function (err) {
        reject(new Error(err.statusText));
      });
    });
  }

  // mutations
};var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["I" /* RESET_STATE */], function (state) {
  for (var f in state) {
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].set(state, f, initialState[f]);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["o" /* GET_MYPROFILE_REQUEST */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'getMyProfile': 'requested' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["p" /* GET_MYPROFILE_SUCCESS */], function (state, data) {
  try {
    var profileInfo = {
      userId: data.user_id,
      mqttAccessToken: data.access_token,
      email: data.email,
      firstName: data.firstname,
      lastName: data.lastname,
      created: data.created,
      // isToResetPassword: !!data.is_reset_password, // TO BE DELETED
      isEmailVerified: data.is_verify,
      profilePictureUrl: data.provider_picture,
      isAdmin: data.role === 'admin'
    };
    state.myProfile = profileInfo;
    state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'getMyProfile': 'successful' });
  } catch (err) {
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].logger.error('GET_MYPROFILE_SUCCESS: Failed');
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].logger.error(err.message);
    state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'getMyProfile': 'failed' });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["n" /* GET_MYPROFILE_FAILURE */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'getMyProfile': 'failed' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["l" /* GET_MYDEALER_REQUEST */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'getMyDealer': 'requested' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["m" /* GET_MYDEALER_SUCCESS */], function (state, data) {
  try {
    var dealerType = data.type ? data.type : 0;
    var dealerInfo = {
      dealerId: data.dealer_id,
      dealerName: data.company_name,
      profilePictureUrl: data.provider_picture,
      typeInfo: {
        type: dealerType,
        typeText: state.dealerTypeTextList[+dealerType]
      },
      ownerInfo: {
        userId: data.user_id,
        email: data.email,
        firstName: data.firstname,
        lastName: data.lastname
      },
      locationInfo: {
        address: (data.company_address2 ? data.company_address2 + ' ' : '') + data.company_address1,
        address1: data.company_address1,
        address2: data.company_address2,
        postalCode: data.company_zipcode,
        timezone: data.timezone,
        lat: data.lat,
        lng: data.lng
      },
      contactInfo: {
        phone: data.company_phone,
        email: data.company_email
      },
      statusInfo: {
        isDeleted: !!data.is_deleted,
        isRegistered: !!data.is_registered,
        isMonitoringBlocked: !!data.is_monitoring_block,
        createdDate: data.created ? new Date(data.created) : null,
        registeredDate: data.registered_time ? new Date(data.registered_time) : null,
        deletedDate: data.deleted_time ? new Date(data.deleted_time) : null
      },
      statistics: {
        totalSite: data.site_count ? data.site_count : 0,
        totalBridge: data.bridge_count ? data.bridge_count : 0,
        totalCamera: data.camera_count ? data.camera_count : 0,
        totalUser: data.user_count ? data.user_count : 0
      }
    };
    state.myDealer = dealerInfo;
    state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'getMyDealer': 'successful' });
  } catch (err) {
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].logger.error('GET_MYDEALER_SUCCESS: Failed');
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].logger.error(err.message);
    state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'getMyDealer': 'failed' });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["k" /* GET_MYDEALER_FAILURE */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'getMyDealer': 'failed' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["r" /* GET_MYSITES_REQUEST */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'getMySites': 'requested' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["s" /* GET_MYSITES_SUCCESS */], function (state, data) {
  try {
    var siteList = [];
    data.map(function (site) {
      var siteData = {
        siteId: site['site_id'],
        siteName: site['name'],
        accountNumber: site['account_number'],
        blueprintUrl: site['blueprint_url'],
        // owner info
        siteOwnerUserId: site['user_id'],
        siteOwnerEmail: site['owner_email'],
        // location info
        siteAddress: (site['address2'] ? site['address2'] + ' ' : '') + site['address1'],
        siteLat: site['lat'],
        siteLng: site['lng'],
        timezone: site['timezone'] ? site['timezone'] : 'UTC'
      };
      siteList.push(siteData);
    });
    state.mySites = siteList;
    state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'getMySites': 'successful' });
  } catch (err) {
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].logger.error('GET_MYSITES_SUCCESS: Failed');
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].logger.error(err.message);
    state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'getMySites': 'failed' });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["q" /* GET_MYSITES_FAILURE */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'getMySites': 'failed' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["W" /* UPDATE_MYPROFILE_REQUEST */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'updateMyProfile': 'requested' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["X" /* UPDATE_MYPROFILE_SUCCESS */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'updateMyProfile': 'successful' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["V" /* UPDATE_MYPROFILE_FAILURE */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'updateMyProfile': 'failed' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["b" /* CHANGE_MYPASSWORD_REQUEST */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'changeMyPassword': 'requested' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["c" /* CHANGE_MYPASSWORD_SUCCESS */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'changeMyPassword': 'successful' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["a" /* CHANGE_MYPASSWORD_FAILURE */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'changeMyPassword': 'failed' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["_0" /* UPLOAD_MYAVATAR_REQUEST */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'uploadMyAvatar': 'requested' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["_1" /* UPLOAD_MYAVATAR_SUCCESS */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'uploadMyAvatar': 'successful' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["Z" /* UPLOAD_MYAVATAR_FAILURE */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'uploadMyAvatar': 'failed' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["K" /* SEND_EMAILCHANGE_EMAIL_REQUEST */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'sendEmailChangeEmail': 'requested' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["L" /* SEND_EMAILCHANGE_EMAIL_SUCCESS */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'sendEmailChangeEmail': 'successful' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["J" /* SEND_EMAILCHANGE_EMAIL_FAILURE */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'sendEmailChangeEmail': 'failed' });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  getMySites: function getMySites() {
    var apiDetailPath = '/sites';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.apiPath + apiDetailPath, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  downloadImage: function downloadImage(url) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(url, { responseType: 'blob' });
  },
  get: function get(apiPath) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(apiPath);
  },
  put: function put(apiPath, apiBody, contentType) {
    var header = null;
    if (contentType) {
      header = { 'headers': { 'content-type': contentType } };
    }
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.put(apiPath, apiBody, header);
  },
  post: function post(apiPath, apiBody, contentType) {
    var header = null;
    if (contentType) {
      header = { 'headers': { 'content-type': contentType } };
    }
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.put(apiPath, apiBody, header);
  },
  getTimeFromInternet: function getTimeFromInternet() {
    var apiPath = 'http://www.googleapis.com';
    apiPath = 'https://www.googleapis.com';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(apiPath);
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apis_dealer__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__(27);




var _mutations;





var initialState = {
  status: {
    registerMyDealer: null,
    updateMyDealer: null
  }

  // initial state
};var state = __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].util.extend({}, initialState);

// getters
var getters = {
  statusRegisterMyDealer: function statusRegisterMyDealer(state) {
    return state.status.registerMyDealer;
  },
  statusUpdateMyDealer: function statusUpdateMyDealer(state) {
    return state.status.updateMyDealer;
  }

  // actions
};var actions = {
  registerMyDealer: function registerMyDealer(_ref, _ref2) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;
    var dealerId = _ref2.dealerId,
        name = _ref2.name,
        zip = _ref2.zip,
        address1 = _ref2.address1,
        address2 = _ref2.address2,
        phone = _ref2.phone,
        email = _ref2.email,
        lat = _ref2.lat,
        lng = _ref2.lng;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["G" /* REGISTER_MYDEALER_REQUEST */]);
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__apis_dealer__["a" /* default */].registerDealer({ dealerId: dealerId, name: name, zip: zip, address1: address1, address2: address2, phone: phone, email: email, lat: lat, lng: lng }).then(function (res) {
        commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["H" /* REGISTER_MYDEALER_SUCCESS */]);
        resolve();
      }, function (err) {
        commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["F" /* REGISTER_MYDEALER_FAILURE */]);
        reject(new Error(err.statusText));
      });
    });
  },
  updateMyDealer: function updateMyDealer(_ref3, _ref4) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;
    var dealerId = _ref4.dealerId,
        name = _ref4.name,
        zip = _ref4.zip,
        address1 = _ref4.address1,
        address2 = _ref4.address2,
        phone = _ref4.phone,
        email = _ref4.email,
        lat = _ref4.lat,
        lng = _ref4.lng;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["T" /* UPDATE_MYDEALER_REQUEST */]);
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__apis_dealer__["a" /* default */].updateDealer({ dealerId: dealerId, name: name, zip: zip, address1: address1, address2: address2, phone: phone, email: email, lat: lat, lng: lng }).then(function (res) {
        commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["U" /* UPDATE_MYDEALER_SUCCESS */]);
        resolve();
      }, function (err) {
        commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["S" /* UPDATE_MYDEALER_FAILURE */]);
        reject(new Error(err.statusText));
      });
    });
  },
  acceptMyDealerInvitation: function acceptMyDealerInvitation(_ref5, _ref6) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;
    var dealerId = _ref6.dealerId,
        memberId = _ref6.memberId;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__apis_dealer__["a" /* default */].acceptDealerMemberInvitation({ dealerId: dealerId, memberId: memberId }).then(function (res) {
        resolve();
      }, function (err) {
        reject(new Error(err.statusText));
      });
    });
  }

  // mutations
};var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["I" /* RESET_STATE */], function (state) {
  for (var f in state) {
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].set(state, f, initialState[f]);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["G" /* REGISTER_MYDEALER_REQUEST */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'registerMyDealer': 'requested' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["H" /* REGISTER_MYDEALER_SUCCESS */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'registerMyDealer': 'successful' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["F" /* REGISTER_MYDEALER_FAILURE */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'registerMyDealer': 'failed' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["T" /* UPDATE_MYDEALER_REQUEST */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'updateMyDealer': 'requested' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["U" /* UPDATE_MYDEALER_SUCCESS */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'updateMyDealer': 'successful' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["S" /* UPDATE_MYDEALER_FAILURE */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'updateMyDealer': 'failed' });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_auth0_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jwt_decode__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__apis_auth__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mutation_types__ = __webpack_require__(27);




var _mutations;







var initialState = {
  auth0: null,
  checkingSession$t: null,
  accountCreatedAt: null,
  newAccountLogicBeginDate: new Date('2018-11-15T00:00:00.000Z'), // hard-coded
  lastPasswordReset: 'TBD',
  authResult: {
    ip: null,
    ipAuthDealer: null,
    provider: null,
    email: null,
    accessToken: null,
    idToken: null,
    expiresAt: null
  },
  status: {
    handleAuthentication: null,
    checkSession: null,
    sendPasswordResetEmail: null,
    getIDTokenIPAuth: null
  }

  // initial state
};var state = __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].util.extend({}, initialState);

// getters
var getters = {
  statusHandleAuthentication: function statusHandleAuthentication(state) {
    return state.status.handleAuthentication;
  },
  statusCheckSession: function statusCheckSession(state) {
    return state.status.checkSession;
  },
  statusSendPasswordResetEmail: function statusSendPasswordResetEmail(state) {
    return state.status.sendPasswordResetEmail;
  },
  statusGetIDTokenIPAuth: function statusGetIDTokenIPAuth(state) {
    return state.status.getIDTokenIPAuth;
  },
  isToResetPasswordAuth0: function isToResetPasswordAuth0(state) {
    return state.lastPasswordReset === 'TBD' ? false : !state.lastPasswordReset;
  },
  lastPasswordReset: function lastPasswordReset(state) {
    return state.lastPasswordReset;
  },
  accountCreatedDate: function accountCreatedDate(state) {
    // string
    return new Date(state.accountCreatedAt);
  },
  newAccountLogicBeginDate: function newAccountLogicBeginDate(state) {
    // string
    return state.newAccountLogicBeginDate;
  },
  auth0: function auth0(state) {
    return state.auth0;
  },
  idToken: function idToken(state) {
    return state.authResult.idToken;
  },
  idTokenExpiresAt: function idTokenExpiresAt(state) {
    return state.authResult.expiresAt;
  },
  idTokenProvider: function idTokenProvider(state) {
    return state.authResult.provider;
  },
  idTokenIPAuthDealerID: function idTokenIPAuthDealerID(state) {
    return state.authResult.ipAuthDealer;
  },
  idTokenIPAuthIP: function idTokenIPAuthIP(state) {
    return state.authResult.ip;
  },
  isAuthenticated: function isAuthenticated(state) {
    return function () {
      var expiresAt = state.authResult.expiresAt ? state.authResult.expiresAt : 0;
      return new Date().getTime() < expiresAt;
    };
  },
  isAuthenticatedInCookie: function isAuthenticatedInCookie() {
    return function () {
      var expiresAt = __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].tool.getCookie('chekt::expires_at') ? __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].tool.getCookie('chekt::expires_at') : 0;
      return new Date().getTime() < expiresAt;
    };
  },
  isIdTokenExpired: function isIdTokenExpired(state) {
    var expiresAt = state.authResult.expiresAt ? state.authResult.expiresAt : 0;
    var now = new Date().getTime();
    return expiresAt < now;
  }
  // actions
};var actions = {
  login: function login(_ref) {
    var commit = _ref.commit,
        state = _ref.state;

    if (!state.auth0) commit('INIT_AUTH0');
    state.auth0.authorize({
      login_hint: __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].param.options['email'] || __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].tool.getCookie('chekt::email')
    });
  },
  checkSession: function checkSession(_ref2) {
    var dispatch = _ref2.dispatch,
        commit = _ref2.commit,
        state = _ref2.state,
        getters = _ref2.getters;

    // if ID token is not expired, no need to check session
    if (!getters.isIdTokenExpired) return;

    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["e" /* CHECK_SESSION_REQUEST */]);
    if (!state.auth0) commit('INIT_AUTH0');
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      state.auth0.checkSession({
        // state and nonce should be handled by auth0-js library, so don't need to do that here
      }, function (err, authResult) {
        // console.log('checkSession')
        // console.log(authResult)
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["d" /* CHECK_SESSION_FAILURE */]);
          reject(err);
        } else {
          var expiresIn = commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["P" /* SET_SESSION */], authResult);
          commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["f" /* CHECK_SESSION_SUCCESS */]);
          resolve(expiresIn);
        }
      });
    });
  },
  handleAuthentication: function handleAuthentication(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state;

    if (!state.auth0) commit('INIT_AUTH0');
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["u" /* HANDLE_AUTHENTICATION_REQUEST */]);
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      state.auth0.parseHash({
        __enableIdPInitiatedLogin: true // warning CSRF attackable
      }, function (err, authResult) {
        // console.log('handleAuthentication')
        // console.log(authResult)
        if (authResult && authResult.accessToken && authResult.idToken) {
          commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["P" /* SET_SESSION */], authResult);
          commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["v" /* HANDLE_AUTHENTICATION_SUCCESS */]);
          resolve();
        } else if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["t" /* HANDLE_AUTHENTICATION_FAILURE */]);
          reject(err);
        } else {
          reject(new Error('no_result'));
        }
      });
    });
  },
  logout: function logout(_ref4) {
    var commit = _ref4.commit,
        state = _ref4.state;

    if (__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].param.getParamValue('ip_auth_dealer')) {
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].tool.redirectToUrl(window.location.origin + window.location.search);
    } else {
      commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["g" /* CLEAR_SESSION */]);
      if (!state.auth0) commit('INIT_AUTH0');
      state.auth0.logout({
        returnTo: window.location.origin + window.location.search,
        clientID: __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].env.authClientID
      });
    }
  },
  changePassword: function changePassword(_ref5) {
    var commit = _ref5.commit,
        state = _ref5.state;

    if (!state.auth0) commit('INIT_AUTH0');
    commit('SEND_PASSWORDRESET_EMAIL_REQUEST');
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      state.auth0.changePassword({
        connection: __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].env.authConnection,
        email: state.authResult.email
      }, function (err, resp) {
        if (err) {
          reject(err);
          commit('SEND_PASSWORDRESET_EMAIL_FAILURE');
        } else {
          resolve(resp);
          commit('SEND_PASSWORDRESET_EMAIL_SUCCESS');
        }
      });
    });
  },
  getUserInfo: function getUserInfo(_ref6) {
    var commit = _ref6.commit,
        state = _ref6.state;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (!state.authResult.ipAuthDealer) {
        if (state.auth0) {
          state.auth0.client.userInfo(state.authResult.accessToken, function (err, user) {
            if (err) {
              reject(err);
            } else {
              resolve();
              commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["Y" /* UPDATE_USERINFO */], user);
            }
          });
        } else {
          reject(new Error('auth0 is not initiated'));
        }
      } else {
        resolve();
        __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].logger.info('getUserInfo: IP auth does\'t have user info');
      }
    });
  },
  getIDTokenIPAuth: function getIDTokenIPAuth(_ref7, _ref8) {
    var commit = _ref7.commit,
        state = _ref7.state;
    var dealerID = _ref8.dealerID;

    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["i" /* GET_IDTOKEN_IPAUTH_REQUEST */]);
    var randomString = __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].tool.randomString(32);
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_6__apis_auth__["a" /* default */].getIDTokenIPAuth(dealerID, randomString).then(function (res) {
        if (res.body.state === randomString) {
          commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["j" /* GET_IDTOKEN_IPAUTH_SUCCESS */], {
            dealerID: dealerID,
            data: res.body
          });
          resolve();
        } else {
          commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["h" /* GET_IDTOKEN_IPAUTH_FAILURE */]);
          reject(new Error('State doesn\'t match'));
        }
      }, function (err) {
        commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["h" /* GET_IDTOKEN_IPAUTH_FAILURE */]);
        reject(err.body);
      });
    });
  }

  // mutations
};var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["x" /* INIT_AUTH0 */], function (state) {
  state.auth0 = new __WEBPACK_IMPORTED_MODULE_3_auth0_js__["a" /* default */].WebAuth({
    domain: __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].env.authDomain,
    // audience: Vue.env.authAudience, // it goes RS256 if audience is added.
    clientID: __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].env.authClientID,
    redirectUri: window.location.origin + '/callback' + window.location.search,
    responseType: 'token id_token', // RH256 requires both access_token and id_token. It uses access_token to validate id_token
    scope: 'openid'
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["Q" /* START_CHECKING_SESSION */], function (state, timer$f) {
  state.checkingSession$t = timer$f;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["R" /* STOP_CHECKING_SESSION */], function (state) {
  if (state.checkingSession$t) {
    clearTimeout(state.checkingSession$t);
    state.checkingSession$t = null;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["u" /* HANDLE_AUTHENTICATION_REQUEST */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'handleAuthentication': 'requested' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["v" /* HANDLE_AUTHENTICATION_SUCCESS */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'handleAuthentication': 'successful' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["t" /* HANDLE_AUTHENTICATION_FAILURE */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'handleAuthentication': 'failed' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["e" /* CHECK_SESSION_REQUEST */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'checkSession': 'requested' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["f" /* CHECK_SESSION_SUCCESS */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'checkSession': 'successful' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["d" /* CHECK_SESSION_FAILURE */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'checkSession': 'failed' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["y" /* LOAD_LAST_SESSION */], function (state) {
  var idToken = __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].tool.getCookie('chekt::id_token');
  var accessToken = __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].tool.getCookie('chekt::access_token');
  var expiresAt = __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].tool.getCookie('chekt::expires_at');
  if (idToken && expiresAt) {
    __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].auth.storeIdTokenToAuthService(idToken);
    state.authResult = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.authResult, { 'idToken': idToken });
    state.authResult = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.authResult, { 'expiresAt': expiresAt });
  }
  state.authResult = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.authResult, { 'accessToken': accessToken });
  __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].logger.info('LOAD_LAST_SESSION');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["P" /* SET_SESSION */], function (state, authResult) {
  var decodedToken = __WEBPACK_IMPORTED_MODULE_4_jwt_decode___default()(authResult.idToken);
  var expiresAt = decodedToken.exp * 1000;
  var expiresIn = +decodedToken.exp - +decodedToken.iat;
  __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].tool.setCookie('chekt::access_token', authResult.accessToken);
  __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].tool.setCookie('chekt::expires_at', expiresAt);
  __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].tool.setCookie('chekt::id_token', authResult.idToken);
  __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].auth.storeIdTokenToAuthService(authResult.idToken);
  if (authResult.idTokenPayload instanceof Object) {
    // email
    if (authResult.idTokenPayload.email) {
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].tool.setCookie('chekt::email', authResult.idTokenPayload.email);
      state.authResult = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.authResult, { 'email': authResult.idTokenPayload.email });
    }
    // last password reset
    state.lastPasswordReset = authResult.idTokenPayload.last_password_reset;
    // account created date
    state.accountCreatedAt = authResult.idTokenPayload.created_at;
  }
  __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].logger.info('Session valid for next ' + expiresIn / 60 + ' minute(s)');
  // console.log(authResult)
  state.authResult = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.authResult, { 'idToken': authResult.idToken });
  state.authResult = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.authResult, { 'expiresAt': expiresAt });
  state.authResult = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.authResult, { 'accessToken': authResult.accessToken });
  return expiresIn;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["g" /* CLEAR_SESSION */], function (state) {
  __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].tool.deleteCookie('chekt::access_token');
  __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].tool.deleteCookie('chekt::expires_at');
  __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].tool.deleteCookie('chekt::id_token');
  state.authResult = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.authResult, { 'email': null });
  state.authResult = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.authResult, { 'idToken': null });
  state.authResult = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.authResult, { 'expiresAt': null });
  state.authResult = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.authResult, { 'accessToken': null });
  state.authResult = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.authResult, { 'ipAuthDealer': null });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["Y" /* UPDATE_USERINFO */], function (state, userInfo) {
  // last password reset
  state.lastPasswordReset = userInfo.last_password_reset;
  // account created date
  state.accountCreatedAt = userInfo.created_at;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["N" /* SEND_PASSWORDRESET_EMAIL_REQUEST */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'sendPasswordResetEmail': 'requested' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["O" /* SEND_PASSWORDRESET_EMAIL_SUCCESS */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'sendPasswordResetEmail': 'successful' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["M" /* SEND_PASSWORDRESET_EMAIL_FAILURE */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'sendPasswordResetEmail': 'failed' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["i" /* GET_IDTOKEN_IPAUTH_REQUEST */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'getIDTokenIPAuth': 'requested' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["j" /* GET_IDTOKEN_IPAUTH_SUCCESS */], function (state, _ref9) {
  var dealerID = _ref9.dealerID,
      data = _ref9.data;

  try {
    var idToken = data.id_token;
    var decodedToken = __WEBPACK_IMPORTED_MODULE_4_jwt_decode___default()(idToken);
    var expiresAt = decodedToken.exp * 1000;
    var expiresIn = +decodedToken.exp - +decodedToken.iat;
    var ip = decodedToken.ip;
    if (idToken && expiresAt) {
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].auth.storeIdTokenToAuthService(idToken);
      state.authResult = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.authResult, { 'ipAuthDealer': dealerID });
      state.authResult = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.authResult, { 'idToken': idToken });
      state.authResult = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.authResult, { 'expiresAt': expiresAt });
      state.authResult = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.authResult, { 'ip': ip });
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].logger.info('IP Auth: Session valid for next ' + expiresIn / 60 + ' minute(s)');
      state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'getIDTokenIPAuth': 'successful' });
    } else {
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].logger.error('GET_IDTOKEN_IPAUTH_SUCCESS: Failed: Invalid idToken or expiresAt');
      state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'getIDTokenIPAuth': 'failed' });
    }
  } catch (err) {
    __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].logger.error('GET_IDTOKEN_IPAUTH_SUCCESS: Failed');
    __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].logger.error(err.message);
    state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'getIDTokenIPAuth': 'failed' });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["h" /* GET_IDTOKEN_IPAUTH_FAILURE */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { 'getIDTokenIPAuth': 'failed' });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(email, password) {
    var apiDetailPath = '/oauth/ro';
    var data = {
      client_id: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.authClientID,
      connection: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.authConnection,
      scope: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.authScope,
      username: email,
      password: password,
      device: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.deviceInfo
    };
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.authApiPath + apiDetailPath, data, { 'headers': { 'Content-Type': 'application/json' } });
  },
  sendPasswordResetEmail: function sendPasswordResetEmail(email) {
    var apiDetailPath = '/dbconnections/change_password';
    var data = {
      'client_id': __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.authClientID,
      'connection': __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.authConnection,
      'email': email,
      'device': __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.deviceInfo
    };
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.authApiPath + apiDetailPath, data, { 'headers': { 'Content-Type': 'application/json' } });
  },
  refreshIdToken: function refreshIdToken(refreshToken) {
    var apiDetailPath = '/delegation';
    var data = {
      grant_type: 'urn:ietf:params:oauth:grant-type:jwt-bearer',
      scope: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.authScope,
      client_id: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.authClientID,
      refresh_token: refreshToken
    };
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.authApiPath + apiDetailPath, data, { 'headers': { 'Content-Type': 'application/json' } });
  },
  revokeRefreshToken: function revokeRefreshToken(refreshToken) {
    var apiDetailPath = '/oauth/revoke';
    var data = {
      client_id: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.authClientID,
      token: refreshToken
    };
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.authApiPath + apiDetailPath, data, { 'headers': { 'Content-Type': 'application/json' } });
  },
  getIDTokenIPAuth: function getIDTokenIPAuth(dealerId, state) {
    var apiDetailPath = '/ipauth/v1/token';
    apiDetailPath += '?response_type=id_token';
    apiDetailPath += '&username=' + dealerId;
    apiDetailPath += '&state=' + state;
    apiDetailPath += '&client_id=' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.ipAuthClientID;
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.ipAuthAPIPath + apiDetailPath);
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_auth0_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apis_mfa__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_mfaHelpers__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mutation_types__ = __webpack_require__(27);




var _mutations;







// Dedicated WebAuth instance for the MFA API.
// - domain: the custom domain (where the user's SSO session cookie lives)
// - audience: the canonical tenant /mfa/ API (custom domain is not a valid audience)
// - responseType 'token': we only need the MFA-scoped access token, no id_token
// Obtaining this token requires an interactive authorize() redirect because Auth0
// enforces an MFA step-up for the MFA API, which checkSession (prompt=none) cannot do.
function getMfaWebAuth() {
  return new __WEBPACK_IMPORTED_MODULE_4_auth0_js__["a" /* default */].WebAuth({
    domain: __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].env.authDomain,
    clientID: __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].env.authClientID,
    redirectUri: window.location.origin + '/account/security',
    responseType: 'token',
    audience: __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].env.mfaAudience,
    scope: 'enroll read:authenticators remove:authenticators'
  });
}

var state = {
  mfaAccessToken: null,
  authenticators: [],
  pendingEnrollment: null, // { secret, barcodeUri, recoveryCodes }
  status: {
    enroll: null // null | 'requested' | 'successful' | 'failed'
  }
};

var getters = {
  mfaAuthenticators: function mfaAuthenticators(state) {
    return state.authenticators;
  },
  mfaPendingEnrollment: function mfaPendingEnrollment(state) {
    return state.pendingEnrollment;
  },
  hasMfaToken: function hasMfaToken(state) {
    return !!state.mfaAccessToken;
  },
  statusMfaEnroll: function statusMfaEnroll(state) {
    return state.status.enroll;
  }
};

var actions = {
  // Try to get the MFA token silently (no redirect) from the existing session.
  // Succeeds only when Auth0 does not need an interactive MFA step-up and the
  // SSO cookie is reachable (i.e. not blocked as a third-party cookie). Callers
  // fall back to startMfaAuthorize() when this rejects.
  initMfaSession: function initMfaSession(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      getMfaWebAuth().checkSession({}, function (err, authResult) {
        if (err) {
          reject(err);
        } else if (authResult && authResult.accessToken) {
          commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["E" /* MFA_SET_TOKEN */], authResult.accessToken);
          resolve(authResult.accessToken);
        } else {
          reject(new Error('no_token'));
        }
      });
    });
  },
  // Full-page redirect to Auth0 to authenticate (with MFA step-up) and return an
  // MFA-scoped access token in the URL hash at /account/security.
  startMfaAuthorize: function startMfaAuthorize() {
    getMfaWebAuth().authorize();
  },
  // Parse the MFA-scoped access token from the hash after returning from authorize().
  resumeMfaSession: function resumeMfaSession(_ref2) {
    var commit = _ref2.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      getMfaWebAuth().parseHash({ hash: window.location.hash }, function (err, authResult) {
        if (err) {
          reject(err);
        } else if (authResult && authResult.accessToken) {
          commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["E" /* MFA_SET_TOKEN */], authResult.accessToken);
          resolve(authResult.accessToken);
        } else {
          reject(new Error('no_token'));
        }
      });
    });
  },
  loadMfaAuthenticators: function loadMfaAuthenticators(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state;

    return __WEBPACK_IMPORTED_MODULE_5__apis_mfa__["a" /* default */].getAuthenticators(state.mfaAccessToken).then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["B" /* MFA_SET_AUTHENTICATORS */], Object(__WEBPACK_IMPORTED_MODULE_6__utils_mfaHelpers__["c" /* parseOtpAuthenticators */])(res.body));
    });
  },
  startMfaEnrollment: function startMfaEnrollment(_ref4) {
    var commit = _ref4.commit,
        state = _ref4.state;

    return __WEBPACK_IMPORTED_MODULE_5__apis_mfa__["a" /* default */].associateOtp(state.mfaAccessToken).then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["D" /* MFA_SET_PENDING_ENROLLMENT */], Object(__WEBPACK_IMPORTED_MODULE_6__utils_mfaHelpers__["b" /* parseAssociateResponse */])(res.body));
    });
  },
  confirmMfaEnrollment: function confirmMfaEnrollment(_ref5, _ref6) {
    var commit = _ref5.commit,
        state = _ref5.state,
        dispatch = _ref5.dispatch;
    var otp = _ref6.otp;

    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["C" /* MFA_SET_ENROLL_STATUS */], 'requested');
    return __WEBPACK_IMPORTED_MODULE_5__apis_mfa__["a" /* default */].confirmOtp(state.mfaAccessToken, otp).then(function () {
      commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["A" /* MFA_CLEAR_PENDING_ENROLLMENT */]);
      return dispatch('loadMfaAuthenticators').then(function () {
        commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["C" /* MFA_SET_ENROLL_STATUS */], 'successful');
      });
    }).catch(function (err) {
      commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["C" /* MFA_SET_ENROLL_STATUS */], 'failed');
      throw err;
    });
  },
  removeMfaAuthenticator: function removeMfaAuthenticator(_ref7, _ref8) {
    var state = _ref7.state,
        dispatch = _ref7.dispatch;
    var id = _ref8.id;

    return __WEBPACK_IMPORTED_MODULE_5__apis_mfa__["a" /* default */].deleteAuthenticator(state.mfaAccessToken, id).then(function () {
      return dispatch('loadMfaAuthenticators');
    });
  },
  clearMfaSession: function clearMfaSession(_ref9) {
    var commit = _ref9.commit;

    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["z" /* MFA_CLEAR */]);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["E" /* MFA_SET_TOKEN */], function (state, token) {
  state.mfaAccessToken = token;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["z" /* MFA_CLEAR */], function (state) {
  state.mfaAccessToken = null;
  state.authenticators = [];
  state.pendingEnrollment = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["B" /* MFA_SET_AUTHENTICATORS */], function (state, list) {
  state.authenticators = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["D" /* MFA_SET_PENDING_ENROLLMENT */], function (state, enrollment) {
  state.pendingEnrollment = enrollment;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["A" /* MFA_CLEAR_PENDING_ENROLLMENT */], function (state) {
  state.pendingEnrollment = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["C" /* MFA_SET_ENROLL_STATUS */], function (state, status) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { enroll: status });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({ state: state, getters: getters, actions: actions, mutations: mutations });

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  // GET enrolled authenticators (needs read:authenticators scope)
  getAuthenticators: function getAuthenticators(mfaAccessToken) {
    var apiDetailPath = '/mfa/authenticators';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.authApiPath + apiDetailPath, {
      headers: { 'Authorization': 'Bearer ' + mfaAccessToken }
    });
  },
  // Associate a new TOTP authenticator (needs enroll scope)
  associateOtp: function associateOtp(mfaAccessToken) {
    var apiDetailPath = '/mfa/associate';
    var data = { authenticator_types: ['otp'] };
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.authApiPath + apiDetailPath, data, {
      headers: { 'Authorization': 'Bearer ' + mfaAccessToken, 'Content-Type': 'application/json' }
    });
  },
  // Confirm the just-associated TOTP by exchanging an OTP at the token endpoint.
  // NOTE: passes the MFA access token as `mfa_token`. Verified against the dev
  // tenant during manual verification; if Auth0 rejects it, adjust here only.
  confirmOtp: function confirmOtp(mfaToken, otp) {
    var apiDetailPath = '/oauth/token';
    var data = {
      grant_type: 'http://auth0.com/oauth/grant-type/mfa-otp',
      client_id: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.authClientID,
      mfa_token: mfaToken,
      otp: otp
    };
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.authApiPath + apiDetailPath, data, {
      headers: { 'Content-Type': 'application/json' }
    });
  },
  // Remove an authenticator (needs remove:authenticators scope)
  deleteAuthenticator: function deleteAuthenticator(mfaAccessToken, authenticatorId) {
    var apiDetailPath = '/mfa/authenticators/' + authenticatorId;
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.delete(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].env.authApiPath + apiDetailPath, {
      headers: { 'Authorization': 'Bearer ' + mfaAccessToken }
    });
  }
});

/***/ }),
/* 301 */,
/* 302 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var AuthPlugin = {
  install: function install(Vue, options) {
    var auth = {
      idToken: null,
      email: null,
      // Remove all tokens from lagacy location (Security reason)
      removeTokensFromLegacyLocation: function removeTokensFromLegacyLocation() {
        localStorage.removeItem('chekt::last_email');
        localStorage.removeItem('chekt::last_refresh_token');
        localStorage.removeItem('chekt::id_token');
        localStorage.removeItem('chekt::refresh_token');
        localStorage.removeItem('access_token');
        localStorage.removeItem('id_token');
        localStorage.removeItem('expires_at');
        localStorage.removeItem('provider');
        localStorage.removeItem('connection');
        localStorage.removeItem('email');
        Vue.tool.deleteCookie('crt');
        Vue.tool.deleteCookie('email');
        Vue.tool.deleteCookie('chekt::connection');
        Vue.tool.deleteCookie('chekt::provider');
        Vue.tool.deleteCookie('chekt::ip_auth_dealer');
      },
      storeIdTokenToAuthService: function storeIdTokenToAuthService(token) {
        Vue.auth.idToken = token;
      }
    };
    Vue.prototype.$auth = auth;
    Vue.auth = auth;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (AuthPlugin);

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var EnvironmentPlugin = {
  install: function install(Vue, options) {
    function getCurrentDomain() {
      var temp = window.location.hostname.split('.');
      if (temp.length > 1) {
        return temp[+temp.length - 2];
      } else {
        return temp[0];
      }
    }
    function getClientInfo() {
      var unknown = '-';
      // screen
      var screenSize = '';
      if (screen.width) {
        var width = screen.width ? screen.width : '';
        var height = screen.height ? screen.height : '';
        screenSize += '' + width + ' x ' + height;
      }
      // browser
      var nVer = navigator.appVersion;
      var nAgt = navigator.userAgent;
      var browser = navigator.appName;
      var version = '' + parseFloat(navigator.appVersion);
      var majorVersion = parseInt(navigator.appVersion, 10);
      var nameOffset = void 0,
          verOffset = void 0,
          ix = void 0;
      // Opera
      if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
        browser = 'Opera';
        version = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf('Version')) !== -1) {
          version = nAgt.substring(verOffset + 8);
        }
      }
      // Opera Next
      if ((verOffset = nAgt.indexOf('OPR')) !== -1) {
        browser = 'Opera';
        version = nAgt.substring(verOffset + 4);
      } else if ((verOffset = nAgt.indexOf('Edge')) !== -1) {
        // Edge
        browser = 'Microsoft Edge';
        version = nAgt.substring(verOffset + 5);
      } else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
        // MSIE
        browser = 'Microsoft Internet Explorer';
        version = nAgt.substring(verOffset + 5);
      } else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
        // Chrome
        browser = 'Chrome';
        version = nAgt.substring(verOffset + 7);
      } else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
        // Safari
        browser = 'Safari';
        version = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf('Version')) !== -1) {
          version = nAgt.substring(verOffset + 8);
        }
      } else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
        // Firefox
        browser = 'Firefox';
        version = nAgt.substring(verOffset + 8);
      } else if (nAgt.indexOf('Trident/') !== -1) {
        // MSIE 11+
        browser = 'Microsoft Internet Explorer';
        version = nAgt.substring(nAgt.indexOf('rv:') + 3);
      } else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        // Other browsers
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() === browser.toUpperCase()) {
          browser = navigator.appName;
        }
      }
      // trim the version string
      if ((ix = version.indexOf('')) !== -1) version = version.substring(0, ix);
      if ((ix = version.indexOf(' ')) !== -1) version = version.substring(0, ix);
      if ((ix = version.indexOf(')')) !== -1) version = version.substring(0, ix);

      majorVersion = parseInt('' + version, 10);
      if (isNaN(majorVersion)) {
        version = '' + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
      }

      // mobile version
      var mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);

      // cookie
      var cookieEnabled = navigator.cookieEnabled === true;

      if (typeof navigator.cookieEnabled === 'undefined' && !cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1 === true;
      }

      // system
      var os = unknown;
      var clientStrings = [{ s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/ }, { s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ }, { s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ }, { s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ }, { s: 'Windows Vista', r: /Windows NT 6.0/ }, { s: 'Windows Server 2003', r: /Windows NT 5.2/ }, { s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ }, { s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ }, { s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ }, { s: 'Windows 98', r: /(Windows 98|Win98)/ }, { s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ }, { s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ }, { s: 'Windows CE', r: /Windows CE/ }, { s: 'Windows 3.11', r: /Win16/ }, { s: 'Android', r: /Android/ }, { s: 'Open BSD', r: /OpenBSD/ }, { s: 'Sun OS', r: /SunOS/ }, { s: 'Linux', r: /(Linux|X11)/ }, { s: 'iOS', r: /(iPhone|iPad|iPod)/ }, { s: 'Mac OS X', r: /Mac OS X/ }, { s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ }, { s: 'QNX', r: /QNX/ }, { s: 'UNIX', r: /UNIX/ }, { s: 'BeOS', r: /BeOS/ }, { s: 'OS/2', r: /OS\/2/ }, { s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ }];
      for (var id in clientStrings) {
        var cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
          os = cs.s;
          break;
        }
      }

      var osVersion = unknown;
      var regRes = null;

      if (/Windows/.test(os)) {
        regRes = /Windows (.*)/.exec(os);
        osVersion = regRes ? regRes[1] : unknown;
        os = 'Windows';
      }

      switch (os) {
        case 'Mac OS X':
          regRes = /Mac OS X (\w+)/.exec(nAgt);
          osVersion = regRes ? regRes[1] : unknown;
          break;
        case 'Android':
          regRes = /Android ([._\d]+)/.exec(nAgt);
          osVersion = regRes ? regRes[1] : unknown;
          break;
        case 'iOS':
          regRes = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
          if (regRes) {
            osVersion = regRes[1];
            osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (+osVersion[3] | 0);
          }
          break;
      }
      var info = {
        screen: screenSize,
        browser: browser,
        browserVersion: version,
        browserMajorVersion: majorVersion,
        mobile: mobile,
        os: os,
        osVersion: osVersion,
        cookies: cookieEnabled
      };
      return info;
    }

    var environment = {
      currentDomain: getCurrentDomain(),
      isProduction: null,
      isQe: null,
      isChektDomain: null,
      ipAuthClientID: null,
      authClientID: null,
      authDomain: null,
      authApiPath: null,
      authConnection: null,
      authAudience: null,
      mfaAudience: null,
      authScope: null,
      authCookieDomain: null,
      authTargetPath: null,
      apiTargetPath: null,
      apiPrefix: null,
      apiPath: null,
      ipAuthAPIPath: null,
      operationWebUrl: null,
      operationV2WebUrl: null,
      googleMapAPIKey: 'AIzaSyD33CRqwF-fO7Z9NioI9z98h0eDZ1la3cw',
      dealerWebUrl: null,
      wcsWebUrl: null,
      monitoringWebUrl: null,
      shareWebUrl: null,
      appWebUrl: null,
      psapUrl: null,
      deviceInfo: null
    };
    if (environment.currentDomain === 'chekt') {
      environment.isChektDomain = true;
      environment.isProduction = true;
    } else if (environment.currentDomain === 'chektdev') {
      environment.isChektDomain = true;
      environment.isProduction = false;
    } else if (environment.currentDomain === 'chektqe') {
      environment.isChektDomain = true;
      environment.isProduction = false;
      environment.isQe = true;
    } else if (environment.currentDomain === 'github') {
      environment.isChektDomain = false;
      environment.isProduction = false;
    } else if (environment.currentDomain === 'firebaseapp') {
      environment.isChektDomain = false;
      environment.isProduction = false;
    } else if (environment.currentDomain === 'localhost') {
      environment.isChektDomain = false;
      environment.isProduction = true;
      environment.isProduction = false;
    } else {
      environment.isChektDomain = false;
      environment.isProduction = false;
    }
    if (environment.isProduction) {
      environment.ipAuthClientID = 'fewWiBkuJ8IQ5Mowzm4p9IIPd28pzyapGnbYyuOL7ZNeZZV3cxMGX5qsVU4YI31e';
      environment.authClientID = 'bHzjpwmWpjwdOukz2h7FM2u2ND5BPKFa';
      environment.authDomain = 'auth.chekt.com';
      // MFA API identifier (audience only — not a traffic target). The built-in
      // MFA API is registered under the canonical tenant domain, so the custom
      // domain is not a valid audience here. All requests still go to authDomain.
      environment.mfaAudience = 'https://chektcloud.auth0.com/mfa/';
      environment.authConnection = 'Username-Password-Authentication';
      environment.authScope = 'openid offline_access';
      environment.authCookieDomain = '.chekt.com';
      environment.authTargetPath = 'account.chekt.com';
      environment.authAudience = 'https://api.chekt.com';
      environment.apiTargetPath = 'api.chekt.com';
      environment.apiPrefix = '/api/v1.1';
      environment.ipAuthAPIPath = 'https://ipauth.chekt.com';
      environment.mqttTargetPath = 'commandcenter.chekt.com';
      environment.mqttTargetPathPort = 443;
      environment.operationWebUrl = 'https://console.chekt.com';
      environment.operationV2WebUrl = 'https://operation-v2.chekt.com';
      environment.dealerWebUrl = 'https://dealer.chekt.com';
      environment.wcsWebUrl = 'https://wcs.chekt.com';
      environment.monitoringWebUrl = 'https://monitoring.chekt.com';
      environment.shareWebUrl = 'https://share.chekt.com';
      environment.appWebUrl = 'https://app.chekt.com';
      environment.psapUrl = 'https://share.chekt.com/psap';
    } else if (environment.isQe) {
      environment.ipAuthClientID = 'fewWiBkuJ8IQ5Mowzm4p9IIPd28pzyapGnbYyuOL7ZNeZZV3cxMGX5qsVU4YI31e';
      environment.authClientID = 'M2aHNcb8wnHqOGIvd7GpuZ8brfytFhWP';
      environment.authDomain = 'auth.chektqe.com';
      // MFA API identifier (audience only — not a traffic target). The built-in
      // MFA API is registered under the canonical tenant domain, so the custom
      // domain is not a valid audience here. All requests still go to authDomain.
      environment.mfaAudience = 'https://chektqe.us.auth0.com/mfa/';
      environment.authConnection = 'Username-Password-Authentication';
      environment.authScope = 'openid offline_access';
      environment.authCookieDomain = '.chektqe.com';
      environment.authTargetPath = 'account.chektqe.com';
      environment.authAudience = 'https://api.chektqe.com';
      environment.apiTargetPath = 'api.chektqe.com';
      environment.apiPrefix = '/api/v1.1';
      environment.ipAuthAPIPath = 'https://ipauth.chektqe.com';
      environment.mqttTargetPath = 'commandcenter.chektqe.com';
      environment.mqttTargetPathPort = 443;
      environment.operationWebUrl = 'https://operation.chektqe.com';
      environment.operationV2WebUrl = 'https://operation-v2.chektqe.com';
      environment.dealerWebUrl = 'https://dealer.chektqe.com';
      environment.wcsWebUrl = 'https://wcs.chektqe.com';
      environment.monitoringWebUrl = 'https://monitoring.chektqe.com';
      environment.shareWebUrl = 'https://share.chektqe.com';
      environment.appWebUrl = 'https://app.chektqe.com';
      environment.psapUrl = 'https://share.chektqe.com/psap';
    } else {
      environment.ipAuthClientID = 'QthqVDpwGKtBQLuGJDdwIQSL4IaD1vnZtO55FrndypmKYjZGF2QhyojHFkpKNcG4';
      environment.authClientID = 'yeJIohNks41mYAiaID29JoxsZESOpEQ8';
      environment.authDomain = 'auth.chektdev.com';
      // MFA API identifier (audience only — not a traffic target). The built-in
      // MFA API is registered under the canonical tenant domain, so the custom
      // domain is not a valid audience here. All requests still go to authDomain.
      environment.mfaAudience = 'https://chektdev.auth0.com/mfa/';
      environment.authConnection = 'Username-Password-Authentication';
      environment.authScope = 'openid offline_access';
      environment.authCookieDomain = '.chektdev.com';
      environment.authTargetPath = 'account.chektdev.com';
      environment.authAudience = 'https://api.chektdev.com';
      environment.apiTargetPath = 'api.chektdev.com';
      environment.apiPrefix = '/api/v1.1';
      environment.ipAuthAPIPath = 'https://ipauth.chektdev.com';
      environment.mqttTargetPath = 'commandcenter.chektdev.com';
      environment.mqttTargetPathPort = 443;
      environment.operationWebUrl = 'https://console.chektdev.com';
      environment.operationV2WebUrl = 'https://operation-v2.chektdev.com';
      environment.dealerWebUrl = 'https://dealer.chektdev.com';
      environment.wcsWebUrl = 'https://wcs.chektdev.com';
      environment.monitoringWebUrl = 'https://monitoring.chektdev.com';
      environment.shareWebUrl = 'https://share.chektdev.com';
      environment.appWebUrl = 'https://app.chektdev.com';
      environment.psapUrl = 'https://share.chektdev.com/psap';
    }
    environment.apiPath = 'https://' + environment.apiTargetPath + environment.apiPrefix;
    environment.authApiPath = 'https://' + environment.authDomain;
    var clientInfo = getClientInfo();
    environment.deviceInfo = clientInfo['os'] + ' ' + clientInfo['osVersion'] + '-' + clientInfo['browser'] + (clientInfo['mobile'] ? '-Mobile' : '') + '-' + window.location.hostname;
    Vue.prototype.$env = environment;
    Vue.env = environment;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (EnvironmentPlugin);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var ToolPlugin = {
  install: function install(Vue, options) {
    var tool = {
      wait: function wait(time) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
          setTimeout(function () {
            resolve();
          }, time);
        });
      },
      getClosestNumberFromArray: function getClosestNumberFromArray(targetNumber, targetArray) {
        var closestNumber = targetArray.reduce(function (prev, curr) {
          return Math.abs(+curr - +targetNumber) < Math.abs(+prev - +targetNumber) ? +curr : +prev;
        });
        return closestNumber;
      },
      playTts: function playTts(text) {
        if ('speechSynthesis' in window) {
          var msg = new SpeechSynthesisUtterance(text);
          var voiceName = 'Google US English';
          msg.voice = window['speechSynthesis'].getVoices().filter(function (voice) {
            return voice.name === voiceName;
          })[0];
          window['speechSynthesis'].speak(msg);
        } else {
          console.warn('TTS is not supported');
        }
      },
      cancelTts: function cancelTts(text) {
        if ('speechSynthesis' in window) {
          window['speechSynthesis'].cancel();
        } else {
          console.warn('TTS is not supported');
        }
      },
      copyTextToClipboard: function copyTextToClipboard(text) {
        var textArea = document.createElement('textarea');
        textArea.style.position = 'fixed';
        textArea.style.top = 0;
        textArea.style.left = 0;
        textArea.style.width = '2em';
        textArea.style.height = '2em';
        textArea.style.padding = 0;
        textArea.style.border = 'none';
        textArea.style.outline = 'none';
        textArea.style.boxShadow = 'none';
        textArea.style.background = 'transparent';
        textArea.style.opacity = 0;
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
          alert('"' + text + '" is successfully copied to your clipboard.');
        } catch (err) {
          alert('Oops, unable to copy text');
          console.warn('Oops, unable to copy text');
          console.warn(err);
        }
        document.body.removeChild(textArea);
      },
      setCookie: function setCookie(cname, cvalue, date) {
        var domain = this.getCookieDomainForCurrentDomain();
        if (!date) {
          var now = new Date();
          now.setFullYear(now.getFullYear() + 5);
          date = now.toUTCString();
        }
        document.cookie = encodeURIComponent(cname) + '=' + encodeURIComponent(cvalue) + ';expires=' + date + ';domain=' + domain + ';path=/';
      },
      getCookie: function getCookie(cname) {
        var name = encodeURIComponent(cname) + '=';
        var cookie = document.cookie;
        var ca = cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) === ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
            var cookieToReturn = decodeURIComponent(c.substring(name.length, c.length));
            if (cookieToReturn === 'undefined') return undefined;else if (cookieToReturn === 'null') return null;else if (cookieToReturn === 'NaN') return NaN;else return cookieToReturn;
          }
        }
        return '';
      },
      deleteCookie: function deleteCookie(cname) {
        this.setCookie(cname, 'meaning_less_string', 'Thu, 01 Jan 1970 00:00:01 GMT');
      },
      getCookieDomainForCurrentDomain: function getCookieDomainForCurrentDomain() {
        var temp = window.location.hostname.split('.');
        if (temp.length > 1) {
          return '.' + temp[+temp.length - 2] + '.' + temp[+temp.length - 1];
        } else {
          return temp[0];
        }
      },
      encodeToBase64: function encodeToBase64(str) {
        return window.btoa(str);
      },
      decodeFromBase64: function decodeFromBase64(base64Str) {
        return window.atob(base64Str);
      },
      encodeToBase64Url: function encodeToBase64Url(str) {
        var base64Str = this.encodeToBase64(str);
        var base64Url = base64Str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
        return base64Url;
      },
      decodeFromBase64Url: function decodeFromBase64Url(base64Url) {
        if (base64Url.length % 4 === 2) base64Url = base64Url + '==';
        if (base64Url.length % 4 === 3) base64Url = base64Url + '=';
        var base64Str = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var str = this.decodeFromBase64(base64Str);
        return str;
      },
      capitalizeFirstLetter: function capitalizeFirstLetter(string) {
        string = string.toLowerCase();
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      redirectToUrl: function redirectToUrl(url) {
        // similar behavior as an HTTP redirect
        window.location.replace(url);
      },
      goToUrl: function goToUrl(url) {
        // similar behavior as clicking on a link
        window.location.href = url;
      },
      openUrl: function openUrl(url) {
        // similar behavior as clicking on a link
        window.open(url);
      },
      openNewTab: function openNewTab(url) {
        var win = window.open(url, '_blank');
        if (win) {
          // Browser has allowed it to be opened
          win.focus();
        } else {
          // Browser has blocked it
          alert('Please allow popups for this website');
        }
      },
      getTodayBeginTimestamp: function getTodayBeginTimestamp(timezoneOffset) {
        var now = Vue.time.newDate();
        var timestamp = now.getTime();
        if (timezoneOffset !== undefined) timestamp += timezoneOffset * 60 * 1000 + now.getTimezoneOffset() * 60 * 1000;
        var localNow = new Date(timestamp);
        timestamp = Math.floor(new Date(new Date(localNow.setHours(0)).setMinutes(0)).setSeconds(0) / 1000) * 1000;
        if (timezoneOffset !== undefined) timestamp -= now.getTimezoneOffset() * 60 * 1000 + timezoneOffset * 60 * 1000;
        return timestamp;
      },
      getNowTimestamp: function getNowTimestamp(timezoneOffset) {
        var now = Vue.time.newDate();
        var timestamp = now.getTime();
        if (timezoneOffset !== undefined) timestamp += timezoneOffset * 60 * 1000 + now.getTimezoneOffset() * 60 * 1000;
        return timestamp;
      },
      getLocalTimestamp: function getLocalTimestamp(timestamp, timezoneOffset) {
        var now = Vue.time.newDate();
        if (timezoneOffset !== undefined) timestamp += timezoneOffset * 60 * 1000 + now.getTimezoneOffset() * 60 * 1000;
        return timestamp;
      },
      hasAllKeys: function hasAllKeys(obj, keys) {
        var result = false;
        if (obj instanceof Object && keys instanceof Array) {
          var undefinedKeys = [];
          keys.map(function (key) {
            if (obj[key] === undefined) undefinedKeys.push(key);
          });
          if (undefinedKeys.length === 0) result = true;else {
            console.log('utils.hasAllKeys failed');
            console.log(undefinedKeys);
          }
        } else {
          console.log('utils.hasAllKeys failed');
        }
        return result;
      },
      getTimeDiffFromNow: function getTimeDiffFromNow(timestamp) {
        var now = Vue.time.newDate();
        var diff = Math.round((now.getTime() - timestamp) / 1000);
        var text = null;
        var textDetail = null;
        if (diff < 60) {
          text = '1m';
          textDetail = diff + 's';
        } else if (diff < 60 * 60) {
          text = Math.round(diff / 60) + 'm';
          textDetail = text;
        } else if (diff < 60 * 60 * 24) {
          text = Math.round(diff / 60 / 60) + 'h';
          textDetail = text;
        } else {
          text = Math.round(diff / 60 / 60 / 24) + 'd';
          textDetail = text;
        }
        return {
          text: text,
          textDetail: textDetail,
          diffInSec: diff
        };
      },
      getFriendlyTimeFromSec: function getFriendlyTimeFromSec(seconds) {
        var text = null;
        if (seconds < 60) {
          text = '1m';
        } else if (seconds < 60 * 60) {
          text = Math.round(seconds / 60) + 'm';
        } else if (seconds < 60 * 60 * 24) {
          text = Math.round(seconds / 60 / 60) + 'h';
        } else {
          text = Math.round(seconds / 60 / 60 / 24) + 'd';
        }
        return text;
      },
      methodLogger: function methodLogger(moduleName, logMessage) {
        var re = /at\s[a-zA-Z0-9.]+/g;
        var aRegexResult = new Error().stack.match(re);
        var callerName = (aRegexResult[1] || aRegexResult[2]).replace('at ', '').replace('VueComponent.', '');
        var moduleNameCss = 'background:#000000 ; padding: 0 1px; border-radius: 0;  color: #fff';
        var callerNameCss = 'background:#35495e ; padding: 0 1px; border-radius: 0;  color: #fff';
        var logMessageCss = 'background:#41b883 ; padding: 0 1px; border-radius: 0;  color: #fff';
        if (moduleName && logMessage) {
          console.log('%c ' + moduleName + ' %c ' + callerName + ' %c ' + logMessage + ' ', moduleNameCss, callerNameCss, logMessageCss);
        } else if (moduleName) {
          console.log('%c ' + moduleName + ' %c ' + callerName + ' ', moduleNameCss, callerNameCss);
        } else if (logMessage) {
          console.log('%c ' + callerName + ' %c ' + logMessage + ' ', callerNameCss, logMessageCss);
        }
      },
      isValidEmailAddress: function isValidEmailAddress(email) {
        var regexp = new RegExp('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$');
        regexp = new RegExp('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,3}$');
        if (regexp.test(email)) {
          return true;
        } else {
          return false;
        }
      },
      isValidMacAddress: function isValidMacAddress(macAddress) {
        var regexp = new RegExp('[0-9A-F]{12}');
        if (regexp.test(macAddress)) {
          return true;
        } else {
          return false;
        }
      },
      isValidPassword: function isValidPassword(password) {
        // (?=.*[a-z]) The string must contain at least 1 lowercase alphabetical character
        // (?=.*[A-Z]) The string must contain at least 1 uppercase alphabetical character
        // (?=.*[0-9]) The string must contain at least 1 numeric character
        // (?=.[!@#\$%\^&]) The string must contain at least one special character, but we are escaping reserved RegEx characters to avoid conflict
        // (?=.{8,}) The string must be eight characters or longer
        var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})');
        var mediumRegex = new RegExp('^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})');
        var regexp = strongRegex;
        regexp = mediumRegex;
        if (regexp.test(password)) {
          return true;
        } else {
          return false;
        }
      },
      convertCamelToNormal: function convertCamelToNormal(str) {
        return str
        // insert a space before all caps
        .replace(/([A-Z])/g, ' $1')
        // uppercase the first character
        .replace(/^./, function (str) {
          return str.toUpperCase();
        });
      },
      randomString: function randomString(length) {
        var charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~';
        var result = '';
        while (length > 0) {
          var bytes = new Uint8Array(16);
          var random = window.crypto.getRandomValues(bytes);
          random.forEach(function (c) {
            if (length === 0) {
              return;
            }
            if (c < charset.length) {
              result += charset[c];
              length--;
            }
          });
        }
        return result;
      },
      isUserAgentMobile: function isUserAgentMobile() {
        var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (isMobile) return true;else return false;
      }
    };
    Vue.prototype.$tool = tool;
    Vue.tool = tool;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ToolPlugin);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var LoggerPlugin = {
  install: function install(Vue, options) {
    var logLevelList = ['DEBUG', 'INFO', 'WARNING', 'ERROR'];
    var defaultLogLevel = logLevelList[0];
    var logger = {
      logLevel: defaultLogLevel,
      key: 'chekt::logLevel',
      getLogLevelFromLocalStorage: function getLogLevelFromLocalStorage() {
        try {
          var targetLogLevel = defaultLogLevel;
          var obj = JSON.parse(localStorage.getItem(Vue.logger.key));
          var exp = obj.exp;
          var logLevel = obj.value;
          var nowTimestamp = new Date().getTime();
          var timeLeft = exp - nowTimestamp;
          if (timeLeft > 0 && logLevel) {
            if (logLevelList.indexOf(logLevel) >= 0) {
              targetLogLevel = logLevel;
            }
            console.log('LogLevel (get custom log level): ' + targetLogLevel + ': ' + Math.round(timeLeft / 1000) + 's left');
            Vue.logger.setLogLevel(targetLogLevel);
          }
        } catch (err) {}
      },
      removeLogLevelInLocalStorage: function removeLogLevelInLocalStorage() {
        try {
          localStorage.removeItem(Vue.logger.key);
          console.log('LogLevel (removed custom log level)');
        } catch (err) {}
      },
      storeLogLevelInLocalStorage: function storeLogLevelInLocalStorage(logLevel) {
        try {
          var targetLogLevel = defaultLogLevel;
          if (logLevelList.indexOf(logLevel) >= 0) {
            targetLogLevel = logLevel;
          }
          var nowDate = new Date();
          var exp = new Date(nowDate.setHours(nowDate.getHours() + 1)).getTime(); // last only 1 hour
          localStorage.setItem(Vue.logger.key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ value: targetLogLevel, exp: exp }));
          console.log('LogLevel (store custom log level): ' + targetLogLevel);
          Vue.logger.setLogLevel(targetLogLevel);
        } catch (err) {}
      },
      setLogLevel: function setLogLevel(logLevel) {
        var targetLogLevel = defaultLogLevel;
        if (logLevelList.indexOf(logLevel) >= 0) {
          targetLogLevel = logLevel;
        }
        try {
          Vue.logger.logLevel = targetLogLevel;
          console.log('LogLevel: ' + Vue.logger.logLevel);
        } catch (err) {}
      },
      debug: function debug(str) {
        var logLevel = defaultLogLevel;
        try {
          var targetLogLevel = Vue.logger.logLevel;
          if (targetLogLevel) logLevel = targetLogLevel;
        } catch (err) {}
        if (logLevelList.indexOf(logLevel) <= logLevelList.indexOf('DEBUG')) {
          console.log('DEBUG: ' + (str instanceof Object ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(str, null, 2) : str));
        }
      },
      info: function info(str) {
        var logLevel = defaultLogLevel;
        try {
          var targetLogLevel = Vue.logger.logLevel;
          if (targetLogLevel) logLevel = targetLogLevel;
        } catch (err) {}
        if (logLevelList.indexOf(logLevel) <= logLevelList.indexOf('INFO')) {
          console.log('INFO: ' + (str instanceof Object ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(str, null, 2) : str));
        }
      },
      warn: function warn(str) {
        var logLevel = defaultLogLevel;
        try {
          var targetLogLevel = Vue.logger.logLevel;
          if (targetLogLevel) logLevel = targetLogLevel;
        } catch (err) {}
        if (logLevelList.indexOf(logLevel) <= logLevelList.indexOf('WARNING')) {
          console.warn('WARNING: ' + (str instanceof Object ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(str, null, 2) : str));
          // console.warn(str)
        }
      },
      error: function error(str) {
        var logLevel = defaultLogLevel;
        try {
          var targetLogLevel = Vue.logger.logLevel;
          if (targetLogLevel) logLevel = targetLogLevel;
        } catch (err) {}
        if (logLevelList.indexOf(logLevel) <= logLevelList.indexOf('ERROR')) {
          console.warn('ERROR: ' + (str instanceof Object ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(str, null, 2) : str));
          // console.error(str)
        }
      }
    };
    window.setLogLevel = logger.storeLogLevelInLocalStorage;
    window.resetLogLevel = logger.removeLogLevelInLocalStorage;
    Vue.prototype.$logger = logger;
    Vue.logger = logger;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (LoggerPlugin);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_jpeg_camera_no_flash__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_jpeg_camera_no_flash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_js_jpeg_camera_no_flash__);


var JpegCameraPlugin = {
  install: function install(Vue, options) {
    Vue.prototype.$jpegCamera = __WEBPACK_IMPORTED_MODULE_0__assets_js_jpeg_camera_no_flash___default.a;
    Vue.jpegCamera = __WEBPACK_IMPORTED_MODULE_0__assets_js_jpeg_camera_no_flash___default.a;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (JpegCameraPlugin);

/***/ }),
/* 308 */
/***/ (function(module, exports) {

/*! JpegCamera 1.3.3 | 2016-09-18
    (c) 2013 Adam Wrobel
    https://amw.github.io/jpeg_camera
    Modified by Trevor Seo at 2018-10-30 */
var JpegCamera, JpegCameraHtml5, Snapshot, Stats, canPlay, checkCanvasToBlob, mpegAudio, vorbisAudio, _ref;
var __hasProp = {}.hasOwnProperty;
var __extends = function __extends(child, parent) {
  for (var key in parent) {
    if (__hasProp.call(parent, key)) child[key] = parent[key];
  }function Ctor() {
    this.constructor = child;
  }Ctor.prototype = parent.prototype;child.prototype = new Ctor();child.__super__ = parent.prototype;return child;
};

JpegCamera = function () {
  JpegCamera.DefaultOptions = {
    // shutter_ogg_url: '/jpeg_camera/shutter.ogg',
    // shutter_mp3_url: '/jpeg_camera/shutter.mp3',
    // swf_url: '/jpeg_camera/jpeg_camera.swf',
    on_debug: function on_debug(message) {
      if (console && console.log) {
        return console.log('JpegCamera: ' + message);
      }
    },
    quality: 0.9,
    shutter: true,
    mirror: false,
    timeout: 0,
    retrySuccess: false,
    scale: 1.0
  };

  JpegCamera._canvas_supported = !!document.createElement('canvas').getContext;

  JpegCamera.canvas_supported = function () {
    return this._canvas_supported;
  };

  function JpegCamera(container, options) {
    if (typeof container === 'string') {
      container = document.getElementById(container.replace('#', ''));
    }
    if (!(container && container.offsetWidth)) {
      throw new Error('JpegCamera: invalid container');
    }
    container.innerHTML = '';
    this.view_width = parseInt(container.offsetWidth, 10);
    this.view_height = parseInt(container.offsetHeight, 10);
    this.container = document.createElement('div');
    this.container.style.width = '100%';
    this.container.style.height = '100%';
    this.container.style.position = 'relative';
    container.appendChild(this.container);
    this.options = this._extend({}, this.constructor.DefaultOptions, options);
    this._engine_init();
  }

  JpegCamera.prototype.ready = function (callback) {
    this.options.on_ready = callback;
    if (this.options.on_ready && this._is_ready) {
      this.options.on_ready.call(this, {
        videoWidth: this.videoWidth,
        videoHeight: this.videoHeight
      });
    }
    return this;
  };

  JpegCamera.prototype._is_ready = false;

  JpegCamera.prototype.error = function (callback) {
    this.options.on_error = callback;
    if (this.options.on_error && this._error_occured) {
      this.options.on_error.call(this, this._error_occured);
    }
    return this;
  };

  JpegCamera.prototype._error_occured = false;

  JpegCamera.StatsCaptureScale = 0.2;

  JpegCamera.prototype.get_stats = function (callback) {
    var snapshot, that;
    snapshot = new Snapshot(this, {});
    this._engine_capture(snapshot, false, 0.1, JpegCamera.StatsCaptureScale);
    that = this;
    return snapshot.get_stats(function (stats) {
      return callback.call(that, stats);
    });
  };

  JpegCamera.prototype.capture = function (options) {
    var scale, snapshot, _options;
    if (options == null) {
      options = {};
    }
    snapshot = new Snapshot(this, options);
    this._snapshots[snapshot.id] = snapshot;
    _options = snapshot._options();
    if (_options.shutter) {
      this._engine_play_shutter_sound();
    }
    scale = Math.min(1.0, _options.scale);
    scale = Math.max(0.01, scale);
    this._engine_capture(snapshot, _options.mirror, _options.quality, scale);
    return snapshot;
  };

  JpegCamera.prototype._snapshots = {};

  JpegCamera.prototype.show_stream = function () {
    this._engine_show_stream();
    this._displayed_snapshot = null;
    return this;
  };

  JpegCamera.prototype.discard_all = function () {
    var id, snapshot, _ref;
    if (this._displayed_snapshot) {
      this.show_stream();
    }
    _ref = this._snapshots;
    for (id in _ref) {
      snapshot = _ref[id];
      this._engine_discard(snapshot);
      snapshot._discarded = true;
    }
    this._snapshots = {};
    return this;
  };

  JpegCamera.prototype._extend = function (object) {
    var key, source, sources, value, _i, _len;
    sources = Array.prototype.slice.call(arguments, 1);
    for (_i = 0, _len = sources.length; _i < _len; _i++) {
      source = sources[_i];
      if (source) {
        for (key in source) {
          value = source[key];
          object[key] = value;
        }
      }
    }
    return object;
  };

  JpegCamera.prototype._debug = function (message) {
    if (this.options.on_debug) {
      return this.options.on_debug.call(this, message);
    }
  };

  JpegCamera.prototype._display = function (snapshot) {
    this._engine_display(snapshot);
    this._displayed_snapshot = snapshot;
    return true;
  };

  JpegCamera.prototype._displayed_snapshot = null;

  JpegCamera.prototype._discard = function (snapshot) {
    if (this._displayed_snapshot === snapshot) {
      this.show_stream();
    }
    this._engine_discard(snapshot);
    snapshot._discarded = true;
    return delete this._snapshots[snapshot.id];
  };

  JpegCamera.prototype._prepared = function (videoWidth, videoHeight) {
    var that;
    this.videoWidth = videoWidth;
    this.videoHeight = videoHeight;
    this._debug('Camera resolution ' + this.videoWidth + 'x' + this.videoHeight + 'px');
    that = this;
    return setTimeout(function () {
      return that._wait_until_stream_looks_ok(true);
    }, 1);
  };

  JpegCamera.prototype._wait_until_stream_looks_ok = function (showDebug) {
    return this.get_stats(function (stats) {
      var that;
      if (stats.std > 2) {
        this._debug('Stream mean gray value = ' + stats.mean + ' standard deviation = ' + stats.std);
        this._debug('Camera is ready');
        this._is_ready = true;
        if (this.options.on_ready) {
          return this.options.on_ready.call(this, {
            videoWidth: this.videoWidth,
            videoHeight: this.videoHeight
          });
        }
      } else {
        if (showDebug) {
          this._debug('Stream mean gray value = ' + stats.mean + ' standard deviation = ' + stats.std);
        }
        that = this;
        return setTimeout(function () {
          return that._wait_until_stream_looks_ok(false);
        }, 100);
      }
    });
  };

  JpegCamera.prototype._got_error = function (error) {
    this._debug('Error - ' + error);
    this._error_occured = error;
    if (this.options.on_error) {
      return this.options.on_error.call(this, this._error_occured);
    }
  };

  JpegCamera.prototype._block_element_access = function () {
    this._overlay = document.createElement('div');
    this._overlay.style.width = '100%';
    this._overlay.style.height = '100%';
    this._overlay.style.position = 'absolute';
    this._overlay.style.top = 0;
    this._overlay.style.left = 0;
    this._overlay.style.zIndex = 2;
    return this.container.appendChild(this._overlay);
  };

  JpegCamera.prototype._overlay = null;

  JpegCamera.prototype.view_width = null;

  JpegCamera.prototype.view_height = null;

  JpegCamera._add_prefixed_style = function (element, style, value) {
    var uppercaseStyle;
    uppercaseStyle = style.charAt(0).toUpperCase() + style.slice(1);
    element.style[style] = value;
    element.style['Webkit' + uppercaseStyle] = value;
    element.style['Moz' + uppercaseStyle] = value;
    element.style['ms' + uppercaseStyle] = value;
    element.style['O' + uppercaseStyle] = value;
    return true;
  };

  return JpegCamera;
}();

navigator.getUserMedia || (navigator.getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia);

window.AudioContext || (window.AudioContext = window.webkitAudioContext);

checkCanvasToBlob = function checkCanvasToBlob() {
  var canvas;
  canvas = document.createElement('canvas');
  if (canvas.getContext && !canvas.toBlob) {
    // throw new Error('JpegCamera: Canvas-to-Blob is not loaded')
    console.error('JpegCamera: Canvas-to-Blob is not loaded');
  }
};

if (navigator.getUserMedia) {
  checkCanvasToBlob();
  vorbisAudio = 'audio/ogg; codecs=vorbis';
  mpegAudio = 'audio/mpeg; ';
  canPlay = function canPlay(type) {
    var elem;
    elem = document.createElement('video');
    return !!(elem.canPlayType && elem.canPlayType(type).replace(/no/, ''));
  };
  JpegCameraHtml5 = function (_super) {
    __extends(JpegCameraHtml5, _super);

    function JpegCameraHtml5() {
      _ref = JpegCameraHtml5.__super__.constructor.apply(this, arguments);
      return _ref;
    }

    JpegCameraHtml5.prototype._engine_init = function () {
      var failure, getUserMediaOptions, horizontalPadding, success, that, verticalPadding;
      this._debug('Using HTML5 engine');
      verticalPadding = Math.floor(this.view_height * 0.2);
      horizontalPadding = Math.floor(this.view_width * 0.2);
      this.message = document.createElement('div');
      this.message['class'] = 'message';
      this.message.style.width = '100%';
      this.message.style.height = '100%';
      JpegCamera._add_prefixed_style(this.message, 'boxSizing', 'border-box');
      this.message.style.overflow = 'hidden';
      this.message.style.textAlign = 'center';
      this.message.style.paddingTop = '' + verticalPadding + 'px';
      this.message.style.paddingBottom = '' + verticalPadding + 'px';
      this.message.style.paddingLeft = '' + horizontalPadding + 'px';
      this.message.style.paddingRight = '' + horizontalPadding + 'px';
      this.message.style.position = 'absolute';
      this.message.style.zIndex = 3;
      this.message.innerHTML = 'Please allow camera access when prompted by the browser.<br><br>' + 'Look for camera icon around your address bar.';
      this.container.appendChild(this.message);
      this.videoContainer = document.createElement('div');
      this.videoContainer.style.width = '' + this.view_width + 'px';
      this.videoContainer.style.height = '' + this.view_height + 'px';
      this.videoContainer.style.overflow = 'hidden';
      this.videoContainer.style.position = 'absolute';
      this.videoContainer.style.zIndex = 1;
      this.container.appendChild(this.videoContainer);
      this.video = document.createElement('video');
      this.video.autoplay = true;
      JpegCamera._add_prefixed_style(this.video, 'transform', 'scalex(-1.0)');
      if (window.AudioContext) {
        if (canPlay(vorbisAudio)) {
          // this._load_shutter_sound(this.options.shutter_ogg_url)
        } else if (canPlay(mpegAudio)) {
          // this._load_shutter_sound(this.options.shutter_mp3_url)
        }
      }
      getUserMediaOptions = {
        video: {
          optional: [{
            minWidth: 1280
          }, {
            minWidth: 640
          }, {
            minWidth: 480
          }, {
            minWidth: 360
          }]
        }
      };
      that = this;
      success = function success(stream) {
        that._remove_message();
        try {
          that.video.srcObject = stream;
        } catch (error) {
          that.video.src = window.URL.createObjectURL(stream);
        }
        that._block_element_access();
        return that._wait_for_video_ready();
      };
      failure = function failure(error) {
        var key;
        // var code = error.code
        that.message.innerHTML = '<span style=\'color: red;\'>' + 'You have denied camera access.' + '</span><br><br>' + 'Look for camera icon around your address bar to change your ' + 'decision.';
        for (key in error) {
          // value = error[key]
          if (key === 'code') {
            continue;
          }
          that._got_error(key);
          return;
        }
        return that._got_error('UNKNOWN ERROR');
      };
      try {
        return navigator.getUserMedia(getUserMediaOptions, success, failure);
      } catch (_error) {
        // var error = _error
        return navigator.getUserMedia('video', success, failure);
      }
    };

    JpegCameraHtml5.prototype._engine_play_shutter_sound = function () {
      var source;
      if (!this.shutter_buffer) {
        return;
      }
      source = this.audio_context.createBufferSource();
      source.buffer = this.shutter_buffer;
      source.connect(this.audio_context.destination);
      return source.start(0);
    };

    JpegCameraHtml5.prototype.stop_stream = function () {
      this.video.pause();
      this.video.src = '';
      this.video.srcObject.getTracks()[0].stop();
      return true;
    };

    JpegCameraHtml5.prototype._engine_capture = function (snapshot, mirror, quality, scale) {
      var canvas, context, crop;
      crop = this._get_capture_crop();
      canvas = document.createElement('canvas');
      canvas.width = Math.round(crop.width * scale);
      canvas.height = Math.round(crop.height * scale);
      context = canvas.getContext('2d');
      context.drawImage(this.video, crop.x_offset, crop.y_offset, crop.width, crop.height, 0, 0, Math.round(crop.width * scale), Math.round(crop.height * scale));
      snapshot._canvas = canvas;
      snapshot._mirror = mirror;
      snapshot._quality = quality;
      return true;
    };

    JpegCameraHtml5.prototype._engine_display = function (snapshot) {
      if (this.displayed_canvas) {
        this.container.removeChild(this.displayed_canvas);
      }
      this.displayed_canvas = snapshot._canvas;
      this.displayed_canvas.style.width = '' + this.view_width + 'px';
      this.displayed_canvas.style.height = '' + this.view_height + 'px';
      this.displayed_canvas.style.top = 0;
      this.displayed_canvas.style.left = 0;
      this.displayed_canvas.style.position = 'absolute';
      this.displayed_canvas.style.zIndex = 2;
      JpegCamera._add_prefixed_style(this.displayed_canvas, 'transform', 'scalex(-1.0)');
      return this.container.appendChild(this.displayed_canvas);
    };

    JpegCameraHtml5.prototype._engine_get_canvas = function (snapshot) {
      var canvas, context;
      canvas = document.createElement('canvas');
      canvas.width = snapshot._canvas.width;
      canvas.height = snapshot._canvas.height;
      context = canvas.getContext('2d');
      context.drawImage(snapshot._canvas, 0, 0);
      return canvas;
    };

    JpegCameraHtml5.prototype._engine_get_image_data = function (snapshot) {
      var canvas, context;
      canvas = snapshot._canvas;
      context = canvas.getContext('2d');
      return context.getImageData(0, 0, canvas.width, canvas.height);
    };

    JpegCameraHtml5.prototype._engine_get_blob = function (snapshot, mime, mirror, quality, callback) {
      var canvas, context;
      // Added by Trevor since those params are not delivered correctly.
      mirror = true;
      quality = 1;
      if (mirror) {
        canvas = document.createElement('canvas');
        canvas.width = snapshot._canvas.width;
        canvas.height = snapshot._canvas.height;
        context = canvas.getContext('2d');
        context.setTransform(1, 0, 0, 1, 0, 0);
        context.translate(canvas.width, 0);
        context.scale(-1, 1);
        context.drawImage(snapshot._canvas, 0, 0);
      } else {
        canvas = snapshot._canvas;
      }
      return canvas.toBlob(function (blob) {
        return callback(blob);
      }, mime, quality);
    };

    JpegCameraHtml5.prototype._engine_discard = function (snapshot) {
      if (snapshot._xhr) {
        snapshot._xhr.abort();
      }
      delete snapshot._xhr;
      return delete snapshot._canvas;
    };

    JpegCameraHtml5.prototype._engine_show_stream = function () {
      if (this.displayed_canvas) {
        this.container.removeChild(this.displayed_canvas);
        this.displayed_canvas = null;
      }
      this.videoContainer.style.display = 'block';
      return true;
    };

    JpegCameraHtml5.prototype._engine_upload = function (snapshot, apiUrl, csrfToken, timeout) {
      this._debug('Uploading the file');
      return snapshot.get_blob(function (blob) {
        var handler, xhr;
        handler = function handler(event) {
          delete snapshot._xhr;
          snapshot._status = event.target.status;
          snapshot._response = event.target.responseText;
          if (snapshot._status >= 200 && snapshot._status < 300) {
            return snapshot._upload_done();
          } else {
            snapshot._error_message = event.target.statusText || 'Unknown error';
            return snapshot._upload_fail();
          }
        };
        xhr = new XMLHttpRequest();
        xhr.open('POST', apiUrl);
        xhr.timeout = timeout;
        if (csrfToken) {
          xhr.setRequestHeader('X-CSRF-Token', csrfToken);
        }
        xhr.onload = handler;
        xhr.onerror = handler;
        xhr.onabort = handler;
        xhr.send(blob);
        snapshot._xhr = xhr;
        return true;
      }, 'image/jpeg');
    };

    JpegCameraHtml5.prototype._remove_message = function () {
      this.message.style.display = 'none';
      return true;
    };

    JpegCameraHtml5.prototype._load_shutter_sound = function (url) {
      var request, that;
      if (this.audio_context) {
        return;
      }
      this.audio_context = new AudioContext();
      request = new XMLHttpRequest();
      request.open('GET', url, true);
      request.responseType = 'arraybuffer';
      that = this;
      request.onload = function () {
        return that.audio_context.decodeAudioData(request.response, function (buffer) {
          that.shutter_buffer = buffer;
          return true;
        });
      };
      return request.send();
    };

    JpegCameraHtml5.prototype._wait_for_video_ready = function () {
      var crop, that, videoHeight, videoWidth;
      videoWidth = parseInt(this.video.videoWidth);
      videoHeight = parseInt(this.video.videoHeight);
      if (videoWidth > 0 && videoHeight > 0) {
        this.videoContainer.appendChild(this.video);
        this.videoWidth = videoWidth;
        this.videoHeight = videoHeight;
        crop = this._get_video_crop();
        this.video.style.position = 'relative';
        this.video.style.width = '' + crop.width + 'px';
        this.video.style.height = '' + crop.height + 'px';
        this.video.style.left = '' + crop.x_offset + 'px';
        this.video.style.top = '' + crop.y_offset + 'px';
        return this._prepared(this.videoWidth, this.videoHeight);
      } else if (this._status_checks_count > 100) {
        return this._got_error('Camera failed to initialize in 10 seconds');
      } else {
        this._status_checks_count++;
        that = this;
        return setTimeout(function () {
          return that._wait_for_video_ready();
        }, 100);
      }
    };

    JpegCameraHtml5.prototype._status_checks_count = 0;

    JpegCameraHtml5.prototype._get_video_crop = function () {
      var scaledVideoHeight, scaledVideoWidth, videoRatio, videoScale, viewRatio;
      videoRatio = this.videoWidth / this.videoHeight;
      viewRatio = this.view_width / this.view_height;
      if (videoRatio >= viewRatio) {
        this._debug('Filling height');
        videoScale = this.view_height / this.videoHeight;
        scaledVideoWidth = Math.round(this.videoWidth * videoScale);
        return {
          width: scaledVideoWidth,
          height: this.view_height,
          x_offset: -Math.floor((scaledVideoWidth - this.view_width) / 2.0),
          y_offset: 0
        };
      } else {
        this._debug('Filling width');
        videoScale = this.view_width / this.videoWidth;
        scaledVideoHeight = Math.round(this.videoHeight * videoScale);
        return {
          width: this.view_width,
          height: scaledVideoHeight,
          x_offset: 0,
          y_offset: -Math.floor((scaledVideoHeight - this.view_height) / 2.0)
        };
      }
    };

    JpegCameraHtml5.prototype._get_capture_crop = function () {
      var snapshotHeight, snapshotWidth, videoRatio, viewRatio;
      videoRatio = this.videoWidth / this.videoHeight;
      viewRatio = this.view_width / this.view_height;
      if (videoRatio >= viewRatio) {
        snapshotWidth = Math.round(this.videoHeight * viewRatio);
        return {
          width: snapshotWidth,
          height: this.videoHeight,
          x_offset: Math.floor((this.videoWidth - snapshotWidth) / 2.0),
          y_offset: 0
        };
      } else {
        snapshotHeight = Math.round(this.videoWidth / viewRatio);
        return {
          width: this.videoWidth,
          height: snapshotHeight,
          x_offset: 0,
          y_offset: Math.floor((this.videoHeight - snapshotHeight) / 2.0)
        };
      }
    };
    return JpegCameraHtml5;
  }(JpegCamera);
  // window.JpegCamera = JpegCameraHtml5
}

Snapshot = function () {
  Snapshot._next_snapshot_id = 1;

  function Snapshot(camera, options) {
    this.camera = camera;
    this.options = options;
    this.id = this.constructor._next_snapshot_id++;
  }

  Snapshot.prototype._discarded = false;

  Snapshot.prototype.show = function () {
    if (this._discarded) {
      window.raise('discarded snapshot cannot be used');
    }
    this.camera._display(this);
    return this;
  };

  Snapshot.prototype.hide = function () {
    if (this.camera.displayed_snapshot() === this) {
      this.camera.show_stream();
    }
    return this;
  };

  Snapshot.prototype.get_stats = function (callback) {
    if (this._discarded) {
      window.raise('discarded snapshot cannot be used');
    }
    return this.get_image_data(function (data) {
      return this._get_stats(data, callback);
    });
  };

  Snapshot.prototype.get_canvas = function (callback) {
    var that;
    if (this._discarded) {
      window.raise('discarded snapshot cannot be used');
    }
    if (!JpegCamera._canvas_supported) {
      return false;
    }
    that = this;
    setTimeout(function () {
      that._extra_canvas || (that._extra_canvas = that.camera._engine_get_canvas(that));
      JpegCamera._add_prefixed_style(that._extra_canvas, 'transform', 'scalex(-1.0)');
      return callback.call(that, that._extra_canvas);
    }, 1);
    return true;
  };

  Snapshot.prototype._extra_canvas = null;

  Snapshot.prototype.get_blob = function (callback, mimeType) {
    var that;
    if (mimeType == null) {
      mimeType = 'image/jpeg';
    }
    if (this._discarded) {
      window.raise('discarded snapshot cannot be used');
    }
    if (!JpegCamera._canvas_supported) {
      return false;
    }
    that = this;
    setTimeout(function () {
      var mirror, quality;
      if (that._blob_mime !== mimeType) {
        that._blob = null;
      }
      that._blob_mime = mimeType;
      if (that._blob) {
        return callback.call(that, that._blob);
      } else {
        mirror = that.options.mirror;
        quality = that.options.quality;
        return that.camera._engine_get_blob(that, mimeType, mirror, quality, function (b) {
          that._blob = b;
          return callback.call(that, that._blob);
        });
      }
    }, 1);
    return true;
  };

  Snapshot.prototype._blob = null;

  Snapshot.prototype._blob_mime = null;

  Snapshot.prototype.get_image_data = function (callback) {
    var that;
    if (this._discarded) {
      window.raise('discarded snapshot cannot be used');
    }
    that = this;
    setTimeout(function () {
      that._image_data || (that._image_data = that.camera._engine_get_image_data(that));
      return callback.call(that, that._image_data);
    }, 1);
    return null;
  };

  Snapshot.prototype._image_data = null;

  Snapshot.prototype.upload = function (options) {
    var cache;
    if (options == null) {
      options = {};
    }
    if (this._discarded) {
      window.raise('discarded snapshot cannot be used');
    }
    if (this._uploading) {
      this.camera._debug('Upload already in progress');
      return;
    }
    this._uploading = true;
    this._retry = 1;
    this._upload_options = options;
    cache = this._options();
    if (!cache.apiUrl) {
      this.camera._debug('Snapshot#upload called without valid apiUrl');
      throw new Error('Snapshot#upload called without valid apiUrl');
    }
    this._start_upload(cache);
    return this;
  };

  Snapshot.prototype._upload_options = {};

  Snapshot.prototype._uploading = false;

  Snapshot.prototype._retry = 1;

  Snapshot.prototype.done = function (callback) {
    var cache;
    if (this._discarded) {
      window.raise('discarded snapshot cannot be used');
    }
    this._upload_options.on_upload_done = callback;
    cache = this._options();
    if (cache.on_upload_done && this._done) {
      cache.on_upload_done.call(this, this._response);
    }
    return this;
  };

  Snapshot.prototype._done = false;

  Snapshot.prototype._response = null;

  Snapshot.prototype.fail = function (callback) {
    var cache;
    if (this._discarded) {
      window.raise('discarded snapshot cannot be used');
    }
    this._upload_options.on_upload_fail = callback;
    cache = this._options();
    if (cache.on_upload_fail && this._fail) {
      cache.on_upload_fail.call(this, this._status, this._error_message, this._response);
    }
    return this;
  };

  Snapshot.prototype._fail = false;

  Snapshot.prototype._status = null;

  Snapshot.prototype._error_message = null;

  Snapshot.prototype.discard = function () {
    this.camera._discard(this);
    delete this._extra_canvas;
    delete this._image_data;
    delete this._blob;
    return void 0;
  };

  Snapshot.prototype._options = function () {
    return this.camera._extend({}, this.camera.options, this.options, this._upload_options);
  };

  Snapshot.prototype._start_upload = function (cache) {
    var csrfToken;
    if (typeof cache.csrfToken === 'string' && cache.csrfToken.length > 0) {
      csrfToken = cache.csrfToken;
    } else {
      csrfToken = null;
    }
    this._done = false;
    this._response = null;
    this._fail = false;
    this._status = null;
    this._error_message = null;
    return this.camera._engine_upload(this, cache.apiUrl, csrfToken, cache.timeout);
  };

  Snapshot.prototype._get_stats = function (data, callback) {
    var gray, grayValues, i, index, mean, n, sum, sumOfSquareDistances, _i, _j, _len;
    if (!this._stats) {
      n = data.width * data.height;
      sum = 0.0;
      grayValues = new Array(n);
      for (i = _i = 0; _i < n; i = _i += 1) {
        index = i * 4;
        gray = 0.2126 * data.data[index + 0] + 0.7152 * data.data[index + 1] + 0.0722 * data.data[index + 2];
        gray = Math.round(gray);
        sum += gray;
        grayValues[i] = gray;
      }
      mean = Math.round(sum / n);
      sumOfSquareDistances = 0;
      for (_j = 0, _len = grayValues.length; _j < _len; _j++) {
        gray = grayValues[_j];
        sumOfSquareDistances += Math.pow(gray - mean, 2);
      }
      this._stats = new Stats();
      this._stats.mean = mean;
      this._stats.std = Math.round(Math.sqrt(sumOfSquareDistances / n));
    }
    return callback.call(this, this._stats);
  };

  Snapshot.prototype._stats = null;

  Snapshot.prototype._upload_done = function () {
    var cache, delay, retryDecision, that;
    this.camera._debug('Upload completed with status ' + this._status);
    this._done = true;
    cache = this._options();
    retryDecision = cache.retrySuccess && cache.retryIf && cache.retryIf.call(this, this._status, this._error_message, this._response, this._retry);
    if (retryDecision === true) {
      retryDecision = 0;
    }
    if (typeof retryDecision === 'number') {
      this._retry++;
      if (retryDecision > 0) {
        delay = parseInt(retryDecision);
        this.camera._debug('Will retry the upload in ' + delay + 'ms (attempt #' + this._retry + ')');
        that = this;
        return setTimeout(function () {
          return that._start_upload(cache);
        }, delay);
      } else {
        this.camera._debug('Will retry the upload immediately (attempt #' + this._retry + ')');
        return this._start_upload(cache);
      }
    } else {
      this._uploading = false;
      if (cache.on_upload_done) {
        return cache.on_upload_done.call(this, this._response);
      }
    }
  };

  Snapshot.prototype._upload_fail = function () {
    var cache, delay, retryDecision, that;
    this.camera._debug('Upload failed with status ' + this._status);
    this._fail = true;
    cache = this._options();
    retryDecision = cache.retryIf && cache.retryIf.call(this, this._status, this._error_message, this._response, this._retry);
    if (retryDecision === true) {
      retryDecision = 0;
    }
    if (typeof retryDecision === 'number') {
      this._retry++;
      if (retryDecision > 0) {
        delay = parseInt(retryDecision);
        this.camera._debug('Will retry the upload in ' + delay + 'ms (attempt #' + this._retry + ')');
        that = this;
        return setTimeout(function () {
          return that._start_upload(cache);
        }, delay);
      } else {
        this.camera._debug('Will retry the upload immediately (attempt #' + this._retry + ')');
        return this._start_upload(cache);
      }
    } else {
      this._uploading = false;
      if (cache.on_upload_fail) {
        return cache.on_upload_fail.call(this, this._status, this._error_message, this._response);
      }
    }
  };

  return Snapshot;
}();

Stats = function () {
  function Stats() {}

  Stats.prototype.mean = null;

  Stats.prototype.std = null;

  return Stats;
}();

module.exports = JpegCameraHtml5;

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);



var ParamPlugin = {
  install: function install(Vue, options) {
    // /////////////////////
    // https://account.chekt.com/login;hl=en;service=email;continue=aHR0cHM6Ly9kZWFsZXIuY2hla3QuY29t;
    // ;hl=en;service=email;continue=aHR0cHM6Ly9kZWFsZXIuY2hla3QuY29t
    // ;access_token=eyJlbWFpbCI6InRyZXZvcnNAY2hla3QuY29tIiwiaXNfcmVzZXRfcGFzc3dvcmQiOnRydWUsImlzX3NpZ25lZHVwIjp0cnVlfQ
    // {
    //   "email": "trevors@chekt.com",
    //   "is_reset_password": true,
    //   "is_signedup": true
    // }
    // ;access_token=eyJlbWFpbCI6InRyZXZvcnNAY2hla3QuY29tIiwicmVxdWVzdCI6ImRlYWxlcl9yZWdpc3RyYXRpb24iLCJpc19yZXNldF9wYXNzd29yZCI6dHJ1ZSwiaXNfc2lnbmVkdXAiOnRydWV9
    // {
    //   "email": "trevors@chekt.com",
    //   "request": "dealer_registration",
    //   "is_reset_password": true,
    //   "is_signedup": true
    // }
    // ;hl=en;service=email;continue=aHR0cHM6Ly9kZWFsZXIuY2hla3QuY29t;access_token=eyJlbWFpbCI6InRyZXZvcnNAY2hla3QuY29tIiwicmVxdWVzdCI6ImRlYWxlcl9yZWdpc3RyYXRpb24iLCJpc19yZXNldF9wYXNzd29yZCI6dHJ1ZSwiaXNfc2lnbmVkdXAiOnRydWV9;
    // /////////////////////
    var param = {
      options: {},
      checkCHeKTParams: function checkCHeKTParams() {
        var _this = this;

        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var pathname = window.location.pathname;
          var itemList = pathname.split(';');
          // there is ';' separated param to be corrected.
          if (itemList.length > 1) {
            var _options = _this.parseNGStyleParamIntoOptions();
            if (_options) {
              pathname = itemList[0] + '?options=' + _options + window.location.search.replace('?', '&');
              window.location.replace(window.location.origin + pathname);
              resolve('Param replaced');
            }
          }
          reject(new Error('No param to replace'));
        });
      },
      parseNGStyleParamIntoOptions: function parseNGStyleParamIntoOptions() {
        // All params
        var params = {};
        var search = window.location.href.split(';').splice(1);
        if (search.length > 0) {
          var queryItems = search;
          queryItems.map(function (queryItem) {
            if (queryItem) {
              var splitedQueryItem = queryItem.split('=');
              params[splitedQueryItem[0]] = null;
              if (splitedQueryItem[1] !== undefined) {
                if (splitedQueryItem[0] === 'continue') {
                  params[splitedQueryItem[0]] = window.atob(decodeURIComponent(splitedQueryItem[1]));
                } else {
                  params[splitedQueryItem[0]] = splitedQueryItem[1];
                }
              }
            }
          });
          // Access Token
          var paramValue = params['access_token'];
          if (paramValue) {
            var request = paramValue;
            var tempObj = JSON.parse(this.decodeFromBase64Url(request));
            params['isSignedUp'] = tempObj['is_signedup'];
            params['email'] = tempObj['email'];
            params['oldEmail'] = tempObj['old_email'];
            // params['isToResetPassword'] = tempObj['is_reset_password'] // TO BE DELETED
            // dealer_registration
            // dealer_member_invitation
            // site_member_invitation
            // email_change
            // email_change_revoke
            params['request'] = tempObj['request'];
          }
          delete params['access_token'];
        }
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(params).length > 0 ? this.encodeToBase64Url(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)) : null;
      },
      encodeToBase64Url: function encodeToBase64Url(str) {
        var base64Str = window.btoa(str);
        var base64Url = base64Str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
        return base64Url;
      },
      decodeFromBase64Url: function decodeFromBase64Url(base64Url) {
        base64Url = decodeURIComponent(base64Url);
        if (base64Url.length % 4 === 2) base64Url = base64Url + '==';
        if (base64Url.length % 4 === 3) base64Url = base64Url + '=';
        var base64Str = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        return window.atob(base64Str);
      },
      getParamValue: function getParamValue(param) {
        var params = {};
        var search = window.location.search;
        if (search) {
          var queryItems = search.split('?')[1].split('&');
          queryItems.map(function (queryItem) {
            var splitedQueryItem = queryItem.split('=');
            params[splitedQueryItem[0]] = null;
            if (splitedQueryItem[1] !== undefined) {
              params[splitedQueryItem[0]] = splitedQueryItem[1];
            }
          });
        }
        return params[param];
      }
    };

    var optionsText = param.getParamValue('options');
    param.options = optionsText ? JSON.parse(window.atob(optionsText)) : {};

    Vue.prototype.$param = param;
    Vue.param = param;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ParamPlugin);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_user__ = __webpack_require__(105);


var TimePlugin = {
  install: function install(Vue, options) {
    var time = {
      newDate: function newDate() {
        if (time.currentDate) {
          return time.currentDate;
        } else {
          return new Date();
        }
      },
      currentDate: null,
      timeOffset: null,
      startCloudClock$i: null
    };

    var updateTimeOffset = function updateTimeOffset(dateString, latency) {
      var computerCurrentDate = new Date();
      try {
        if (dateString) {
          var cloudCurrentDate = new Date(dateString);
          cloudCurrentDate.setTime(cloudCurrentDate.getTime() + latency);
          time.timeOffset = computerCurrentDate.getTime() - cloudCurrentDate.getTime();
          Vue.logger.info('time.js: time.timeOffset: ' + time.timeOffset);
        } else {
          throw new Error('updateDate: dateString: ' + dateString + ': latency: ' + latency);
        }
      } catch (err) {
        Vue.logger.error('getting time from internet failed!');
        Vue.logger.error(err.message);
        time.timeOffset = 0;
      }
    };

    var updateDate = function updateDate() {
      var timeDiffThreshold = 1000 * 1800;
      var computerCurrentDate = new Date();
      try {
        if (time.timeOffset !== null) {
          var cloudCurrentDate = new Date(computerCurrentDate.getTime() - time.timeOffset);
          if (time.currentDate) {
            if (cloudCurrentDate.getTime() - time.currentDate.getTime() > timeDiffThreshold || time.currentDate.getTime() - cloudCurrentDate.getTime() > timeDiffThreshold) {
              Vue.logger.info('time.js: location.reload');
              // 0.5 hour... if time changes like 0.5 hour... reload page...
              // it is important... for everything...
              // 1. event, live time
              // 2. access token expiration... it is critical..
              location.reload();
            }
          }
          time.currentDate = cloudCurrentDate;
        }
      } catch (err) {
        Vue.logger.error('time.js: updateDate failed!');
        Vue.logger.error(err.message);
        time.currentDate = computerCurrentDate;
      }
    };

    var startClock = function startClock(dateString, latency) {
      var clockTick = 1; // second
      var clockTickInterval = 1000 * clockTick; // every 1 second
      updateTimeOffset(dateString, latency);
      updateDate();
      // just in case!
      if (time.startCloudClock$i) {
        clearInterval(time.startCloudClock$i);
        time.startCloudClock$i = null;
      }
      // Start here
      time.startCloudClock$i = setInterval(function () {
        // console.log(time.newDate())
        updateDate();
      }, clockTickInterval);
    };

    var getTimeFromInternet = function getTimeFromInternet() {
      var startTimestamp = new Date().getTime();
      __WEBPACK_IMPORTED_MODULE_0__apis_user__["a" /* default */].pingCloud().then(function (res) {
        var endTimestamp = new Date().getTime();
        var totalLatency = endTimestamp - startTimestamp;
        var dateString = res.headers.get('date');
        startClock(dateString, totalLatency / 2); // Client --> Server --> Client,,, so only need half latency
      }, function (err) {
        var endTimestamp = new Date().getTime();
        var totalLatency = endTimestamp - startTimestamp;
        var dateString = err.headers.get('date');
        startClock(dateString, totalLatency / 2);
      });
    };

    getTimeFromInternet();

    Vue.prototype.$time = time;
    Vue.time = time;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TimePlugin);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var GoogleMapPlugin = {
  install: function install(Vue, options) {
    var googlemap = {
      isLoaded: null,
      google: null,
      loadScript: null
    };

    var scriptPath = 'https://maps.googleapis.com/maps/api/js?language=en&libraries=places';
    var apiKey = Vue.env.googleMapAPIKey;
    scriptPath += '&key=' + apiKey;
    scriptPath += '&channel=3';

    var script = document.createElement('script');
    script.src = scriptPath;

    googlemap.loadScript = function (callback) {
      if (googlemap.isLoaded === null) {
        googlemap.isLoaded = false;
        script.onload = function () {
          googlemap.isLoaded = true;
          googlemap.google = window.google;
          callback(new Error(true));
        };
        script.onerror = function () {
          googlemap.isLoaded = false;
          callback(new Error(false));
          console.error('Error loading: ' + this.src);
        };
        document.head.appendChild(script);
      }
    };

    Vue.prototype.$googlemap = googlemap;
    Vue.googlemap = googlemap;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GoogleMapPlugin);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TagManagerPlugin = {
  install: function install(Vue, options) {
    var tagManager = {
      appendTags: null,
      tagList: [{
        desc: 'Pingdom Visitor Insights',
        src: '//rum-static.pingdom.net/pa-5bff7efacea07b0016000595.js',
        isLoaded: null
      }]
    };
    tagManager.appendTags = function () {
      tagManager.tagList.map(function (tagInfo) {
        if (tagInfo.isLoaded === null) {
          var script = document.createElement('script');
          script.src = tagInfo.src;
          tagInfo.isLoaded = false;
          script.onload = function () {
            tagInfo.isLoaded = true;
            console.log('Loaded tag: ' + tagInfo.desc);
          };
          script.onerror = function () {
            tagInfo.isLoaded = false;
            console.error('Error loading: ' + tagInfo.src);
          };
          document.body.appendChild(script);
        }
      });
    };
    Vue.prototype.$tagManager = tagManager;
    Vue.tagManager = tagManager;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TagManagerPlugin);

/***/ })
],[108]);


// WEBPACK FOOTER //
// static/js/app.246b2254e3e6bd369723.js